// This file is auto-generated by @hey-api/openapi-ts

export const $AccessTypeDto = {
  enum: ['Read', 'Write', 'Owner'],
  type: 'string',
  description: 'Kind of access the account has',
} as const;

export const $AccountLinkOverviewDto = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AccountLinkOverviewRecordDto',
      },
      description: '',
    },
  },
  additionalProperties: false,
  description: 'Contains the overview of all linked accounts to this account',
} as const;

export const $AccountLinkOverviewLinkTypeDto = {
  enum: ['Read', 'Write', 'Owner'],
  type: 'string',
  description: 'Type of link established',
} as const;

export const $AccountLinkOverviewLoginDetailsDto = {
  required: ['displayName', 'itsmeLogin', 'localLogin', 'loginUsername'],
  type: 'object',
  properties: {
    displayName: {
      type: 'string',
      description: 'The display name the referenced user uses in the UI',
    },
    loginUsername: {
      type: 'string',
      description: 'The username of the referenced user (email)',
    },
    localLogin: {
      type: 'boolean',
      description: 'Whether the referenced user has local login credentials (username/password)',
    },
    itsmeLogin: {
      type: 'boolean',
      description: 'Whether the referenced user has ItsMe federated login credentials (ItsMe IDP)',
    },
  },
  additionalProperties: false,
  description: 'Body containing information regarding the login credentials for a given user account',
} as const;

export const $AccountLinkOverviewRecordDto = {
  required: ['id', 'identityAlias', 'inviteeEmail', 'type'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Id of the account link or invite',
    },
    identityAlias: {
      type: 'string',
      description: '',
    },
    inviteeEmail: {
      type: 'string',
      description: '',
    },
    loginDetails: {
      $ref: '#/components/schemas/AccountLinkOverviewLoginDetailsDto',
    },
    type: {
      $ref: '#/components/schemas/AccountLinkOverviewLinkTypeDto',
    },
    linkingRequest: {
      $ref: '#/components/schemas/AccountLinkOverviewRecordLinkingRequestDto',
    },
  },
  additionalProperties: false,
  description: 'Body containing a single linked account record',
} as const;

export const $AccountLinkOverviewRecordLinkingRequestDto = {
  required: ['createdAt', 'inviteReference', 'status'],
  type: 'object',
  properties: {
    inviteReference: {
      type: 'string',
      description: '',
      format: 'uuid',
    },
    status: {
      type: 'string',
      description: '',
    },
    createdAt: {
      type: 'string',
      description: '',
      format: 'date-time',
    },
    lastMailSentAt: {
      type: 'string',
      description: '',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains link request details',
} as const;

export const $AccountLinkingTypeDto = {
  enum: ['Read', 'Write'],
  type: 'string',
  description: 'Defines the access control of the linking',
} as const;

export const $AccountMergeAttemptLanguageDto = {
  enum: ['Dutch', 'French'],
  type: 'string',
  description: 'Language throughout the merge process',
} as const;

export const $AccountMergeCheckResponse = {
  required: ['email', 'mergeType', 'sessionId', 'state'],
  type: 'object',
  properties: {
    sessionId: {
      type: 'string',
      description: 'The session ID',
    },
    email: {
      type: 'string',
      description: 'The email address',
    },
    mergeType: {
      $ref: '#/components/schemas/AccountMergeType',
    },
    state: {
      $ref: '#/components/schemas/AccountMergeState',
    },
  },
  additionalProperties: false,
  description: 'Response for checking if merge sessions are possible',
} as const;

export const $AccountMergeState = {
  enum: ['NotPossible', 'Possible', 'Merged'],
  type: 'string',
  description: 'Account merge state',
} as const;

export const $AccountMergeType = {
  enum: ['ExistingCrmAccount', 'Itsme'],
  type: 'string',
  description: 'The type of the account merge',
} as const;

export const $ActiveProductDetailsResponse = {
  required: ['energyType', 'productName', 'status'],
  type: 'object',
  properties: {
    productName: {
      type: 'string',
      description: 'Name of the product',
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    status: {
      $ref: '#/components/schemas/ContractProductStatusDto',
    },
  },
  additionalProperties: false,
  description: 'Details of an active product',
} as const;

export const $ActiveProductsCardResponse = {
  required: ['activeProducts'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    activeProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ActiveProductDetailsResponse',
      },
      description: 'List of active product details',
    },
  },
  additionalProperties: false,
  description: 'Response model for active products card in next best action flow',
} as const;

export const $AddMeterReadingRequest = {
  required: [
    'accountNumber',
    'direction',
    'ean',
    'meterTimeFrameType',
    'readingValue',
    'registeredDate',
    'utilityType',
  ],
  type: 'object',
  properties: {
    accountNumber: {
      type: 'string',
      description: 'Number of the account',
    },
    readingValue: {
      type: 'integer',
      description: 'Value of the meter reading',
      format: 'int32',
    },
    ean: {
      type: 'string',
      description: 'Ean for which the reading will be added',
    },
    meterTimeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    registeredDate: {
      type: 'string',
      description: 'Date until vacancy has been requested. Should be the last day of one of the four next months',
      format: 'date',
    },
    utilityType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    direction: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
  },
  additionalProperties: false,
  description: 'Add meter reading',
} as const;

export const $Address = {
  type: 'object',
  properties: {
    countryCode: {
      type: 'string',
      description: 'The countryCode property',
      nullable: true,
    },
    city: {
      type: 'string',
      description: 'The city property',
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'The email property',
      nullable: true,
    },
    firstName: {
      type: 'string',
      description: 'The firstName property',
      nullable: true,
    },
    lastName: {
      type: 'string',
      description: 'The lastName property',
      nullable: true,
    },
    line1: {
      type: 'string',
      description: 'The line1 property',
      nullable: true,
    },
    line2: {
      type: 'string',
      description: 'The line2 property',
      nullable: true,
    },
    line3: {
      type: 'string',
      description: 'The line3 property',
      nullable: true,
    },
    postalCode: {
      type: 'string',
      description: 'The postalCode property',
      nullable: true,
    },
    state: {
      type: 'string',
      description: 'The state property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Address response',
} as const;

export const $AddressDetailsDto = {
  required: ['houseNumber', 'municipality', 'postalCode', 'street'],
  type: 'object',
  properties: {
    street: {
      type: 'string',
      description: 'The name of the street where the address is located',
    },
    houseNumber: {
      type: 'string',
      description: 'The number of the house or building on the street',
    },
    bus: {
      type: 'string',
      description: 'Optional bus or additional unit information',
      nullable: true,
    },
    postalCode: {
      type: 'string',
      description: 'The postal code of the address',
    },
    municipality: {
      type: 'string',
      description: 'The municipality or city where the address is located',
    },
  },
  additionalProperties: false,
  description: 'Response containing address information in detail',
} as const;

export const $AddressRegionDto = {
  enum: ['Flanders', 'Walloon', 'Brussels', 'Unknown'],
  type: 'string',
  description: 'Represents a region within an address context',
} as const;

export const $AdvanceAmountChangedCardDetailsResponse = {
  required: ['advances'],
  type: 'object',
  properties: {
    advances: {
      $ref: '#/components/schemas/AdvanceAmountCollectionResponse',
    },
  },
  additionalProperties: false,
  description: 'Represents the details for the current advance amount compared to the recommended advance amount card.',
} as const;

export const $AdvanceAmountChangedCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/AdvanceAmountChangedCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for advance amount changed card',
} as const;

export const $AdvanceAmountCollectionResponse = {
  required: ['advancePayments', 'totals'],
  type: 'object',
  properties: {
    advancePayments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/AdvanceAmountDto',
      },
      description: 'Collection of advance payment records',
    },
    totals: {
      $ref: '#/components/schemas/AdvanceAmountTotalsDto',
    },
  },
  additionalProperties: false,
  description: 'Collection of advance payment records',
} as const;

export const $AdvanceAmountDto = {
  type: 'object',
  properties: {
    contractDetails: {
      $ref: '#/components/schemas/AdvanceContractDto',
    },
    meterDetails: {
      $ref: '#/components/schemas/AdvanceMeterDto',
    },
    details: {
      $ref: '#/components/schemas/AdvanceDetailsDto',
    },
  },
  additionalProperties: false,
  description: 'Details of an advance payment',
} as const;

export const $AdvanceAmountTotalsDto = {
  type: 'object',
  properties: {
    currentAmount: {
      type: 'number',
      description: 'Total current amount',
      format: 'decimal',
      nullable: true,
    },
    minAmount: {
      type: 'integer',
      description: 'Total minimum amount',
      format: 'int32',
      nullable: true,
    },
    maxAmount: {
      type: 'integer',
      description: 'Total maximum amount',
      format: 'int32',
      nullable: true,
    },
    recommendedAmount: {
      type: 'number',
      description: 'Total recommended amount',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description:
    'Recommendation numbers for when a customer tries to change the total across multiple contracts and billing accounts',
} as const;

export const $AdvanceContractDto = {
  required: ['contractNumber', 'contractStartDate'],
  type: 'object',
  properties: {
    contractNumber: {
      type: 'string',
      description: 'Identifier of the contract',
    },
    contractStartDate: {
      type: 'string',
      description: 'Contract start date',
      format: 'date',
    },
    contractExpiryDate: {
      type: 'string',
      description: 'Contract expiry date',
      format: 'date',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Details of the contract related to the advance payment',
} as const;

export const $AdvanceDetailsDto = {
  required: ['changeRequested', 'isDefaulter', 'notAvailable', 'vacancyChangeRequested'],
  type: 'object',
  properties: {
    currentAmount: {
      type: 'number',
      description: 'Current amount',
      format: 'decimal',
      nullable: true,
    },
    minAmount: {
      type: 'integer',
      description: 'Minimum amount allowed',
      format: 'int32',
      nullable: true,
    },
    maxAmount: {
      type: 'integer',
      description: 'Maximum amount allowed',
      format: 'int32',
      nullable: true,
    },
    recommendedAmount: {
      type: 'number',
      description: 'The recommended amount',
      format: 'decimal',
      nullable: true,
    },
    recommendedAmountError: {
      $ref: '#/components/schemas/RecommendedAmountResponseError',
    },
    isDefaulter: {
      type: 'boolean',
      description: 'Is defaulter',
    },
    notAvailable: {
      type: 'boolean',
      description: 'Not available',
    },
    changeRequested: {
      type: 'boolean',
      description: '',
    },
    vacancyAmount: {
      type: 'number',
      description: 'Vacancy amount',
      format: 'decimal',
      nullable: true,
    },
    vacancyUntil: {
      type: 'string',
      description: 'Vacancy date until',
      format: 'date',
      nullable: true,
    },
    vacancyChangeRequested: {
      type: 'boolean',
      description: 'Whether a vacancy request is ongoing',
    },
    monthsUntilMeterReadingMonth: {
      type: 'integer',
      description: 'Amount of months until meter reading month',
      format: 'int32',
      nullable: true,
    },
    amountDueForMeterReadingMonth: {
      type: 'number',
      description: 'Amount due for meter reading month',
      format: 'decimal',
      nullable: true,
    },
    lastChangedOn: {
      type: 'string',
      description: 'WHen the advance was last changed',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Details of as',
} as const;

export const $AdvanceMeterDto = {
  required: ['ean', 'energyType', 'invoiceFrequency', 'isBudgetMeter', 'meterType', 'serviceComponent'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'EAN of the meter',
    },
    meterType: {
      $ref: '#/components/schemas/MeterType',
    },
    isBudgetMeter: {
      type: 'boolean',
      description: 'Is budget meter',
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    serviceComponent: {
      $ref: '#/components/schemas/MeterService',
    },
    invoiceFrequency: {
      $ref: '#/components/schemas/InvoiceFrequency',
    },
    meterReadingMonth: {
      type: 'integer',
      description: 'Month in which the meter gets read',
      format: 'int32',
      nullable: true,
    },
    yearlyBillMonth: {
      type: 'integer',
      description: 'Month in which the yearly bill occurs',
      format: 'int32',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Details of the meter related to the advance payment',
} as const;

export const $AnticipationAnnouncementCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Anticipation Announcement card',
} as const;

export const $AssetTypeDto = {
  enum: ['Vehicle'],
  type: 'string',
  description: 'Asset type',
} as const;

export const $AvailableMeterRegistersResponse = {
  required: ['ean', 'energyType', 'hasInjection', 'meterNumber', 'meterRegime', 'meterType', 'registers'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'Ean of the meter.',
    },
    meterNumber: {
      type: 'string',
      description: 'Number of the meter.',
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    meterType: {
      $ref: '#/components/schemas/MeterType',
    },
    meterRegime: {
      $ref: '#/components/schemas/MeterRegime',
    },
    hasInjection: {
      type: 'boolean',
      description: 'Whether injection readings can be submitted.',
    },
    registers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeterRegisterDto',
      },
      description: 'The registers (timeframe / direction combinations) that can be submitted.',
    },
  },
  additionalProperties: false,
  description: 'Describes which registers a meter reading can be submitted for, for a given account and EAN.',
} as const;

export const $AvailableProductsInfoResponse = {
  type: 'object',
  properties: {
    campaign: {
      type: 'string',
      description: 'The campaign property',
      nullable: true,
    },
    couponCode: {
      type: 'string',
      description: 'The couponCode property',
      nullable: true,
    },
    currencyCode: {
      type: 'string',
      description: 'The currencyCode property',
      nullable: true,
    },
    customerInfo: {
      $ref: '#/components/schemas/OrderCustomerInfo',
    },
    errorDetails: {
      $ref: '#/components/schemas/EnecoErrorDetails',
    },
    locale: {
      type: 'string',
      description: 'The locale property',
      nullable: true,
    },
    products: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoProduct',
      },
      description: 'The products property',
      nullable: true,
    },
    productType: {
      type: 'string',
      description: 'The productType property',
      nullable: true,
    },
    success: {
      type: 'boolean',
      description: 'The success property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Available products response.',
} as const;

export const $BillInsertDto = {
  required: ['reasonCode'],
  type: 'object',
  properties: {
    reasonCode: {
      type: 'string',
      description: 'Reason code',
    },
  },
  additionalProperties: false,
  description: 'Bill insert with reason',
} as const;

export const $BillingAccountPaymentPlanEligibilityDto = {
  required: ['billingAccountNumber', 'isEligible'],
  type: 'object',
  properties: {
    billingAccountNumber: {
      type: 'string',
      description: 'Billing account number',
    },
    isEligible: {
      type: 'boolean',
      description: 'Whether the billing account is eligible',
    },
    conditions: {
      $ref: '#/components/schemas/PaymentPlanEligibilityConditions',
    },
  },
  additionalProperties: false,
  description: 'Eligibility information for a single billing account',
} as const;

export const $BillingAccountRelatedMeterResponse = {
  required: ['ean', 'energyType'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'EAN of the meter',
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Meters associated with a billing account',
} as const;

export const $BoilerBrandDto = {
  enum: [
    'ACV',
    'Alliance',
    'Ariston',
    'Atag',
    'Atlantic',
    'Bosch',
    'Buderus',
    'Bulex',
    'Chaffoteaux',
    'Chappee',
    'Daalderop',
    'De_Dietrich',
    'Elco',
    'ELM_Leblanc',
    'Ferroli',
    'Franco_Belge',
    'Frisquet',
    'Geminox',
    'Ideal_Standard',
    'Immergas',
    'Junkers',
    'Oertli',
    'Other',
    'Remeha',
    'Riello',
    'Saint_Roch',
    'Saunier_Duval',
    'Sime',
    'Styx',
    'Vaillant',
    'Viessmann',
    'Weishaupt',
    'Wolf',
    'Unknown',
  ],
  type: 'string',
  description: 'Boiler brand',
} as const;

export const $BrandBenefitsCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Brand Benefits card',
} as const;

export const $BudgetMeterNotificationCardDetailsResponse = {
  required: ['advances'],
  type: 'object',
  properties: {
    advances: {
      $ref: '#/components/schemas/AdvanceAmountCollectionResponse',
    },
  },
  additionalProperties: false,
  description: 'Represents the details for the budget meter notification card.',
} as const;

export const $BudgetMeterNotificationCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/BudgetMeterNotificationCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for budget meter notification card',
} as const;

export const $CalculateMeterDeviationResponse = {
  required: ['details', 'summaryDelta'],
  type: 'object',
  properties: {
    summaryDelta: {
      $ref: '#/components/schemas/RectificationDeltaDto',
    },
    details: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RectificationDeltaResultResponse',
      },
      description: 'Delta per contested values',
    },
  },
  additionalProperties: false,
  description: 'The calculate meter deviation response class',
} as const;

export const $ChargebeeStatus = {
  enum: [0, 1, 2],
  type: 'integer',
  description: 'Chargebee Status',
  format: 'int32',
} as const;

export const $ChildAccountLinkingInviteRequest = {
  required: ['email', 'linkingType'],
  type: 'object',
  properties: {
    alias: {
      type: 'string',
      description: 'Alias of the invitee',
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'Email of the invitee',
    },
    linkingType: {
      $ref: '#/components/schemas/AccountLinkingTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Request that contains the child account linking invite details',
} as const;

export const $ChildAccountLinkingRequest = {
  required: ['alias', 'sessionToken'],
  type: 'object',
  properties: {
    sessionToken: {
      type: 'string',
      description: 'Session token',
    },
    alias: {
      type: 'string',
      description: 'Alias the user selected',
    },
  },
  additionalProperties: false,
  description: 'Body containing details link a child account',
} as const;

export const $ComfortBonusCardDetailsResponse = {
  required: ['comfortBonusLevel'],
  type: 'object',
  properties: {
    comfortBonusLevel: {
      $ref: '#/components/schemas/ComfortBonusLevelDto',
    },
  },
  additionalProperties: false,
  description: 'Response containing details for the comfort bonus card.',
} as const;

export const $ComfortBonusCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/ComfortBonusCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for comfort bonus card',
} as const;

export const $ComfortBonusLevelDto = {
  enum: ['LEVEL0', 'LEVEL1', 'LEVEL2'],
  type: 'string',
  description: "Comfort bonus level based on the 'customer's lifetime'",
} as const;

export const $CompanyDataDto = {
  required: ['companyNumber', 'formatType', 'name', 'vatType'],
  type: 'object',
  properties: {
    name: {
      type: 'string',
      description: 'Name of the company',
    },
    formatType: {
      $ref: '#/components/schemas/CompanyFormatTypeDto',
    },
    vatType: {
      $ref: '#/components/schemas/CompanyVatTypeDto',
    },
    companyNumber: {
      type: 'string',
      description: 'Company number',
    },
  },
  additionalProperties: false,
  description: 'Company data for a crm account',
} as const;

export const $CompanyFormatTypeDto = {
  enum: [
    'None',
    'BV',
    'CV',
    'CommV',
    'Eenmanszaak',
    'FV',
    'Tijdelijke_Maatschap',
    'VOF',
    'VZW',
    'NV',
    'Maatschap',
    'ASBL',
    'Entreprise_Individuelle',
    'SC',
    'SA',
    'SCOMM',
    'SNC',
    'Societe_Simple',
    'SRL',
    'ACP',
    'VME',
    'ADF',
    'SSM',
  ],
  type: 'string',
  description: 'Format of the company',
} as const;

export const $CompanyVatTypeDto = {
  enum: ['None', 'VatRequired', 'VatNotRequired', 'CompanyNumberRequested'],
  type: 'string',
  description: 'VAT type of the company',
} as const;

export const $CompleteMoveFileCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for complete move file card',
} as const;

export const $CompletedProgressTimelineCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Completed Progress Timeline card',
} as const;

export const $ConfigureItsMeCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for ItsMe configuration card',
} as const;

export const $ConsumptionData = {
  required: [
    'basedOn',
    'direction',
    'energyType',
    'isValidated',
    'meterTimeFrameType',
    'reason',
    'unitOfMeasure',
    'value',
  ],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    direction: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
    meterTimeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    reason: {
      $ref: '#/components/schemas/ReasonDto',
    },
    basedOn: {
      $ref: '#/components/schemas/MeterReadingType',
    },
    value: {
      type: 'number',
      description: 'Value of the consumption data',
      format: 'decimal',
    },
    unitOfMeasure: {
      $ref: '#/components/schemas/UnitOfMeasureDto',
    },
    isValidated: {
      type: 'boolean',
      description: 'Is the meter reading validated',
    },
  },
  additionalProperties: false,
  description: 'The consumption data for a specific period',
} as const;

export const $ConsumptionPeriod = {
  required: ['data', 'endDate', 'startDate'],
  type: 'object',
  properties: {
    startDate: {
      type: 'string',
      description: 'The start date of the period',
      format: 'date-time',
    },
    endDate: {
      type: 'string',
      description: 'The end date of the period',
      format: 'date-time',
    },
    data: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ConsumptionData',
      },
      description: 'The consumption data for this period',
    },
  },
  additionalProperties: false,
  description: 'The period for which the data gets fetched',
} as const;

export const $ConsumptionResponse = {
  required: ['consumptionType', 'displayMode', 'endDate', 'periods', 'startDate', 'timeFrame'],
  type: 'object',
  properties: {
    consumptionType: {
      $ref: '#/components/schemas/ConsumptionTypeDto',
    },
    timeFrame: {
      $ref: '#/components/schemas/TimeFrameDto',
    },
    displayMode: {
      $ref: '#/components/schemas/DisplayModeDto',
    },
    startDate: {
      type: 'string',
      description: 'The start date of the current view period',
      format: 'date-time',
    },
    endDate: {
      type: 'string',
      description: 'The end date of the current view period',
      format: 'date-time',
    },
    periods: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ConsumptionPeriod',
      },
      description: 'The periods for which consumption data is available',
    },
  },
  additionalProperties: false,
  description: 'The response for the consumption data',
} as const;

export const $ConsumptionTypeDto = {
  enum: ['Total', 'Electricity', 'Gas', 'Injection', 'PeakValues'],
  type: 'string',
  description: 'Represents the type of consumption data to be retrieved.',
} as const;

export const $ContactAddressDto = {
  required: ['country', 'houseNumber', 'municipality', 'street', 'zipCode'],
  type: 'object',
  properties: {
    street: {
      type: 'string',
      description: 'Street of the address',
    },
    zipCode: {
      type: 'string',
      description: 'Zip code of the address',
    },
    municipality: {
      type: 'string',
      description: 'Municipality of the address',
    },
    houseNumber: {
      type: 'string',
      description: 'House number of the address',
    },
    bus: {
      type: 'string',
      description: 'Bus of the address',
      nullable: true,
    },
    country: {
      type: 'string',
      description: 'Country of the address',
    },
  },
  additionalProperties: false,
  description: 'Representation of the customers contact address',
} as const;

export const $ContactFormAttachmentDto = {
  required: ['fileExtension', 'fileName', 'fileUploadOperationId'],
  type: 'object',
  properties: {
    fileUploadOperationId: {
      type: 'string',
      description: 'Operation id for the upload process',
    },
    fileName: {
      type: 'string',
      description: `The name of the file as stored in the archive, excluding file extension, providing a
human-readable reference.`,
    },
    fileExtension: {
      type: 'string',
      description: 'The extension of the file, indicating its format and type, such as .pdf, .docx, etc.',
    },
  },
  additionalProperties: false,
  description: 'Represents the metadata and identification details for a file archived in the system.',
} as const;

export const $ContactFormDto = {
  type: 'object',
  properties: {
    attachments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ContactFormAttachmentDto',
      },
      description: `A list of attachments related to the contact case, typically representing documents or files
provided by the contact.`,
      nullable: true,
    },
    box: {
      type: 'string',
      description: 'The post office box number where the contact prefers to receive mail.',
      nullable: true,
    },
    city: {
      type: 'string',
      description: 'The city of residence or work associated with the contact.',
      nullable: true,
    },
    company: {
      type: 'boolean',
      description: `Indicates if the contact information pertains to a company or organization rather than an
individual.`,
      nullable: true,
    },
    companyName: {
      type: 'string',
      description: 'The name of the company or organization the contact is associated with.',
      nullable: true,
    },
    companyNumber: {
      type: 'string',
      description: 'The registration or identification number for the company associated with the contact.',
      nullable: true,
    },
    customerNumber: {
      type: 'string',
      description: `A unique identifier or reference number assigned to the contact in the context of customer
relationships or services.`,
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'The email address used by the contact for electronic communication.',
      nullable: true,
    },
    firstName: {
      type: 'string',
      description: 'The first name or given name of the contact.',
      nullable: true,
    },
    gender: {
      $ref: '#/components/schemas/GenderFormContactDto',
    },
    language: {
      $ref: '#/components/schemas/ContactFormLanguageDto',
    },
    lastName: {
      type: 'string',
      description: 'The last name or family name of the contact.',
      nullable: true,
    },
    question: {
      type: 'string',
      description: `A specific question or query posed by the contact, typically related to the subject or context
of communication.`,
      nullable: true,
    },
    street: {
      type: 'string',
      description: 'The street address where the contact resides or works.',
      nullable: true,
    },
    streetNumber: {
      type: 'string',
      description: 'The number associated with the street address of the contact.',
      nullable: true,
    },
    subject: {
      type: 'string',
      description: 'The subject or main topic of communication or inquiry from the contact.',
      nullable: true,
    },
    subLevelSubject: {
      type: 'string',
      description: `Additional subject details or subcategories related to the main subject of inquiry from
the contact.`,
      nullable: true,
    },
    telephone: {
      type: 'string',
      description: 'The telephone number used by the contact for voice communication.',
      nullable: true,
    },
    zipCode: {
      type: 'string',
      description: "The postal code or zip code corresponding to the contact's location.",
      nullable: true,
    },
    recaptchaToken: {
      type: 'string',
      description: 'Token for reCaptcha validation.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: `Represents a contact's personal and professional information, including address details, communication preferences,
and identification numbers.`,
} as const;

export const $ContactFormLanguageDto = {
  enum: ['DUTCH', 'FRENCH'],
  type: 'string',
  description: 'Kinds of language',
} as const;

export const $ContestedValue = {
  required: ['contestedDate', 'contestedIndex'],
  type: 'object',
  properties: {
    contestedDate: {
      type: 'string',
      description: 'Date entered by the user',
      format: 'date',
    },
    contestedIndex: {
      type: 'integer',
      description: 'Index entered by the user',
      format: 'int32',
    },
  },
  additionalProperties: false,
  description: 'Contested values entered by user',
} as const;

export const $ContractProductStatusDto = {
  enum: [
    'None',
    'WaitingForApproval',
    'InProgress',
    'WaitingForDelivery',
    'Active',
    'RequestedTermination',
    'Terminated',
    'Cancelled',
    'CancelRequested',
  ],
  type: 'string',
  description: 'Status that a contract can be in',
} as const;

export const $ContractProductSwitchResponse = {
  required: ['hasProductSwitchOptions', 'status'],
  type: 'object',
  properties: {
    hasProductSwitchOptions: {
      type: 'boolean',
      description: 'Indicates if there are switch options available for the product',
    },
    status: {
      $ref: '#/components/schemas/ProductSwitchStatusResponse',
    },
    tariffCardByLanguage: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TariffCardByLanguage',
      },
      description: 'Tariff card information by language',
      nullable: true,
    },
    startDate: {
      type: 'string',
      description: 'Start date of the product switch',
      format: 'date-time',
      nullable: true,
    },
    fixedDurationEndDate: {
      type: 'string',
      description: 'End date if product has fixed end date',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Response containing ProductSwitchStatus information',
} as const;

export const $ContractStatusDto = {
  enum: [
    'None',
    'AwaitingApproval',
    'InProgress',
    'AwaitingDelivery',
    'Active',
    'TerminationRequested',
    'Terminated',
    'Cancelled',
    'CancelRequested',
  ],
  type: 'string',
  description: 'Contract status',
} as const;

export const $CorrespondenceAddressDto = {
  required: ['country', 'houseNumber', 'municipality', 'postalCode', 'street'],
  type: 'object',
  properties: {
    country: {
      type: 'string',
      description: 'Country of the address',
    },
    postalCode: {
      type: 'string',
      description: 'Postal code of the address',
    },
    municipality: {
      type: 'string',
      description: 'Municipality of the address',
    },
    street: {
      type: 'string',
      description: 'Street of the address',
    },
    houseNumber: {
      type: 'string',
      description: 'House number of the address',
    },
    bus: {
      type: 'string',
      description: 'Bus of the address',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Move address',
} as const;

export const $CostCategoryTypeDto = {
  enum: [
    'EnergyCost',
    'NetTariffCost',
    'TaxationCost',
    'NonConditionalPromo',
    'Total',
    'ExtraCosts',
    'FixedFee',
    'Usage',
    'Offtake',
    'ProsumerCost',
    'DataManagement',
    'Captar',
    'Injection',
    'TotalCostWithNonConditionalPromo',
    'TotalCostWithConditionalPromo',
    'ConditionalPromo',
  ],
  type: 'string',
  description: 'Represents the different types of cost categories used in price simulation.',
} as const;

export const $CostDto = {
  required: ['costCategoryType', 'detailedCosts', 'value'],
  type: 'object',
  properties: {
    costCategoryType: {
      $ref: '#/components/schemas/CostCategoryTypeDto',
    },
    value: {
      type: 'number',
      description: 'The monetary value of this cost.',
      format: 'decimal',
    },
    detailedCosts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DetailedCostDto',
      },
      description: 'The detailed breakdown of this cost category.',
    },
  },
  additionalProperties: false,
  description: 'Represents a cost category with its type, value and detailed cost breakdown.',
} as const;

export const $CreateAssetRequestDto = {
  required: ['assetType'],
  type: 'object',
  properties: {
    assetType: {
      $ref: '#/components/schemas/AssetTypeDto',
    },
    externalAssetId: {
      type: 'string',
      description: 'Identifier in external system',
      nullable: true,
    },
    vehicle: {
      $ref: '#/components/schemas/VehicleAssetResourceDto',
    },
  },
  additionalProperties: false,
  description: 'Create a new asset',
} as const;

export const $CreatePaymentPlanRequest = {
  required: ['amountOfSlices'],
  type: 'object',
  properties: {
    amountOfSlices: {
      type: 'integer',
      description: 'Amount of slices the user wants to pay in',
      format: 'int32',
    },
  },
  additionalProperties: false,
  description: 'Request to create a new payment plan',
} as const;

export const $CreateSubscriptionRequestDto = {
  required: ['consentVersion', 'startDate', 'tier', 'type'],
  type: 'object',
  properties: {
    type: {
      $ref: '#/components/schemas/SubscriptionTypeDto',
    },
    tier: {
      $ref: '#/components/schemas/SubscriptionTierDto',
    },
    startDate: {
      type: 'string',
      description: 'Subscription start date',
      format: 'date-time',
    },
    endDate: {
      type: 'string',
      description: 'Optional subscription end date',
      format: 'date-time',
      nullable: true,
    },
    consentVersion: {
      minLength: 1,
      type: 'string',
      description: 'Consent version',
    },
  },
  additionalProperties: false,
  description: 'Create subscription',
} as const;

export const $CrmAccountClaimDto = {
  required: ['accessType', 'alias', 'crmAccountNumber'],
  type: 'object',
  properties: {
    crmAccountNumber: {
      type: 'string',
      description: 'Account number of the account',
    },
    alias: {
      type: 'string',
      description: 'Alias of the account',
    },
    accessType: {
      $ref: '#/components/schemas/AccessTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Contains an account claim entry',
} as const;

export const $CsatRequest = {
  type: 'object',
  properties: {
    csatFeedback: {
      type: 'string',
      description: 'The CSAT feedback.',
      nullable: true,
    },
    csatScore: {
      type: 'integer',
      description: 'The CSAT score.',
      format: 'int32',
      nullable: true,
    },
    date: {
      type: 'string',
      description: 'The date.',
      nullable: true,
    },
    intentValue: {
      type: 'string',
      description: 'The intent value.',
      nullable: true,
    },
    language: {
      type: 'string',
      description: 'The language.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The CSAT request.',
} as const;

export const $CsvLanguage = {
  enum: ['Dutch', 'French'],
  type: 'string',
  description: 'Language in which the csv should be',
} as const;

export const $CurrentAdvanceAmountVsRecommendedAdvanceAmountCardDetails = {
  required: ['advances'],
  type: 'object',
  properties: {
    advances: {
      $ref: '#/components/schemas/AdvanceAmountCollectionResponse',
    },
  },
  additionalProperties: false,
  description: 'Represents the details for the current advance amount compared to the recommended advance amount card.',
} as const;

export const $CurrentAdvanceAmountVsRecommendedAdvanceAmountCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/CurrentAdvanceAmountVsRecommendedAdvanceAmountCardDetails',
    },
  },
  additionalProperties: false,
  description: 'Response for current advance amount vs recommended advance amount card',
} as const;

export const $CustomerInfoResponse = {
  type: 'object',
  properties: {
    enecoId: {
      type: 'string',
      description: 'Customer id',
      nullable: true,
    },
    chargebeeStatus: {
      $ref: '#/components/schemas/ChargebeeStatus',
    },
    customerPaymentStatus: {
      $ref: '#/components/schemas/CustomerPaymentStatus',
    },
    totalAmountDue: {
      type: 'number',
      description: 'Total amount due',
      format: 'double',
      nullable: true,
    },
    customer: {
      $ref: '#/components/schemas/OrderCustomer',
    },
    dongle: {
      $ref: '#/components/schemas/DongleInfo',
    },
    invoices: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/InvoiceInfo',
      },
      description: 'Invoice info',
      nullable: true,
    },
    paymentMethod: {
      $ref: '#/components/schemas/PaymentMethodInfo',
    },
    promotionalCreditsLeft: {
      type: 'number',
      description: 'The promotionalCreditsLeft property',
      format: 'double',
      nullable: true,
    },
    promotionalCreditsTotal: {
      type: 'number',
      description: 'The promotionalCreditsTotal property',
      format: 'double',
      nullable: true,
    },
    subscriptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SubscriptionInfo',
      },
      description: 'Subscriptions',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Customer info response',
} as const;

export const $CustomerLanguageDto = {
  enum: ['English', 'Dutch', 'French'],
  type: 'string',
  description: "The customer's language",
} as const;

export const $CustomerPaymentStatus = {
  enum: ['AllGood', 'InDunning'],
  type: 'string',
  description: 'Customer payment status',
} as const;

export const $CustomerTypeDto = {
  enum: ['Residential', 'SOHO'],
  type: 'string',
  description: 'Type of customer',
} as const;

export const $DeliveryCountdownCardDetailsResponse = {
  required: ['address'],
  type: 'object',
  properties: {
    address: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    gasEan: {
      type: 'string',
      description: 'Gas EAN',
      nullable: true,
    },
    electricityEan: {
      type: 'string',
      description: 'Electricity EAN',
      nullable: true,
    },
    startDate: {
      type: 'string',
      description: 'Start date for the delivery',
      format: 'date',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Details of a delivery countdown',
} as const;

export const $DeliveryCountdownCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/DeliveryCountdownCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response model for delivery countdown card in next best action flow',
} as const;

export const $DetailCorrespondenceUpdateRequest = {
  required: ['selectedAddress'],
  type: 'object',
  properties: {
    customAddress: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
    selectedAddress: {
      $ref: '#/components/schemas/SelectedCorrespondenceAddressDto',
    },
    correspondenceDate: {
      type: 'string',
      description: 'Date from which invoices should be sent to this selected address',
      format: 'date',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Request that allows the customer to update the correspondence address',
} as const;

export const $DetailMeterUpdateRequest = {
  required: ['energyType'],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/MoveEnergyTypeDto',
    },
    oldEAN: {
      type: 'string',
      description: "The old meter's EAN",
      nullable: true,
    },
    ean: {
      type: 'string',
      description: "The meter's EAN",
      nullable: true,
    },
    oldMeterNumber: {
      type: 'string',
      description: "The old meter's number",
      nullable: true,
    },
    meterNumber: {
      type: 'string',
      description: "The meter's number",
      nullable: true,
    },
    meterValue: {
      type: 'number',
      description: 'Value of the meter',
      format: 'decimal',
      nullable: true,
    },
    dayMeterValue: {
      type: 'number',
      description: 'Day meter value',
      format: 'decimal',
      nullable: true,
    },
    nightMeterValue: {
      type: 'number',
      description: 'Night meter value',
      format: 'decimal',
      nullable: true,
    },
    nightExclusiveMeterValue: {
      type: 'number',
      description: 'Exclusive night meter value',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Request to update move meter details',
} as const;

export const $DetailOldAddressNewOwnerContactDetailsUpdateRequest = {
  type: 'object',
  properties: {
    representation: {
      $ref: '#/components/schemas/Representation',
    },
    firstName: {
      type: 'string',
      description: 'First name of the new owner',
      nullable: true,
    },
    lastName: {
      type: 'string',
      description: 'Last name of the new owner',
      nullable: true,
    },
    phoneNumber: {
      type: 'string',
      description: 'Phone number of the new owner',
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'Email of the new owner',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Update the old address new owner',
} as const;

export const $DetailedCostDto = {
  required: ['costType', 'value'],
  type: 'object',
  properties: {
    costType: {
      $ref: '#/components/schemas/DetailedCostTypeDto',
    },
    value: {
      type: 'number',
      description: 'The monetary value of this detailed cost.',
      format: 'decimal',
    },
  },
  additionalProperties: false,
  description: 'Represents a detailed cost item with its type and value.',
} as const;

export const $DetailedCostTypeDto = {
  enum: ['FixedFee', 'Usage', 'PurchaseRate', 'ProsumentRate', 'DataManagement', 'CapacityRate'],
  type: 'string',
  description: 'Represents the different types of detailed costs used in price simulation.',
} as const;

export const $DigitalCancellationFormResponse = {
  required: ['accountNumber', 'address', 'email', 'firstName', 'lastName', 'products'],
  type: 'object',
  properties: {
    accountNumber: {
      type: 'string',
      description: 'Account number linked to the sales order',
    },
    firstName: {
      type: 'string',
      description: 'First name of the customer',
    },
    lastName: {
      type: 'string',
      description: 'Last name of the customer',
    },
    address: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    email: {
      type: 'string',
      description: 'Email address of the customer',
    },
    phoneNumber: {
      type: 'string',
      description: 'Telephone or mobile number of the customer',
      nullable: true,
    },
    products: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DigitalCancellationProductResponse',
      },
      description: 'Products of the contract items sharing the sales order',
    },
  },
  additionalProperties: false,
  description: 'Prefilled details for the digital cancellation form of a sales order.',
} as const;

export const $DigitalCancellationProductResponse = {
  required: ['energyType', 'id', 'name', 'nameFr', 'type'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Id of the product',
    },
    name: {
      type: 'string',
      description: 'Dutch name of the product',
    },
    nameFr: {
      type: 'string',
      description: 'French name of the product',
    },
    type: {
      $ref: '#/components/schemas/ProductType',
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Product of a contract item to be cancelled.',
} as const;

export const $DirectionTypeCodeDto = {
  enum: ['Injection', 'OffTake'],
  type: 'string',
  description: 'Direction type code',
} as const;

export const $DiscountStatus = {
  enum: ['None', 'Active', 'Expired'],
  type: 'string',
  description: 'Discount status',
} as const;

export const $DisplayModeDto = {
  enum: ['Consumption', 'Cost'],
  type: 'string',
  description: 'Represents the display mode for consumption data.',
} as const;

export const $Document = {
  required: ['documentType', 'url'],
  type: 'object',
  properties: {
    documentType: {
      $ref: '#/components/schemas/InvoiceDocumentTypeDto',
    },
    url: {
      type: 'string',
      description: 'The Url',
    },
  },
  additionalProperties: false,
  description: 'Representation of the invoice documents',
} as const;

export const $DongleInfo = {
  type: 'object',
  properties: {
    dongleStatus: {
      $ref: '#/components/schemas/DongleStatus',
    },
    orderDate: {
      type: 'string',
      description: 'The orderDate property',
      format: 'date-time',
      nullable: true,
    },
    purchaseStatus: {
      $ref: '#/components/schemas/PurchaseStatus',
    },
    shippingAddress: {
      $ref: '#/components/schemas/Address',
    },
    shippingStatus: {
      $ref: '#/components/schemas/ShippingStatus',
    },
  },
  additionalProperties: false,
  description: 'Dongle info response',
} as const;

export const $DongleStatus = {
  enum: ['Unknown', 'NotInstaled', 'Active', 'NotActive'],
  type: 'string',
  description: 'Dongle Status',
} as const;

export const $DunningStatus = {
  enum: ['InProgress', 'Success', 'Exhausted', 'Stopped'],
  type: 'string',
  description: 'Dunning status',
} as const;

export const $DynamicPriceRecord = {
  required: ['date', 'price', 'time'],
  type: 'object',
  properties: {
    date: {
      type: 'string',
      description: 'The day on for which the price is valid',
      format: 'date',
    },
    time: {
      type: 'string',
      description: 'The time for which the price is valid',
      format: 'time',
    },
    price: {
      type: 'number',
      description: 'The price',
      format: 'decimal',
    },
  },
  additionalProperties: false,
  description: 'A dynamic price record',
} as const;

export const $DynamicPricingResponse = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/DynamicPriceRecord',
      },
    },
  },
  additionalProperties: false,
  description: 'A container with dynamic pricing records',
} as const;

export const $EODFileUploadResponse = {
  required: ['fileName', 'fileReference'],
  type: 'object',
  properties: {
    fileReference: {
      type: 'string',
      description: 'File reference',
    },
    fileName: {
      type: 'string',
      description: 'File name',
    },
  },
  additionalProperties: false,
  description: 'Uploaded file details',
} as const;

export const $ElectricityServiceComponentDto = {
  enum: ['Compensation', 'Injection', 'Offtake', 'OfftakeInjection', 'Valorisation'],
  type: 'string',
  description: 'The service component of the electricityOrder',
} as const;

export const $EligibilitiesResponse = {
  required: ['signedAgreements'],
  type: 'object',
  properties: {
    signedAgreements: {
      $ref: '#/components/schemas/SignedAgreementsDto',
    },
  },
  additionalProperties: false,
  description: 'Response containing multiple kinds of eligibility characteristics',
} as const;

export const $EnecoDiscount = {
  type: 'object',
  properties: {
    campaignCodes: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'The campaignCodes property',
      nullable: true,
    },
    detailsUrl: {
      type: 'string',
      description: 'The detailsUrl property',
      nullable: true,
    },
    discountAmount: {
      type: 'number',
      description: 'The discountAmount property',
      format: 'double',
      nullable: true,
    },
    discountPercentage: {
      type: 'number',
      description: 'The discountPercentage property',
      format: 'double',
      nullable: true,
    },
    durationLength: {
      type: 'integer',
      description: 'The durationLength property',
      format: 'int32',
      nullable: true,
    },
    durationUnit: {
      $ref: '#/components/schemas/EnecoDiscountDurationUnit',
    },
    id: {
      type: 'string',
      description: 'The id property',
      nullable: true,
    },
    invoiceName: {
      type: 'string',
      description: 'The invoiceName property',
      nullable: true,
    },
    name: {
      type: 'string',
      description: 'The name property',
      nullable: true,
    },
    notes: {
      type: 'string',
      description: 'The notes property',
      nullable: true,
    },
    redemingCouponCode: {
      type: 'string',
      description: 'The redemingCouponCode property',
      nullable: true,
    },
    requireCouponCode: {
      type: 'boolean',
      description: 'The requireCouponCode property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Eneco discount.',
} as const;

export const $EnecoDiscountDurationUnit = {
  enum: ['OneTime', 'Day', 'Week', 'Month', 'Year', 'Forever'],
  type: 'string',
  description: 'Eneco discount duration unit.',
} as const;

export const $EnecoErrorDetails = {
  required: ['message'],
  type: 'object',
  properties: {
    callerMessage: {
      type: 'string',
      description: 'The callerMessage property',
      nullable: true,
    },
    customerMessage: {
      type: 'string',
      description: 'The customerMessage property',
      nullable: true,
    },
    erroMessage: {
      type: 'string',
      description: 'The erroMessage property',
      nullable: true,
    },
    errorCode: {
      type: 'string',
      description: 'The errorCode property',
      nullable: true,
    },
    errorLocation: {
      type: 'string',
      description: 'The errorLocation property',
      nullable: true,
    },
    message: {
      type: 'string',
      description: 'The primary error message.',
    },
  },
  additionalProperties: false,
  description: 'Eneco Error Details',
} as const;

export const $EnecoOrderDiscount = {
  type: 'object',
  properties: {
    couponCode: {
      type: 'string',
      description: 'The couponCode property',
      nullable: true,
    },
    id: {
      type: 'string',
      description: 'The id property',
      nullable: true,
    },
    redeemingCouponCode: {
      type: 'string',
      description: 'The redeemingCouponCode property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Eneco order discount.',
} as const;

export const $EnecoOrderExtra = {
  type: 'object',
  properties: {
    discounts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoOrderDiscount',
      },
      description: 'The discounts property',
      nullable: true,
    },
    productId: {
      type: 'string',
      description: 'The productId property',
      nullable: true,
    },
    quantity: {
      type: 'integer',
      description: 'The quantity property',
      format: 'int32',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Eneco order extra.',
} as const;

export const $EnecoOrderProduct = {
  type: 'object',
  properties: {
    discounts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoOrderDiscount',
      },
      description: 'The discounts property',
      nullable: true,
    },
    extras: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoOrderExtra',
      },
      description: 'The extras property',
      nullable: true,
    },
    productId: {
      type: 'string',
      description: 'The productId property',
      nullable: true,
    },
    quantity: {
      type: 'integer',
      description: 'The quantity property',
      format: 'int32',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Eneco order product.',
} as const;

export const $EnecoProduct = {
  type: 'object',
  properties: {
    billingPeriod: {
      type: 'integer',
      description: 'The billingPeriod property',
      format: 'int32',
      nullable: true,
    },
    description: {
      type: 'string',
      description: 'The description property',
      nullable: true,
    },
    discounts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoDiscount',
      },
      description: 'The discounts property',
      nullable: true,
    },
    extras: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoProductExtra',
      },
      description: 'The extras property',
      nullable: true,
    },
    familyId: {
      type: 'string',
      description: 'The familyId property',
      nullable: true,
    },
    features: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'The features property',
      nullable: true,
    },
    isMetered: {
      type: 'boolean',
      description: 'The isMetered property',
      nullable: true,
    },
    isShippable: {
      type: 'boolean',
      description: 'The isShippable property',
      nullable: true,
    },
    mainDescription: {
      type: 'string',
      description: 'The mainDescription property',
      nullable: true,
    },
    mainId: {
      type: 'string',
      description: 'The mainId property',
      nullable: true,
    },
    mainName: {
      type: 'string',
      description: 'The mainName property',
      nullable: true,
    },
    maximumQuantity: {
      type: 'integer',
      description: 'The maximumQuantity property',
      format: 'int32',
      nullable: true,
    },
    meteredPriceFormula: {
      type: 'string',
      description: 'The meteredPriceFormula property',
      nullable: true,
    },
    minimumQuantity: {
      type: 'integer',
      description: 'The minimumQuantity property',
      format: 'int32',
      nullable: true,
    },
    name: {
      type: 'string',
      description: 'The name property',
      nullable: true,
    },
    periodUnit: {
      $ref: '#/components/schemas/EnecoProductPeriodUnit',
    },
    priceIsTaxExcluded: {
      type: 'boolean',
      description: 'The priceIsTaxExcluded property',
      nullable: true,
    },
    priceModel: {
      $ref: '#/components/schemas/EnecoProductPriceModel',
    },
    productId: {
      type: 'string',
      description: 'The productId property',
      nullable: true,
    },
    quantity: {
      type: 'integer',
      description: 'The quantity property',
      format: 'int32',
      nullable: true,
    },
    taxPercentage: {
      type: 'number',
      description: 'The taxPercentage property',
      format: 'double',
      nullable: true,
    },
    unitPrice: {
      type: 'number',
      description: 'The unitPrice property',
      format: 'double',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Eneco product.',
} as const;

export const $EnecoProductExtra = {
  type: 'object',
  properties: {
    billingPeriod: {
      type: 'integer',
      description: 'The billingPeriod property',
      format: 'int32',
      nullable: true,
    },
    description: {
      type: 'string',
      description: 'The description property',
      nullable: true,
    },
    discounts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoDiscount',
      },
      description: 'The discounts property',
      nullable: true,
    },
    familyId: {
      type: 'string',
      description: 'The familyId property',
      nullable: true,
    },
    features: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'The features property',
      nullable: true,
    },
    isMetered: {
      type: 'boolean',
      description: 'The isMetered property',
      nullable: true,
    },
    isShippable: {
      type: 'boolean',
      description: 'The isShippable property',
      nullable: true,
    },
    mainDescription: {
      type: 'string',
      description: 'The mainDescription property',
      nullable: true,
    },
    mainId: {
      type: 'string',
      description: 'The mainId property',
      nullable: true,
    },
    mainName: {
      type: 'string',
      description: 'The mainName property',
      nullable: true,
    },
    maximumQuantity: {
      type: 'integer',
      description: 'The maximumQuantity property',
      format: 'int32',
      nullable: true,
    },
    meteredPriceFormula: {
      type: 'string',
      description: 'The meteredPriceFormula property',
      nullable: true,
    },
    minimumQuantity: {
      type: 'integer',
      description: 'The minimumQuantity property',
      format: 'int32',
      nullable: true,
    },
    name: {
      type: 'string',
      description: 'The name property',
      nullable: true,
    },
    periodUnit: {
      $ref: '#/components/schemas/EnecoProductExtraPeriodUnit',
    },
    priceIsTaxExcluded: {
      type: 'boolean',
      description: 'The priceIsTaxExcluded property',
      nullable: true,
    },
    priceModel: {
      $ref: '#/components/schemas/EnecoProductExtraPriceModel',
    },
    productId: {
      type: 'string',
      description: 'The productId property',
      nullable: true,
    },
    quantity: {
      type: 'integer',
      description: 'The quantity property',
      format: 'int32',
      nullable: true,
    },
    taxPercentage: {
      type: 'number',
      description: 'The taxPercentage property',
      format: 'double',
      nullable: true,
    },
    unitPrice: {
      type: 'number',
      description: 'The unitPrice property',
      format: 'double',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Eneco product.',
} as const;

export const $EnecoProductExtraPeriodUnit = {
  enum: ['OneTime', 'Day', 'Week', 'Month', 'Year', 'Forever'],
  type: 'string',
  description: 'Eneco product extra period unit.',
} as const;

export const $EnecoProductExtraPriceModel = {
  enum: ['FlatFee', 'PerUnit', 'Tiered', 'Volume', 'Stairstep'],
  type: 'string',
  description: 'Eneco product extra price model.',
} as const;

export const $EnecoProductPeriodUnit = {
  enum: ['OneTime', 'Day', 'Week', 'Month', 'Year', 'Forever'],
  type: 'string',
  description: 'Eneco product period unit.',
} as const;

export const $EnecoProductPriceModel = {
  enum: ['FlatFee', 'PerUnit', 'Tiered', 'Volume', 'Stairstep'],
  type: 'string',
  description: 'Eneco product price model.',
} as const;

export const $EnergyMonitorFrequency = {
  enum: ['Never', 'Weekly', 'Biweekly', 'Monthly'],
  type: 'string',
  description: 'The carrier for invoices',
} as const;

export const $EnergyProductPair = {
  type: 'object',
  properties: {
    electric: {
      type: 'string',
      description: 'Represents the electric energy product associated with an energy product pair',
      nullable: true,
    },
    gas: {
      type: 'string',
      description: 'Represents the gas energy product associated with an energy product pair',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents a pair of energy products associated with electricity and gas',
} as const;

export const $EnergyProductPairMail = {
  type: 'object',
  properties: {
    electricTechnicalName: {
      type: 'string',
      description: 'Gets or sets the technical name of the electric energy product.',
      nullable: true,
    },
    electricVisibleName: {
      type: 'string',
      description: 'Gets or sets the visible name of the electric energy product.',
      nullable: true,
    },
    gasTechnicalName: {
      type: 'string',
      description: 'Gets or sets the technical name of the gas energy product.',
      nullable: true,
    },
    gasVisibleName: {
      type: 'string',
      description: 'Gets or sets the visible name of the gas energy product.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description:
    'Represents a pair of energy products for mail, specifying both technical and visible names for electric and gas products',
} as const;

export const $EnergyTypeDto = {
  enum: ['Electricity', 'Gas', 'Both', 'Unknown'],
  type: 'string',
  description: 'Type of energy that can be delivered',
} as const;

export const $Error = {
  required: ['code', 'description', 'metadata', 'numericType', 'type'],
  type: 'object',
  properties: {
    code: {
      type: 'string',
      readOnly: true,
    },
    description: {
      type: 'string',
      readOnly: true,
    },
    type: {
      $ref: '#/components/schemas/ErrorType',
    },
    numericType: {
      type: 'integer',
      format: 'int32',
      readOnly: true,
    },
    metadata: {
      type: 'object',
      additionalProperties: {},
      nullable: true,
      readOnly: true,
    },
  },
  additionalProperties: false,
} as const;

export const $ErrorType = {
  enum: [0, 1, 2, 3, 4, 5, 6],
  type: 'integer',
  format: 'int32',
} as const;

export const $FallbackCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for fallback card',
} as const;

export const $FaqCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for FAQ card',
} as const;

export const $FinalizeOrderRequest = {
  required: ['dataProcessingAccepted', 'privacyPolicyAccepted'],
  type: 'object',
  properties: {
    gezinsbondNumber: {
      type: 'string',
      description: 'Gezinsbond number that was used',
      nullable: true,
    },
    privacyPolicyAccepted: {
      type: 'boolean',
      description: 'Whether the user accepted the privacy policy',
    },
    dataProcessingAccepted: {
      type: 'boolean',
      description: 'Whether the user accepted the data processing',
    },
  },
  additionalProperties: false,
  description: 'Request containing the order finalization data',
} as const;

export const $ForgotEmailResponse = {
  required: ['email'],
  type: 'object',
  properties: {
    email: {
      type: 'string',
      description: 'Obfuscated email to which an email was sent',
    },
  },
  additionalProperties: false,
  description: 'Contains forgot email details',
} as const;

export const $GenderDto = {
  enum: ['Unspecified', 'Male', 'Female'],
  type: 'string',
  description: "Gender of the CRM accounts' user",
} as const;

export const $GenderFormContactDto = {
  enum: ['Male', 'Female'],
  type: 'string',
  description: 'Kinds of gender',
} as const;

export const $GetAccountContactDetailsResponse = {
  required: ['accountNumber', 'createdDate', 'customerType', 'email', 'firstName', 'gender', 'language', 'lastName'],
  type: 'object',
  properties: {
    accountNumber: {
      type: 'string',
      description: 'Identifier of the account',
    },
    firstName: {
      type: 'string',
      description: 'First name of the account',
    },
    lastName: {
      type: 'string',
      description: 'Last name of the account',
    },
    email: {
      type: 'string',
      description: 'Email of the account',
    },
    dateOfBirth: {
      type: 'string',
      description: 'Creation date of the account',
      format: 'date',
      nullable: true,
    },
    createdDate: {
      type: 'string',
      description: 'Created date',
      format: 'date-time',
    },
    telephoneNumber: {
      type: 'string',
      description: 'Telephone number of the account',
      nullable: true,
    },
    mobileNumber: {
      type: 'string',
      description: 'Mobile number of the account',
      nullable: true,
    },
    gezinsBondNumber: {
      type: 'string',
      description: 'Gezinsbond number of the account',
      nullable: true,
    },
    customerType: {
      $ref: '#/components/schemas/CustomerTypeDto',
    },
    gender: {
      $ref: '#/components/schemas/GenderDto',
    },
    language: {
      $ref: '#/components/schemas/CustomerLanguageDto',
    },
    contactAddress: {
      $ref: '#/components/schemas/ContactAddressDto',
    },
    companyData: {
      $ref: '#/components/schemas/CompanyDataDto',
    },
    comfortBonusLevel: {
      $ref: '#/components/schemas/ComfortBonusLevelDto',
    },
    firstContractDate: {
      type: 'string',
      description: 'The first contract start date',
      format: 'date',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Representation a CRM accounts contact details',
} as const;

export const $GetAccountContactPreferencesResponse = {
  required: ['advancePayments', 'enecoNews', 'hasEBillingPromotion', 'promotions'],
  type: 'object',
  properties: {
    invoicePreferences: {
      $ref: '#/components/schemas/InvoiceContactPreference',
    },
    advancePayments: {
      type: 'boolean',
      description: 'Does the user want Advance invoices',
    },
    enecoNews: {
      type: 'boolean',
      description: 'Does the user want more information about Eneco',
    },
    promotions: {
      type: 'boolean',
      description: 'Doest the user want more info about Promotions or third party partners',
    },
    energyMonitorFrequency: {
      $ref: '#/components/schemas/EnergyMonitorFrequency',
    },
    hasEBillingPromotion: {
      type: 'boolean',
      description: 'Whether the user has any active product that has an E-Billing requirement',
    },
  },
  additionalProperties: false,
  description: 'Representation a CRM accounts contact preferences',
} as const;

export const $GetAccountDetailsResponse = {
  required: ['alias', 'crmAccountNumber'],
  type: 'object',
  properties: {
    crmAccountNumber: {
      type: 'string',
      description: 'account number of the crm account',
    },
    alias: {
      type: 'string',
      description: 'the configured alias for the crm account',
    },
  },
  additionalProperties: false,
  description: 'Details of a CRM account from the viewpoint of the logged in user',
} as const;

export const $GetAddressResponse = {
  required: ['addresses'],
  type: 'object',
  properties: {
    addresses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetAddressResponseAddress',
      },
    },
  },
  additionalProperties: false,
  description: 'A container with dynamic pricing records',
} as const;

export const $GetAddressResponseAddress = {
  required: ['city', 'street', 'zipcode'],
  type: 'object',
  properties: {
    zipcode: {
      type: 'string',
      description: 'The zipCode',
    },
    cityId: {
      type: 'integer',
      description: 'the unique city identification',
      format: 'int32',
      nullable: true,
    },
    city: {
      type: 'string',
      description: 'The city',
    },
    streetId: {
      type: 'integer',
      description: 'The unique street identification',
      format: 'int32',
      nullable: true,
    },
    street: {
      type: 'string',
      description: 'The street',
    },
    region: {
      $ref: '#/components/schemas/AddressRegionDto',
    },
  },
  additionalProperties: false,
  description: 'A dynamic price record',
} as const;

export const $GetAssetResponse = {
  required: ['assetType', 'id'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Asset identifier',
      format: 'uuid',
    },
    assetType: {
      $ref: '#/components/schemas/AssetTypeDto',
    },
    externalAssetId: {
      type: 'string',
      description: 'Asset identifier in external system',
      nullable: true,
    },
    vehicle: {
      $ref: '#/components/schemas/VehicleAssetResourceDto',
    },
  },
  additionalProperties: false,
  description: 'Single asset response',
} as const;

export const $GetAssetsResponse = {
  required: ['assets'],
  type: 'object',
  properties: {
    assets: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetAssetResponse',
      },
    },
  },
  additionalProperties: false,
  description: 'Single asset response',
} as const;

export const $GetContractDetailsForProductResponse = {
  required: ['activeFrom', 'address', 'addressDetails', 'addressId', 'contractId', 'meter', 'productName', 'tariff'],
  type: 'object',
  properties: {
    activeFrom: {
      type: 'string',
      description: 'When the contract becomes active',
      format: 'date',
    },
    activeUntil: {
      type: 'string',
      description: 'When the contract ends',
      format: 'date',
      nullable: true,
    },
    contractId: {
      type: 'string',
      description: 'Id of the contract',
    },
    type: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    contractProductStatusExternal: {
      $ref: '#/components/schemas/ContractProductStatusDto',
    },
    productName: {
      type: 'string',
      description: 'Name of the product',
    },
    address: {
      type: 'string',
      description: 'Address to which the product is delivered',
    },
    addressId: {
      type: 'string',
      description: 'Address Id of the address',
    },
    addressDetails: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    tariff: {
      $ref: '#/components/schemas/GetContractDetailsForProductResponseTariff',
    },
    meter: {
      $ref: '#/components/schemas/GetContractDetailsForProductResponseMeter',
    },
    gridOperator: {
      $ref: '#/components/schemas/GetContractDetailsForProductResponseGridOperator',
    },
    productSwitch: {
      $ref: '#/components/schemas/ContractProductSwitchResponse',
    },
    tariffChartStartDate: {
      type: 'string',
      description: 'The start date of the tariff chart',
      format: 'date',
      nullable: true,
    },
    fixedDurationEndDate: {
      type: 'string',
      description: 'End date if product has fixed end date',
      format: 'date-time',
      nullable: true,
    },
    fixedDurationYears: {
      type: 'integer',
      description: 'Amount of years the fixed duration product is valid',
      format: 'int32',
      nullable: true,
    },
    billingAccountNumber: {
      type: 'string',
      description: 'Billing account number',
      nullable: true,
    },
    nextRenewalDate: {
      type: 'string',
      description: 'The date for the next automatic renewal',
      format: 'date',
      nullable: true,
    },
    nextRenewalProductIdentifier: {
      type: 'string',
      description: 'The date for the next automatic renewal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Details for a product within a contract.',
} as const;

export const $GetContractDetailsForProductResponseGridOperator = {
  required: ['gln', 'name'],
  type: 'object',
  properties: {
    name: {
      type: 'string',
      description: 'Name of the grid operator',
    },
    gln: {
      type: 'string',
      description: 'GLN of the grid operator',
    },
  },
  additionalProperties: false,
  description: 'Describes the grid operator for this product',
} as const;

export const $GetContractDetailsForProductResponseMeter = {
  required: [
    'ean',
    'invoiceFrequency',
    'meterNumber',
    'meterRegime',
    'meterTariff',
    'meterType',
    'registers',
    'service',
  ],
  type: 'object',
  properties: {
    meterType: {
      $ref: '#/components/schemas/MeterType',
    },
    ean: {
      type: 'string',
      description: 'EAN code for the meter',
    },
    meterNumber: {
      type: 'string',
      description: 'Number of the meter',
    },
    service: {
      $ref: '#/components/schemas/MeterService',
    },
    meterRegime: {
      $ref: '#/components/schemas/MeterRegimeHolder',
    },
    meterTariff: {
      $ref: '#/components/schemas/MeterTariffHolder',
    },
    invoiceFrequency: {
      $ref: '#/components/schemas/InvoiceFrequencyHolder',
    },
    registers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RegisterHolder',
      },
      description: 'The registers that the meter contains',
    },
  },
  additionalProperties: false,
  description: 'Meter details for a given product',
} as const;

export const $GetContractDetailsForProductResponseTariff = {
  required: ['currentTariff', 'isSocialTariff', 'product', 'promotions'],
  type: 'object',
  properties: {
    product: {
      type: 'string',
      description: 'The name of the product',
    },
    productType: {
      $ref: '#/components/schemas/ProductType',
    },
    promotions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Promotion',
      },
      description: 'Discounts active on this product',
    },
    isSocialTariff: {
      type: 'boolean',
      description: 'Is social tariff',
    },
    currentTariff: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TariffDetails',
      },
      description: 'Links to the tariff card by language, which is currently active',
    },
  },
  additionalProperties: false,
  description: 'Tariff details for a given product',
} as const;

export const $GetContractDetailsForProductsResponse = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetContractDetailsForProductResponse',
      },
      description: 'List of contract details for all products of an account',
    },
  },
  additionalProperties: false,
  description: 'Details for multiple products of an account',
} as const;

export const $GetInvoiceDto = {
  required: [
    'billingAccountNumber',
    'billInserts',
    'documents',
    'dueAmount',
    'invoiceEnergyType',
    'invoiceId',
    'invoiceStatus',
    'invoiceType',
    'openAmount',
    'paidAmount',
    'paymentMethod',
  ],
  type: 'object',
  properties: {
    invoiceId: {
      type: 'string',
      description: 'The invoice identification',
    },
    invoiceType: {
      $ref: '#/components/schemas/InvoiceTypeDto',
    },
    dueDate: {
      type: 'string',
      description: 'Due date of the invoice',
      format: 'date-time',
      nullable: true,
    },
    invoiceDate: {
      type: 'string',
      description: 'Date when the invoice is created',
      format: 'date-time',
      nullable: true,
    },
    invoicingPeriodStartDate: {
      type: 'string',
      description: 'Start of the period for which the customer gets invoiced',
      format: 'date-time',
      nullable: true,
    },
    invoicingPeriodEndDate: {
      type: 'string',
      description: 'End of the period for which the customer gets invoiced',
      format: 'date-time',
      nullable: true,
    },
    paymentDate: {
      type: 'string',
      description: 'Date when the invoice was paid',
      format: 'date-time',
      nullable: true,
    },
    dueAmount: {
      type: 'number',
      description: 'Due amount to pay',
      format: 'decimal',
    },
    paidAmount: {
      type: 'number',
      description: 'What amount has already been paid for this invoice?',
      format: 'decimal',
    },
    openAmount: {
      type: 'number',
      description: 'The amount that is till open to pay',
      format: 'decimal',
    },
    invoiceStatus: {
      $ref: '#/components/schemas/InvoiceStatusDto',
    },
    paymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
    billInserts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/BillInsertDto',
      },
      description: 'One or multiple bill inserts',
    },
    invoiceEnergyType: {
      $ref: '#/components/schemas/InvoiceEnergyTypeDto',
    },
    billingAccountNumber: {
      type: 'string',
      description: 'The billing account the invoice belongs to',
    },
    documents: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Document',
      },
      description: 'The documents associated with the invoice',
    },
  },
  additionalProperties: false,
  description: 'Representation of a single invoice row',
} as const;

export const $GetInvoicesOpenAmountSummaryRecord = {
  required: ['amount', 'amountOfUnpaidInvoices', 'billingAccountNumber', 'iban', 'openAmountItems', 'paymentMethod'],
  type: 'object',
  properties: {
    billingAccountNumber: {
      type: 'string',
      description: 'The billing account number associated with the invoice',
    },
    amount: {
      type: 'number',
      description: 'The amount outstanding for the billing account',
      format: 'decimal',
    },
    amountOfUnpaidInvoices: {
      type: 'integer',
      description: 'The number of unpaid invoices for the billing account',
      format: 'int32',
    },
    iban: {
      type: 'string',
      description: 'The iban number linked to this billing account',
    },
    paymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
    openAmountItems: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/OpenAmountItemResponse',
      },
      description: 'Open amounts under the grouping',
    },
  },
  additionalProperties: false,
  description: 'Record containing open amount information for a billing account',
} as const;

export const $GetInvoicesOpenAmountSummaryResponse = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetInvoicesOpenAmountSummaryRecord',
      },
      description: 'Collection of open amount summary records',
    },
  },
  additionalProperties: false,
  description: 'Response containing a summary of open invoice amounts',
} as const;

export const $GetInvoicesResponse = {
  required: ['invoices'],
  type: 'object',
  properties: {
    invoices: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetInvoiceDto',
      },
      description: 'Multiple invoice rows',
    },
    openAmountSummary: {
      $ref: '#/components/schemas/GetInvoicesOpenAmountSummaryResponse',
    },
  },
  additionalProperties: false,
  description: 'Paged response containing multiple invoice rows',
} as const;

export const $GetMonthlyInvoicePeriodDtoMeter = {
  required: ['billingAccountNumber', 'contractId', 'crmAccountNumber', 'ean', 'energyType', 'period'],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    ean: {
      type: 'string',
      description: 'EAN of the meter',
    },
    period: {
      $ref: '#/components/schemas/MonthlyInvoicePeriodDto',
    },
    crmAccountNumber: {
      type: 'string',
      description: 'Number that signifies CRM account',
    },
    billingAccountNumber: {
      type: 'string',
      description: 'Number that signifies Billing account',
    },
    contractId: {
      type: 'string',
      description: 'Contract Id associated with the meter',
    },
  },
  additionalProperties: false,
  description: 'A meter with monthly invoice period',
} as const;

export const $GetNewAddressDetailsResponse = {
  type: 'object',
  properties: {
    address: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
  },
  additionalProperties: false,
  description: 'Response containing possible already filled in address for the new address',
} as const;

export const $GetOrderResponse = {
  required: ['createdAt', 'lastUpdatedStep', 'orderId'],
  type: 'object',
  properties: {
    orderId: {
      type: 'string',
      description: 'Unique identifier of the order',
      format: 'uuid',
    },
    createdAt: {
      type: 'string',
      description: 'Timestamp when the order was created',
      format: 'date-time',
    },
    reminderEmailSentAt: {
      type: 'string',
      description: 'Timestamp when the order reminder email was sent',
      format: 'date-time',
      nullable: true,
    },
    priceSimulationId: {
      type: 'string',
      description: 'Unique identifier of the associated price simulation',
      format: 'uuid',
      nullable: true,
    },
    accountNumber: {
      type: 'string',
      description: 'Optional account number associated with the order',
      nullable: true,
    },
    customerType: {
      $ref: '#/components/schemas/CustomerTypeDto',
    },
    personalDetails: {
      $ref: '#/components/schemas/OrderPersonalDetailsDto',
    },
    companyDetails: {
      $ref: '#/components/schemas/OrderCompanyDetailsDto',
    },
    deliveryAddress: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    correspondenceAddressIsSame: {
      type: 'boolean',
      description: 'Indicates whether the correspondence address is the same as the delivery address',
      nullable: true,
    },
    correspondenceAddress: {
      $ref: '#/components/schemas/CorrespondenceAddressDto',
    },
    electricity: {
      $ref: '#/components/schemas/OrderElectricityDto',
    },
    gas: {
      $ref: '#/components/schemas/OrderGasDto',
    },
    payment: {
      $ref: '#/components/schemas/OrderPaymentDto',
    },
    basket: {
      $ref: '#/components/schemas/SimpleOrderBasketDto',
    },
    finalized: {
      $ref: '#/components/schemas/OrderFinalizedDto',
    },
    lastUpdatedStep: {
      $ref: '#/components/schemas/OrderStepDto',
    },
    nextStep: {
      $ref: '#/components/schemas/OrderStepDto',
    },
    promos: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PromoDto',
      },
      description: 'Promo',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The representation of an order as response to be used throughout Order Management Flow',
} as const;

export const $GetOverviewForAddressResponse = {
  required: ['activeProducts', 'expiredProducts'],
  type: 'object',
  properties: {
    activeProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetOverviewForAddressResponseItem',
      },
      description: '',
    },
    expiredProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetOverviewForAddressResponseItem',
      },
      description: '',
    },
  },
  additionalProperties: false,
  description: 'Collection of active and non-active products for a specific address',
} as const;

export const $GetOverviewForAddressResponseItem = {
  required: ['contractId', 'productName', 'promotions', 'renewalStatus'],
  type: 'object',
  properties: {
    contractId: {
      type: 'string',
      description: 'Id of the contract',
    },
    type: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    contractProductStatusExternal: {
      $ref: '#/components/schemas/ContractProductStatusDto',
    },
    productName: {
      type: 'string',
      description: 'Name of the product',
    },
    startTime: {
      type: 'string',
      description: 'Contract start date',
      format: 'date',
      nullable: true,
    },
    endTime: {
      type: 'string',
      description: 'Optional contract end date',
      format: 'date',
      nullable: true,
    },
    fixedDurationEndDate: {
      type: 'string',
      description: 'End date if product has fixed end date',
      format: 'date-time',
      nullable: true,
    },
    fixedDurationYears: {
      type: 'integer',
      description: 'Amount of years the fixed duration product is valid',
      format: 'int32',
      nullable: true,
    },
    meterReadingMonth: {
      type: 'integer',
      description: 'Month in which meter gets read',
      format: 'int32',
      nullable: true,
    },
    meterType: {
      $ref: '#/components/schemas/MeterTypeDto',
    },
    renewalStatus: {
      $ref: '#/components/schemas/ProductSwitchStatusResponse',
    },
    promotions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Promotion',
      },
      description: 'List of promotions attached to the contract',
    },
    billingAccountNumber: {
      type: 'string',
      description: 'Billing account number',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Response containing information about the contract and product',
} as const;

export const $GetPriceSimulationResponse = {
  required: ['simulationDetails'],
  type: 'object',
  properties: {
    simulationDetails: {
      $ref: '#/components/schemas/PriceSimulationDetailsDto',
    },
    simulationHistory: {
      $ref: '#/components/schemas/PriceSimulationHistoryDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the response containing price simulation details.',
} as const;

export const $GetProfileResponse = {
  required: ['displayName', 'email', 'hasItsmeLogin', 'hasLocalLogin', 'oktaId'],
  type: 'object',
  properties: {
    hasLocalLogin: {
      type: 'boolean',
      description: 'Whether the user has local login details (okta username/password)',
    },
    hasItsmeLogin: {
      type: 'boolean',
      description: 'Whether the user has social login details (third party login provider such as itsme)',
    },
    displayName: {
      type: 'string',
      description: 'The display name for the user, aka. the MyEneco Voornaam or ME Voornaam',
    },
    email: {
      type: 'string',
      description: 'The email for the user which is configured in okta',
    },
    oktaId: {
      type: 'string',
      description: 'Okta identifier',
    },
  },
  additionalProperties: false,
  description: 'Contains the profile details for a user',
} as const;

export const $GetServiceDeliveryPointOverviewForAddressResponse = {
  required: ['serviceDeliveryPoints'],
  type: 'object',
  properties: {
    serviceDeliveryPoints: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetServiceDeliveryPointOverviewForAddressResponseItem',
      },
      description: '',
    },
  },
  additionalProperties: false,
  description: 'Collection of all active service delivery points for a specific address',
} as const;

export const $GetServiceDeliveryPointOverviewForAddressResponseItem = {
  required: ['contractId', 'ean', 'invoiceFrequency', 'meterRegime', 'meterRegisterTypes', 'meterTariff'],
  type: 'object',
  properties: {
    contractId: {
      type: 'string',
      description: 'Id of the contract',
    },
    ean: {
      type: 'string',
      description: 'The ean number',
    },
    meterType: {
      $ref: '#/components/schemas/MeterType',
    },
    isBudgetMeter: {
      type: 'boolean',
      description: 'Kind of meter',
      nullable: true,
    },
    serviceComponent: {
      $ref: '#/components/schemas/MeterService',
    },
    type: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    meterRegisterTypes: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RegisterType',
      },
      description: 'Which registers the meter has',
    },
    meterRegime: {
      $ref: '#/components/schemas/MeterRegimeHolder',
    },
    meterTariff: {
      $ref: '#/components/schemas/MeterTariffHolder',
    },
    invoiceFrequency: {
      $ref: '#/components/schemas/InvoiceFrequencyHolder',
    },
  },
  additionalProperties: false,
  description: 'Response containing information about the contract and product',
} as const;

export const $GetSubscriptionResponse = {
  required: ['assets', 'id', 'startDate', 'status', 'tier', 'type'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Subscription identifier',
      format: 'uuid',
    },
    type: {
      $ref: '#/components/schemas/SubscriptionTypeDto',
    },
    tier: {
      $ref: '#/components/schemas/SubscriptionTierDto',
    },
    startDate: {
      type: 'string',
      description: 'Start date of subscription',
      format: 'date-time',
    },
    endDate: {
      type: 'string',
      description: 'Optional end date of subscription',
      format: 'date-time',
      nullable: true,
    },
    status: {
      $ref: '#/components/schemas/SubscriptionStatusDto',
    },
    assets: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetAssetResponse',
      },
      description: 'List of assets for this subscription',
    },
  },
  additionalProperties: false,
  description: 'Single subscription response',
} as const;

export const $GetSubscriptionsResponse = {
  required: ['subscriptions'],
  type: 'object',
  properties: {
    subscriptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetSubscriptionResponse',
      },
      description: 'List of subscriptions',
    },
  },
  additionalProperties: false,
  description: 'Get all subscriptions response',
} as const;

export const $GlobalAmountSimulationRecord = {
  required: ['contractNumber', 'ean'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'The EAN of the meter',
    },
    contractNumber: {
      type: 'string',
      description: 'The contract number',
    },
    amount: {
      type: 'integer',
      description: 'The simulated amount for the specified EAN and contract',
      format: 'int32',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents a record containing details of a global amount simulation.',
} as const;

export const $GlobalAmountSimulationResponse = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GlobalAmountSimulationRecord',
      },
    },
  },
  additionalProperties: false,
  description: 'Represents the response for a global amount simulation operation.',
} as const;

export const $ImpersonationRequest = {
  required: ['type', 'value'],
  type: 'object',
  properties: {
    value: {
      type: 'string',
    },
    type: {
      $ref: '#/components/schemas/ImpersonationTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Contains details about which person is being impersonated',
} as const;

export const $ImpersonationResponse = {
  required: [
    'actsAsIdentityProviderDisplayName',
    'actsAsIdentityProviderId',
    'crmAccountClaims',
    'impersonationRole',
    'impersonationType',
    'impersonatorIdentityProviderId',
    'impersonatorSubject',
  ],
  type: 'object',
  properties: {
    actsAsIdentityProviderId: {
      type: 'string',
      description: 'Id in Okta of the account being impersonated',
    },
    actsAsIdentityProviderDisplayName: {
      type: 'string',
      description: 'Display name in Okta of the account being impersonated',
    },
    impersonatorSubject: {
      type: 'string',
      description: 'Email in Okta of the impersonator',
    },
    impersonatorIdentityProviderId: {
      type: 'string',
      description: 'Id in Okta of the impersonator',
    },
    impersonationType: {
      $ref: '#/components/schemas/ImpersonationTypeDto',
    },
    impersonationRole: {
      $ref: '#/components/schemas/ImpersonationRoleDto',
    },
    crmAccountClaims: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/CrmAccountClaimDto',
      },
      description: 'Collection of account claim entries',
    },
  },
  additionalProperties: false,
  description: 'Contains the response of the impersonation flow',
} as const;

export const $ImpersonationRoleDto = {
  enum: ['Read', 'Write'],
  type: 'string',
  description: 'Role that the impersonator gets',
} as const;

export const $ImpersonationTypeDto = {
  enum: ['Email', 'Account'],
  type: 'string',
  description: 'The way of impersonation',
} as const;

export const $InitiateOrderRequest = {
  required: ['basket', 'language'],
  type: 'object',
  properties: {
    priceSimulationId: {
      type: 'string',
      description: 'Optional ID of a previous price simulation',
      format: 'uuid',
      nullable: true,
    },
    accountNumber: {
      type: 'string',
      description: 'Optional account number of an existing customer',
      nullable: true,
    },
    language: {
      $ref: '#/components/schemas/CustomerLanguageDto',
    },
    basket: {
      $ref: '#/components/schemas/SimpleOrderBasketDto',
    },
    promos: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/OrderPromoDto',
      },
      description: 'Promo selected by the customer',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Request model for initiating a new order',
} as const;

export const $InstallationStatusDto = {
  enum: ['Installed', 'NotInstalled', 'NotYetInstalled'],
  type: 'string',
  description: 'Installation status',
} as const;

export const $IntentRequest = {
  type: 'object',
  properties: {
    message: {
      type: 'string',
      description: 'The message to classify.',
      nullable: true,
    },
    language: {
      type: 'string',
      description: 'The language to use for classification.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The classification request.',
} as const;

export const $IntentResponse = {
  type: 'object',
  properties: {
    category: {
      type: 'string',
      description: 'The classified category.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The classification response.',
} as const;

export const $IntermediateSettlementBillInclReasonCardDetailsResponse = {
  required: ['summary'],
  type: 'object',
  properties: {
    billInsertReason: {
      type: 'string',
      description: 'The reason associated with the bill insertion.',
      nullable: true,
    },
    summary: {
      $ref: '#/components/schemas/GetInvoicesOpenAmountSummaryResponse',
    },
  },
  additionalProperties: false,
  description: 'Details for the intermediate settlement bill including the reason card.',
} as const;

export const $IntermediateSettlementBillInclReasonCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/IntermediateSettlementBillInclReasonCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for intermediate settlement bill including reason card',
} as const;

export const $InvoiceContactPreference = {
  enum: ['Email', 'Post', 'Peppol'],
  type: 'string',
  description: 'The carrier for invoices',
} as const;

export const $InvoiceDocumentTypeDto = {
  enum: [
    'Advance',
    'CorrectionNote',
    'CreditNote',
    'IncidentalNote',
    'Invoice',
    'SimplifiedBill',
    'DynamicBill',
    'EndNote',
    'SelfBill',
    'PaymentPlan',
  ],
  type: 'string',
  description: 'Type of invoice document',
} as const;

export const $InvoiceEnergyTypeDto = {
  enum: ['Electricity', 'Gas', 'Both', 'Unknown'],
  type: 'string',
  description: 'Current status of the invoice',
} as const;

export const $InvoiceFrequency = {
  enum: ['Monthly', 'Yearly', 'Continuous'],
  type: 'string',
  description: 'The Invoice frequency',
} as const;

export const $InvoiceFrequencyDto = {
  enum: ['Monthly', 'Yearly'],
  type: 'string',
  description: 'The frequency of the invoice',
} as const;

export const $InvoiceFrequencyHolder = {
  required: ['changeRequestPending', 'current'],
  type: 'object',
  properties: {
    changeRequestPending: {
      type: 'boolean',
      description: 'Whether a invoice frequency change request is ongoing',
    },
    current: {
      $ref: '#/components/schemas/InvoiceFrequency',
    },
    requested: {
      $ref: '#/components/schemas/InvoiceFrequency',
    },
  },
  additionalProperties: false,
  description:
    'Holder that has the current and requested invoice frequency and information about ongoing invoice frequency change requests',
} as const;

export const $InvoiceInfo = {
  type: 'object',
  properties: {
    dueAmount: {
      type: 'number',
      description: 'The dueAmount property',
      format: 'double',
      nullable: true,
    },
    dueDate: {
      type: 'string',
      description: 'The dueDate property',
      format: 'date-time',
      nullable: true,
    },
    dunningStatus: {
      $ref: '#/components/schemas/DunningStatus',
    },
    invoiceAmount: {
      type: 'number',
      description: 'The invoiceAmount property',
      format: 'double',
      nullable: true,
    },
    invoiceDate: {
      type: 'string',
      description: 'The invoiceDate property',
      format: 'date-time',
      nullable: true,
    },
    invoiceNumber: {
      type: 'string',
      description: 'The invoiceNumber property',
      nullable: true,
    },
    lines: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/InvoiceLineInfo',
      },
      description: 'The lines property',
      nullable: true,
    },
    paymentFailureReasonCode: {
      type: 'string',
      description: 'The paymentFailureReasonCode property',
      nullable: true,
    },
    paymentFailureReasonMessage: {
      type: 'string',
      description: 'The paymentFailureReasonMessage property',
      nullable: true,
    },
    status: {
      $ref: '#/components/schemas/InvoiceStatus',
    },
  },
  additionalProperties: false,
  description: 'Invoice info response',
} as const;

export const $InvoiceLineInfo = {
  type: 'object',
  properties: {
    discountAmount: {
      type: 'number',
      description: 'The discountAmount property',
      format: 'double',
      nullable: true,
    },
    itemName: {
      type: 'string',
      description: 'The itemName property',
      nullable: true,
    },
    quantity: {
      type: 'integer',
      description: 'The quantity property',
      format: 'int32',
      nullable: true,
    },
    servicePeriodEnd: {
      type: 'string',
      description: 'The servicePeriodEnd property',
      format: 'date-time',
      nullable: true,
    },
    servicePeriodStart: {
      type: 'string',
      description: 'The servicePeriodStart property',
      format: 'date-time',
      nullable: true,
    },
    subscriptionId: {
      type: 'string',
      description: 'The subscriptionId property',
      nullable: true,
    },
    totalAmount: {
      type: 'number',
      description: 'The totalAmount property',
      format: 'double',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Invoice line response',
} as const;

export const $InvoiceStatus = {
  enum: ['Posted', 'Pending', 'Paid', 'Overdue', 'NotPaid', 'Voided'],
  type: 'string',
  description: 'Invoice Status',
} as const;

export const $InvoiceStatusDto = {
  enum: ['New', 'Paid', 'Unpaid', 'PartiallyPaid', 'PaymentInProgress'],
  type: 'string',
  description: 'Current status of the invoice',
} as const;

export const $InvoiceTypeDto = {
  enum: [
    'AdvanceInvoice',
    'YearlyBill',
    'ClosingBill',
    'Invoice',
    'CorrectionInvoice',
    'IntermediaryInvoice',
    'CreditNote',
    'MonthlyBill',
    'SelfBill',
    'CollectionLetter',
  ],
  type: 'string',
  description: 'Type of invoice',
} as const;

export const $LanguageCodeDto = {
  enum: ['NL', 'FR', 'DE'],
  type: 'string',
  description: 'Supported language codes',
} as const;

export const $LinkItsmeRequest = {
  required: ['itsmeId'],
  type: 'object',
  properties: {
    itsmeId: {
      type: 'string',
      description: '',
    },
  },
  additionalProperties: false,
  description: 'Request which allows a user to link an itsme account to the okta account',
} as const;

export const $ListContractAddressesResponse = {
  required: ['addresses'],
  type: 'object',
  properties: {
    addresses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ListContractAddressesResponseItem',
      },
      description: 'Collection of addresses',
    },
  },
  additionalProperties: false,
  description: 'Response containing a collection of addresses',
} as const;

export const $ListContractAddressesResponseItem = {
  required: ['address', 'details', 'hasActiveContracts', 'id'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Internal id of the address',
    },
    address: {
      type: 'string',
      description: 'The address',
    },
    details: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    hasActiveContracts: {
      type: 'boolean',
      description: 'Whether the address has active contracts',
    },
  },
  additionalProperties: false,
  description: 'Response containing address information',
} as const;

export const $LocationDto = {
  required: ['latitude', 'longitude'],
  type: 'object',
  properties: {
    latitude: {
      type: 'number',
      description: 'Latitude',
      format: 'double',
    },
    longitude: {
      type: 'number',
      description: 'Longitude',
      format: 'double',
    },
  },
  additionalProperties: false,
  description: 'Location coordinates',
} as const;

export const $LocationType = {
  enum: ['Old', 'New'],
  type: 'string',
  description: 'Move location',
} as const;

export const $MarketingPropositionCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Marketing Proposition card',
} as const;

export const $MergeSessionPossibleCheckRequest = {
  required: ['language'],
  type: 'object',
  properties: {
    language: {
      $ref: '#/components/schemas/AccountMergeAttemptLanguageDto',
    },
  },
  additionalProperties: false,
  description: 'Request which allows a user to change his password',
} as const;

export const $MeterDeviationRequest = {
  required: ['ean', 'meterValues'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'The ean of the meter to rectify',
    },
    meterValues: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeterRectificationValueRequest',
      },
      description: 'Gets or sets the value of the meter values',
    },
  },
  additionalProperties: false,
  description: 'The meter deviation request class',
} as const;

export const $MeterReadingIndexValue = {
  required: ['direction', 'isValidated', 'meterNumber', 'meterTimeFrameType', 'reason', 'value'],
  type: 'object',
  properties: {
    value: {
      type: 'integer',
      description: 'Gets or sets the value of the meter reading index value.',
      format: 'int32',
    },
    meterTimeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    direction: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
    reason: {
      $ref: '#/components/schemas/Reason',
    },
    isValidated: {
      type: 'boolean',
      description: 'Is the meter reading validated',
    },
    meterNumber: {
      type: 'string',
      description: 'Gets or sets the value of the meter number',
    },
  },
  additionalProperties: false,
  description:
    'Represents the index value of a meter reading, including the value itself and the associated time frame type.',
} as const;

export const $MeterReadingResponse = {
  required: ['date', 'ean', 'indexValues', 'meterReadingType', 'registeredDate', 'utilityType'],
  type: 'object',
  properties: {
    ean: {
      maxLength: 50,
      type: 'string',
      description: 'Gets or sets the value of the ean',
    },
    indexValues: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeterReadingIndexValue',
      },
      description: 'Gets or sets the list of index values associated with the meter reading.',
    },
    date: {
      type: 'string',
      description: 'Gets or sets the value of the date',
      format: 'date',
    },
    meterReadingType: {
      $ref: '#/components/schemas/MeterReadingType',
    },
    registeredDate: {
      type: 'string',
      description: 'Gets or sets the value of the registered date',
      format: 'date',
    },
    utilityType: {
      $ref: '#/components/schemas/UtilityType',
    },
  },
  additionalProperties: false,
  description: 'The meter reading response class',
} as const;

export const $MeterReadingType = {
  enum: ['Official', 'Informative', 'CustomerAdded', 'RLP'],
  type: 'string',
  description: 'The meter reading type enum',
} as const;

export const $MeterRectificationValueRequest = {
  required: ['contestedDate', 'contestedReadingValue', 'direction', 'meterTimeFrameType', 'originalDate'],
  type: 'object',
  properties: {
    contestedReadingValue: {
      type: 'integer',
      description: 'The rectified reading value',
      format: 'int32',
    },
    originalDate: {
      type: 'string',
      description: 'Date of the original observation of the rectified value',
      format: 'date',
    },
    contestedDate: {
      type: 'string',
      description: 'Date of observation of the rectified value',
      format: 'date',
    },
    meterTimeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    direction: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
  },
  additionalProperties: false,
  description: 'Request containing the rectified values compared to the original values',
} as const;

export const $MeterRegime = {
  enum: ['NotApplicable', 'Smr1', 'Smr3'],
  type: 'string',
  description: 'The meter regime',
} as const;

export const $MeterRegimeHolder = {
  required: ['changeRequestPending', 'current'],
  type: 'object',
  properties: {
    changeRequestPending: {
      type: 'boolean',
      description: 'Whether a meter regime change request is ongoing',
    },
    current: {
      $ref: '#/components/schemas/MeterRegime',
    },
    requested: {
      $ref: '#/components/schemas/MeterRegime',
    },
  },
  additionalProperties: false,
  description:
    'Holder that has the current and requested meter regimes and information about ongoing meter regime change requests',
} as const;

export const $MeterRegisterDto = {
  required: ['direction', 'meterTimeFrameType'],
  type: 'object',
  properties: {
    meterTimeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    direction: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
  },
  additionalProperties: false,
  description: 'A single register a meter reading can be submitted for.',
} as const;

export const $MeterService = {
  enum: [
    'PureOfftake',
    'PureInjection',
    'Compensation',
    'ValorisationInjection',
    'CommercialisationConstraintInjection',
    'CommercialisationInjection',
    'CompensatedOfftake',
    'Unknown',
  ],
  type: 'string',
  description: 'Kind of service being delivered by the meter',
} as const;

export const $MeterTariffDto = {
  enum: ['Normal', 'Incentative'],
  type: 'string',
  description: 'What kind of meter tariff is active',
} as const;

export const $MeterTariffHolder = {
  required: ['changeRequestPending', 'current'],
  type: 'object',
  properties: {
    changeRequestPending: {
      type: 'boolean',
      description: 'Whether a meter tariff change request is ongoing',
    },
    current: {
      $ref: '#/components/schemas/MeterTariffDto',
    },
    requested: {
      $ref: '#/components/schemas/MeterTariffDto',
    },
  },
  additionalProperties: false,
  description:
    'Holder that has the current and requested meter tariff and information about ongoing meter tariff change requests',
} as const;

export const $MeterType = {
  enum: ['Analogue', 'Digital', 'DigitalNightExclusive', 'Unknown'],
  type: 'string',
  description: 'Kind of meter',
} as const;

export const $MeterTypeDto = {
  enum: ['Analogue', 'Digital', 'DigitalNightExclusive', 'Unknown'],
  type: 'string',
  description: 'Physical Meter type',
} as const;

export const $MonthlyBillingCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for monthly billing card',
} as const;

export const $MonthlyInvoicePeriodDto = {
  enum: ['NoPreference', 'Between4And11', 'Between11And18', 'Between21And25', 'Between28And4'],
  type: 'string',
  description: 'Current invoice period for the monthly invoices',
} as const;

export const $MonthlyInvoicePreferenceDto = {
  required: ['meters'],
  type: 'object',
  properties: {
    meters: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetMonthlyInvoicePeriodDtoMeter',
      },
      description: 'Meters to configure the preferences for',
    },
  },
  additionalProperties: false,
  description: 'Body containing Meters to configure the preferences for',
} as const;

export const $MoveAddressDto = {
  required: ['houseNumber', 'municipality', 'postalCode', 'street'],
  type: 'object',
  properties: {
    postalCode: {
      type: 'string',
      description: 'Postal code of the address',
    },
    municipality: {
      type: 'string',
      description: 'Municipality of the address',
    },
    street: {
      type: 'string',
      description: 'Street of the address',
    },
    houseNumber: {
      type: 'string',
      description: 'House number of the address',
    },
    bus: {
      type: 'string',
      description: 'Bus of the address',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Move address',
} as const;

export const $MoveEnergyTypeDto = {
  enum: ['Gas', 'Electricity'],
  type: 'string',
  description: 'Energy types that can get transferred',
} as const;

export const $MoveFileCreatedCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for move file created card',
} as const;

export const $MoveFileDetailResponse = {
  required: [
    'contactDetails',
    'contractDetails',
    'flow',
    'isLocked',
    'lastSubmittedStep',
    'newAddress',
    'oldAddress',
    'status',
    'statusHints',
  ],
  type: 'object',
  properties: {
    status: {
      $ref: '#/components/schemas/MoveFileStatusDto',
    },
    flow: {
      $ref: '#/components/schemas/MoveFlowDto',
    },
    reason: {
      $ref: '#/components/schemas/MoveReasonDto',
    },
    moveRequestId: {
      type: 'string',
      description: 'External request id',
      nullable: true,
    },
    readableMoveRequestId: {
      type: 'string',
      description: 'External request database id',
      nullable: true,
    },
    externallySentAt: {
      type: 'string',
      description:
        'Date at which the move file was externally sent. If the MoveRequestId is null and this is filled in, the async process of sending it to the move tool is still in progress',
      format: 'date-time',
      nullable: true,
    },
    statusHints: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/StatusHintDto',
      },
      description: 'Status hints',
    },
    oldAddress: {
      $ref: '#/components/schemas/MoveViewDetailOldAddressSectionResponse',
    },
    newAddress: {
      $ref: '#/components/schemas/MoveViewDetailNewAddressSectionResponse',
    },
    contactDetails: {
      $ref: '#/components/schemas/MoveViewDetailContactDetailsSectionResponse',
    },
    contractDetails: {
      $ref: '#/components/schemas/MoveViewDetailContractDetailsSectionResponse',
    },
    lastSubmittedStep: {
      $ref: '#/components/schemas/MoveStepDto',
    },
    nextStep: {
      $ref: '#/components/schemas/MoveStepDto',
    },
    isLocked: {
      type: 'boolean',
      description: 'Is move file locked',
    },
  },
  additionalProperties: false,
  description: 'Details of the move file',
} as const;

export const $MoveFileStatusDto = {
  enum: ['Incomplete', 'InProgress', 'Closed', 'Cancelled', 'None'],
  type: 'string',
  description: 'Status of the move file',
} as const;

export const $MoveFlowDto = {
  enum: ['ContinueFlow', 'CancelFlow'],
  type: 'string',
  description: 'For which flow the move was initiated for',
} as const;

export const $MoveReasonDto = {
  enum: [
    'MoveAndKeepEneco',
    'MoveInWithSomeoneElse',
    'MoveIntoResidentialCareCenter',
    'MoveToOtherCountry',
    'MoveAndLeaveEneco',
    'Other',
  ],
  type: 'string',
  description: 'Reasons why people initiate a move',
} as const;

export const $MoveRegisterDto = {
  required: ['directionTypeCode', 'timeframeTypeCode'],
  type: 'object',
  properties: {
    timeframeTypeCode: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    directionTypeCode: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
    meterReading: {
      type: 'number',
      description: 'Meter reading',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'A meter register',
} as const;

export const $MoveStepDto = {
  enum: [
    'MoveReasons',
    'Eod',
    'NewAddress',
    'NewAddressKeyTransfer',
    'OldAddressKeyTransfer',
    'ConfirmationOverview',
    'Done',
    'OldAddressMeters',
    'CorrespondenceAddress',
    'EodNewAddress',
    'EodOldAddress',
  ],
  type: 'string',
  description: 'Collection of move file steps',
} as const;

export const $MoveViewDetailAddressMeterResponse = {
  required: ['energyType', 'isDigital', 'registers'],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/MoveEnergyTypeDto',
    },
    ean: {
      type: 'string',
      description: 'EAN of the meter',
      nullable: true,
    },
    meterNumber: {
      type: 'string',
      description: 'Meter number',
      nullable: true,
    },
    isDigital: {
      type: 'boolean',
      description: 'Is digital meter',
    },
    registers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MoveRegisterDto',
      },
      description: 'Registers linked to the meter',
    },
    isSealed: {
      type: 'boolean',
      description: 'Whether meters are sealed, set by PreSwitch Light',
      nullable: true,
    },
    hasSolarPanels: {
      type: 'boolean',
      description: 'Whether the meter has solar panels',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains information about a meter',
} as const;

export const $MoveViewDetailContactDetailsSectionResponse = {
  type: 'object',
  properties: {
    customCorrespondenceAddress: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
    contactCorrespondenceAddress: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
    selectedCorrespondenceAddress: {
      $ref: '#/components/schemas/SelectedCorrespondenceAddressDto',
    },
    correspondenceDate: {
      type: 'string',
      description: 'Correspondence date',
      format: 'date',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains contact level information',
} as const;

export const $MoveViewDetailContactResponse = {
  type: 'object',
  properties: {
    representation: {
      $ref: '#/components/schemas/Representation',
    },
    firstName: {
      type: 'string',
      description: 'First name',
      nullable: true,
    },
    lastName: {
      type: 'string',
      description: 'Last name',
      nullable: true,
    },
    phoneNumber: {
      type: 'string',
      description: 'Phone number',
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'Email',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains contact information of the old address',
} as const;

export const $MoveViewDetailContractDetailsSectionResponse = {
  required: ['firstName', 'lastName'],
  type: 'object',
  properties: {
    firstName: {
      type: 'string',
      description: 'First name',
    },
    lastName: {
      type: 'string',
      description: 'Last name',
    },
  },
  additionalProperties: false,
  description: 'Contains contract level information',
} as const;

export const $MoveViewDetailNewAddressSectionResponse = {
  required: ['contact', 'isLocked', 'meters', 'status'],
  type: 'object',
  properties: {
    status: {
      $ref: '#/components/schemas/MoveFileStatusDto',
    },
    newAddress: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
    deliveryDate: {
      type: 'string',
      description: 'Delivery date',
      format: 'date-time',
      nullable: true,
    },
    vacancy: {
      type: 'string',
      description: 'Vacancy date',
      format: 'date-time',
      nullable: true,
    },
    eod: {
      $ref: '#/components/schemas/EODFileUploadResponse',
    },
    meters: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MoveViewDetailAddressMeterResponse',
      },
      description: 'Collection of meter details',
    },
    contact: {
      $ref: '#/components/schemas/MoveViewDetailContactResponse',
    },
    isLocked: {
      type: 'boolean',
      description: 'Is the new address section locked',
    },
    initiatingLeavingCustomerDate: {
      type: 'string',
      description: 'Initiating leaving customer date set PreSwitch light',
      format: 'date',
      nullable: true,
    },
    suggestedEans: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SuggestedEanResponse',
      },
      description: 'List of the suggested EANs',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Detail section of new address',
} as const;

export const $MoveViewDetailOldAddressSectionResponse = {
  required: ['contact', 'isLocked', 'meters', 'status'],
  type: 'object',
  properties: {
    status: {
      $ref: '#/components/schemas/MoveFileStatusDto',
    },
    oldAddress: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
    keyTransfer: {
      type: 'string',
      description: 'Date of key transfer',
      format: 'date-time',
      nullable: true,
    },
    vacancy: {
      type: 'string',
      description: 'Vacancy date',
      format: 'date-time',
      nullable: true,
    },
    eod: {
      $ref: '#/components/schemas/EODFileUploadResponse',
    },
    meters: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MoveViewDetailAddressMeterResponse',
      },
      description: 'Collection of meter details',
    },
    contact: {
      $ref: '#/components/schemas/MoveViewDetailContactResponse',
    },
    isLocked: {
      type: 'boolean',
      description: 'Is the old address section locked',
    },
  },
  additionalProperties: false,
  description: 'Detail section of old address',
} as const;

export const $NextBestActionBlockDto = {
  enum: ['Pay', 'Adv', 'Usage', 'Sit', 'Eng', 'Pers', 'Any'],
  type: 'string',
  description: 'Available blocks for next best actions',
} as const;

export const $NextBestActionCardResponse = {
  required: ['block', 'key'],
  type: 'object',
  properties: {
    key: {
      enum: [
        'MoveFileCreated',
        'ActiveProducts',
        'ConfigureItsMe',
        'IntermediateSettlementBillInclReason',
        'PaymentPlanInstallment',
        'PayInvoice',
        'ReferToAccountNumberIfRefund',
        'PushDirectDebit',
        'NoOpenAmount',
        'AdvanceAmountChanged',
        'CurrentAdvanceAmountVsRecommendedAdvanceAmount',
        'ShowUsage',
        'CompleteMoveFile',
        'PaymentMethodChangedDueToFailedDirectDebit',
        'ProductConfirmation',
        'ComfortBonus',
        'ShowPersonalInfo',
        'Fallback',
        'ThankYou',
        'OrderStatus',
        'ProgressTimeline',
        'BrandBenefits',
        'Faq',
        'AnticipationAnnouncement',
        'DeliveryCountdown',
        'MarketingProposition',
        'CompletedProgressTimeline',
        'PreDeliveryFAQ',
        'MonthlyBilling',
        'BudgetMeterNotification',
      ],
      type: 'string',
      description: 'Key of the card',
    },
    block: {
      $ref: '#/components/schemas/NextBestActionBlockDto',
    },
  },
  additionalProperties: false,
  description:
    'Next Best Action Card. Possible key values: MoveFileCreated, ActiveProducts, ConfigureItsMe, IntermediateSettlementBillInclReason, PaymentPlanInstallment, PayInvoice, ReferToAccountNumberIfRefund, PushDirectDebit, NoOpenAmount, AdvanceAmountChanged, CurrentAdvanceAmountVsRecommendedAdvanceAmount, ShowUsage, CompleteMoveFile, PaymentMethodChangedDueToFailedDirectDebit, ProductConfirmation, ComfortBonus, ShowPersonalInfo, Fallback, ThankYou, OrderStatus, ProgressTimeline, BrandBenefits, Faq, AnticipationAnnouncement, DeliveryCountdown, MarketingProposition, CompletedProgressTimeline, PreDeliveryFAQ, MonthlyBilling, BudgetMeterNotification',
  discriminator: {
    propertyName: 'key',
    mapping: {
      MoveFileCreated: '#/components/schemas/MoveFileCreatedCardResponse',
      ActiveProducts: '#/components/schemas/ActiveProductsCardResponse',
      ConfigureItsMe: '#/components/schemas/ConfigureItsMeCardResponse',
      IntermediateSettlementBillInclReason: '#/components/schemas/IntermediateSettlementBillInclReasonCardResponse',
      PaymentPlanInstallment: '#/components/schemas/PaymentPlanInstallmentCardResponse',
      PayInvoice: '#/components/schemas/PayInvoiceCardResponse',
      ReferToAccountNumberIfRefund: '#/components/schemas/ReferToAccountNumberIfRefundCardResponse',
      PushDirectDebit: '#/components/schemas/PushDirectDebitCardResponse',
      NoOpenAmount: '#/components/schemas/NoOpenAmountCardResponse',
      AdvanceAmountChanged: '#/components/schemas/AdvanceAmountChangedCardResponse',
      CurrentAdvanceAmountVsRecommendedAdvanceAmount:
        '#/components/schemas/CurrentAdvanceAmountVsRecommendedAdvanceAmountCardResponse',
      ShowUsage: '#/components/schemas/ShowUsageCardResponse',
      CompleteMoveFile: '#/components/schemas/CompleteMoveFileCardResponse',
      PaymentMethodChangedDueToFailedDirectDebit:
        '#/components/schemas/PaymentMethodChangedDueToFailedDirectDebitCardResponse',
      ProductConfirmation: '#/components/schemas/ProductConfirmationCardResponse',
      ComfortBonus: '#/components/schemas/ComfortBonusCardResponse',
      ShowPersonalInfo: '#/components/schemas/ShowPersonalInfoCardResponse',
      Fallback: '#/components/schemas/FallbackCardResponse',
      ThankYou: '#/components/schemas/ThankYouCardResponse',
      OrderStatus: '#/components/schemas/OrderStatusCardResponse',
      ProgressTimeline: '#/components/schemas/ProgressTimelineCardResponse',
      BrandBenefits: '#/components/schemas/BrandBenefitsCardResponse',
      Faq: '#/components/schemas/FaqCardResponse',
      AnticipationAnnouncement: '#/components/schemas/AnticipationAnnouncementCardResponse',
      DeliveryCountdown: '#/components/schemas/DeliveryCountdownCardResponse',
      MarketingProposition: '#/components/schemas/MarketingPropositionCardResponse',
      CompletedProgressTimeline: '#/components/schemas/CompletedProgressTimelineCardResponse',
      PreDeliveryFAQ: '#/components/schemas/PreDeliveryFAQCardResponse',
      MonthlyBilling: '#/components/schemas/MonthlyBillingCardResponse',
      BudgetMeterNotification: '#/components/schemas/BudgetMeterNotificationCardResponse',
    },
  },
} as const;

export const $NextBestActionResponse = {
  required: ['cards', 'errors'],
  type: 'object',
  properties: {
    cards: {
      type: 'array',
      items: {
        oneOf: [
          {
            $ref: '#/components/schemas/ActiveProductsCardResponse',
          },
          {
            $ref: '#/components/schemas/AdvanceAmountChangedCardResponse',
          },
          {
            $ref: '#/components/schemas/AnticipationAnnouncementCardResponse',
          },
          {
            $ref: '#/components/schemas/BrandBenefitsCardResponse',
          },
          {
            $ref: '#/components/schemas/BudgetMeterNotificationCardResponse',
          },
          {
            $ref: '#/components/schemas/ComfortBonusCardResponse',
          },
          {
            $ref: '#/components/schemas/CompletedProgressTimelineCardResponse',
          },
          {
            $ref: '#/components/schemas/CompleteMoveFileCardResponse',
          },
          {
            $ref: '#/components/schemas/ConfigureItsMeCardResponse',
          },
          {
            $ref: '#/components/schemas/CurrentAdvanceAmountVsRecommendedAdvanceAmountCardResponse',
          },
          {
            $ref: '#/components/schemas/DeliveryCountdownCardResponse',
          },
          {
            $ref: '#/components/schemas/FallbackCardResponse',
          },
          {
            $ref: '#/components/schemas/FaqCardResponse',
          },
          {
            $ref: '#/components/schemas/IntermediateSettlementBillInclReasonCardResponse',
          },
          {
            $ref: '#/components/schemas/MarketingPropositionCardResponse',
          },
          {
            $ref: '#/components/schemas/MonthlyBillingCardResponse',
          },
          {
            $ref: '#/components/schemas/MoveFileCreatedCardResponse',
          },
          {
            $ref: '#/components/schemas/NoOpenAmountCardResponse',
          },
          {
            $ref: '#/components/schemas/OrderStatusCardResponse',
          },
          {
            $ref: '#/components/schemas/PayInvoiceCardResponse',
          },
          {
            $ref: '#/components/schemas/PaymentMethodChangedDueToFailedDirectDebitCardResponse',
          },
          {
            $ref: '#/components/schemas/PaymentPlanInstallmentCardResponse',
          },
          {
            $ref: '#/components/schemas/PreDeliveryFAQCardResponse',
          },
          {
            $ref: '#/components/schemas/ProductConfirmationCardResponse',
          },
          {
            $ref: '#/components/schemas/ProgressTimelineCardResponse',
          },
          {
            $ref: '#/components/schemas/PushDirectDebitCardResponse',
          },
          {
            $ref: '#/components/schemas/ReferToAccountNumberIfRefundCardResponse',
          },
          {
            $ref: '#/components/schemas/ShowPersonalInfoCardResponse',
          },
          {
            $ref: '#/components/schemas/ShowUsageCardResponse',
          },
          {
            $ref: '#/components/schemas/ThankYouCardResponse',
          },
        ],
        description:
          'Next Best Action Card. Possible key values: MoveFileCreated, ActiveProducts, ConfigureItsMe, IntermediateSettlementBillInclReason, PaymentPlanInstallment, PayInvoice, ReferToAccountNumberIfRefund, PushDirectDebit, NoOpenAmount, AdvanceAmountChanged, CurrentAdvanceAmountVsRecommendedAdvanceAmount, ShowUsage, CompleteMoveFile, PaymentMethodChangedDueToFailedDirectDebit, ProductConfirmation, ComfortBonus, ShowPersonalInfo, Fallback, ThankYou, OrderStatus, ProgressTimeline, BrandBenefits, Faq, AnticipationAnnouncement, DeliveryCountdown, MarketingProposition, CompletedProgressTimeline, PreDeliveryFAQ, MonthlyBilling, BudgetMeterNotification',
        discriminator: {
          propertyName: 'key',
          mapping: {
            MoveFileCreated: '#/components/schemas/MoveFileCreatedCardResponse',
            ActiveProducts: '#/components/schemas/ActiveProductsCardResponse',
            ConfigureItsMe: '#/components/schemas/ConfigureItsMeCardResponse',
            IntermediateSettlementBillInclReason:
              '#/components/schemas/IntermediateSettlementBillInclReasonCardResponse',
            PaymentPlanInstallment: '#/components/schemas/PaymentPlanInstallmentCardResponse',
            PayInvoice: '#/components/schemas/PayInvoiceCardResponse',
            ReferToAccountNumberIfRefund: '#/components/schemas/ReferToAccountNumberIfRefundCardResponse',
            PushDirectDebit: '#/components/schemas/PushDirectDebitCardResponse',
            NoOpenAmount: '#/components/schemas/NoOpenAmountCardResponse',
            AdvanceAmountChanged: '#/components/schemas/AdvanceAmountChangedCardResponse',
            CurrentAdvanceAmountVsRecommendedAdvanceAmount:
              '#/components/schemas/CurrentAdvanceAmountVsRecommendedAdvanceAmountCardResponse',
            ShowUsage: '#/components/schemas/ShowUsageCardResponse',
            CompleteMoveFile: '#/components/schemas/CompleteMoveFileCardResponse',
            PaymentMethodChangedDueToFailedDirectDebit:
              '#/components/schemas/PaymentMethodChangedDueToFailedDirectDebitCardResponse',
            ProductConfirmation: '#/components/schemas/ProductConfirmationCardResponse',
            ComfortBonus: '#/components/schemas/ComfortBonusCardResponse',
            ShowPersonalInfo: '#/components/schemas/ShowPersonalInfoCardResponse',
            Fallback: '#/components/schemas/FallbackCardResponse',
            ThankYou: '#/components/schemas/ThankYouCardResponse',
            OrderStatus: '#/components/schemas/OrderStatusCardResponse',
            ProgressTimeline: '#/components/schemas/ProgressTimelineCardResponse',
            BrandBenefits: '#/components/schemas/BrandBenefitsCardResponse',
            Faq: '#/components/schemas/FaqCardResponse',
            AnticipationAnnouncement: '#/components/schemas/AnticipationAnnouncementCardResponse',
            DeliveryCountdown: '#/components/schemas/DeliveryCountdownCardResponse',
            MarketingProposition: '#/components/schemas/MarketingPropositionCardResponse',
            CompletedProgressTimeline: '#/components/schemas/CompletedProgressTimelineCardResponse',
            PreDeliveryFAQ: '#/components/schemas/PreDeliveryFAQCardResponse',
            MonthlyBilling: '#/components/schemas/MonthlyBillingCardResponse',
            BudgetMeterNotification: '#/components/schemas/BudgetMeterNotificationCardResponse',
          },
        },
      },
      description: 'Cards to show',
    },
    errors: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/Error',
      },
      description: 'Errors while fetching data for cards',
    },
  },
  additionalProperties: false,
  description: `Represents the response for the next best action request, encapsulating
a collection of action cards and any related errors.`,
} as const;

export const $NoOpenAmountCardDetailsResponse = {
  required: ['summary'],
  type: 'object',
  properties: {
    summary: {
      $ref: '#/components/schemas/GetInvoicesOpenAmountSummaryResponse',
    },
  },
  additionalProperties: false,
  description: `Represents the details of a "No Open amount" card in the Next Best Actions system.
The card provides information about the total open invoice amount and the number of open invoices.`,
} as const;

export const $NoOpenAmountCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/NoOpenAmountCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for no open amount card',
} as const;

export const $OnlinePaymentCallbackRequest = {
  required: ['pomDocumentId', 'responseCode'],
  type: 'object',
  properties: {
    responseCode: {
      type: 'string',
      description: 'The response code of the online payment processor',
    },
    pomDocumentId: {
      type: 'string',
      description: 'Identifier of the online payment processor',
    },
  },
  additionalProperties: false,
  description: 'Represents the request object for an online payment callback operation',
} as const;

export const $OnlinePaymentUrlResponse = {
  required: ['url'],
  type: 'object',
  properties: {
    url: {
      type: 'string',
      description: 'The URL for the online payment',
    },
  },
  additionalProperties: false,
  description: 'Represents a response containing the URL for an online payment',
} as const;

export const $OpenAmountItemResponse = {
  required: ['amount', 'invoiceNumber', 'invoiceType', 'status'],
  type: 'object',
  properties: {
    invoiceNumber: {
      type: 'string',
      description: 'The unique identifier of the invoice',
    },
    status: {
      $ref: '#/components/schemas/InvoiceStatusDto',
    },
    amount: {
      type: 'number',
      description: 'The total outstanding amount for the invoice',
      format: 'decimal',
    },
    invoiceType: {
      $ref: '#/components/schemas/InvoiceTypeDto',
    },
    dueDate: {
      type: 'string',
      description: 'Date when the invoice should be paid',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents an item with open amount details associated with an invoice.',
} as const;

export const $OrderCompanyDetailsDto = {
  required: ['companyName', 'companyNumberIsBeingRequested', 'companyType', 'hasCoContracting'],
  type: 'object',
  properties: {
    companyName: {
      type: 'string',
      description: 'The legal name of the company',
    },
    companyType: {
      $ref: '#/components/schemas/CompanyFormatTypeDto',
    },
    companyNumber: {
      type: 'integer',
      description: 'The official company registration number (deprecated)',
      format: 'int32',
      nullable: true,
    },
    vatNumber: {
      type: 'string',
      description: 'The official company registration number (optional)',
      nullable: true,
    },
    companyNumberIsBeingRequested: {
      type: 'boolean',
      description: 'Indicates whether a company registration number is in the process of being requested',
    },
    hasCoContracting: {
      type: 'boolean',
      description: 'User has co contracting',
    },
    subjectToVAT: {
      type: 'boolean',
      description: 'Is user subjected to VAT',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Request model for company details of a business customer during order creation',
} as const;

export const $OrderCustomer = {
  type: 'object',
  properties: {
    billingAddress: {
      $ref: '#/components/schemas/Address',
    },
    companyName: {
      type: 'string',
      description: 'The companyName property',
      nullable: true,
    },
    customerId: {
      type: 'string',
      description: 'The customerId property',
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'The email property',
      nullable: true,
    },
    firstName: {
      type: 'string',
      description: 'The firstName property',
      nullable: true,
    },
    lastName: {
      type: 'string',
      description: 'The lastName property',
      nullable: true,
    },
    phone: {
      type: 'string',
      description: 'The phone property',
      nullable: true,
    },
    vatNumber: {
      type: 'string',
      description: 'The vatNumber property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Customer',
} as const;

export const $OrderCustomerInfo = {
  type: 'object',
  properties: {
    activeFeatures: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'The activeFeatures property',
      nullable: true,
    },
    billingAddress: {
      $ref: '#/components/schemas/Address',
    },
    companyName: {
      type: 'string',
      description: 'The companyName property',
      nullable: true,
    },
    customerId: {
      type: 'string',
      description: 'The Eneco ID of the customer',
      nullable: true,
    },
    dongleOrderDate: {
      type: 'string',
      description: 'The dongleOrderDate property',
      format: 'date-time',
      nullable: true,
    },
    email: {
      type: 'string',
      description: 'The email property',
      nullable: true,
    },
    firstName: {
      type: 'string',
      description: 'The firstName property',
      nullable: true,
    },
    hasUnpaidInvoices: {
      type: 'boolean',
      description: 'The hasUnpaidInvoices property',
      nullable: true,
    },
    lastName: {
      type: 'string',
      description: 'The lastName property',
      nullable: true,
    },
    oldFeatures: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'The oldFeatures property',
      nullable: true,
    },
    phone: {
      type: 'string',
      description: 'The phone property',
      nullable: true,
    },
    smartStart: {
      type: 'string',
      description: 'The smartStart property',
      format: 'date-time',
      nullable: true,
    },
    smartStatus: {
      $ref: '#/components/schemas/OrderCustomerInfoSmartStatus',
    },
    vatNumber: {
      type: 'string',
      description: 'The vatNumber property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Order customer info.',
} as const;

export const $OrderCustomerInfoSmartStatus = {
  enum: ['Unknown', 'New', 'InTrial', 'Future', 'Active', 'Paused', 'NonRenewing', 'Cancelled', 'Archived'],
  type: 'string',
  description: 'Order customer info smart status.',
} as const;

export const $OrderElectricityDto = {
  required: [
    'deliveryStartDateAsap',
    'hasExclusiveNightMeter',
    'meterType',
    'readings',
    'serviceComponent',
    'switchReason',
  ],
  type: 'object',
  properties: {
    switchReason: {
      $ref: '#/components/schemas/OrderSwitchReasonDto',
    },
    ean: {
      type: 'string',
      description: 'The European Article Number (EAN) for the electricity connection',
      nullable: true,
    },
    meterNumber: {
      type: 'string',
      description: 'The physical meter identification number for electricity consumption tracking',
      nullable: true,
    },
    hasExclusiveNightMeter: {
      type: 'boolean',
      description: 'Rhe customer has an exclusive night meter',
    },
    exclusiveNightEan: {
      type: 'string',
      description:
        'The exclusive night time EAN for dual-rate electricity connections, or null if single-rate connection',
      nullable: true,
    },
    exclusiveNightMeterNumber: {
      type: 'string',
      description: 'The exclusive night meter meterNumber if one exists',
      nullable: true,
    },
    deliveryStartDate: {
      type: 'string',
      description: 'The date when electricity delivery should start',
      format: 'date',
      nullable: true,
    },
    deliveryStartDateAsap: {
      type: 'boolean',
      description: 'Customer wants the delivery to be ASAP',
    },
    readings: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/OrderMeterReadingDto',
      },
      description: 'Collection of current meter readings for different register types',
    },
    solarPanels: {
      $ref: '#/components/schemas/OrderSolarPanelsDto',
    },
    meterType: {
      $ref: '#/components/schemas/PriceSimulationMeterTypeDto',
    },
    serviceComponent: {
      $ref: '#/components/schemas/ElectricityServiceComponentDto',
    },
  },
  additionalProperties: false,
  description: 'Represents electricity service configuration including meter information and solar panel details',
} as const;

export const $OrderElectricitySolarPanelsDto = {
  required: ['hasSolarPanels'],
  type: 'object',
  properties: {
    hasSolarPanels: {
      type: 'boolean',
      description: 'Indicates whether solar panels are installed',
    },
    installationDate: {
      $ref: '#/components/schemas/SolarPanelInstallationDateDto',
    },
    totalPower: {
      type: 'number',
      description: 'The total power capacity in watts',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Information about the solar panel installation',
} as const;

export const $OrderFinalizedDto = {
  required: ['dataProcessingAccepted', 'finalizedAt', 'privacyPolicyAccepted'],
  type: 'object',
  properties: {
    gezinsbondNumber: {
      type: 'string',
      description: 'Optional Gezinsbond membership number for discounts',
      nullable: true,
    },
    privacyPolicyAccepted: {
      type: 'boolean',
      description: 'Indicates whether the customer has accepted the privacy policy',
    },
    dataProcessingAccepted: {
      type: 'boolean',
      description: 'Indicates whether the customer has accepted data processing terms',
    },
    finalizedAt: {
      type: 'string',
      description: 'Timestamp when the order was finalized',
      format: 'date-time',
    },
  },
  additionalProperties: false,
  description: 'Represents the finalization details of an order',
} as const;

export const $OrderGasDto = {
  type: 'object',
  properties: {
    switchReason: {
      $ref: '#/components/schemas/OrderSwitchReasonDto',
    },
    deliveryStartDate: {
      type: 'string',
      description: 'The date when gas delivery should start',
      format: 'date',
      nullable: true,
    },
    deliveryStartDateAsap: {
      type: 'boolean',
      description: 'Delivery should start asap',
      nullable: true,
    },
    ean: {
      type: 'string',
      description: 'The European Article Number (EAN) for the gas connection',
      nullable: true,
    },
    meterNumber: {
      type: 'string',
      description: 'The physical meter identification number for gas consumption tracking',
      nullable: true,
    },
    meterReading: {
      $ref: '#/components/schemas/OrderMeterReadingDto',
    },
    maintenance: {
      $ref: '#/components/schemas/OrderGasMaintenanceDto',
    },
  },
  additionalProperties: false,
  description: 'Represents gas service configuration including delivery details and maintenance information',
} as const;

export const $OrderGasMaintenanceDto = {
  required: ['brand', 'buildingOlderThan10Years'],
  type: 'object',
  properties: {
    brand: {
      $ref: '#/components/schemas/BoilerBrandDto',
    },
    buildingOlderThan10Years: {
      type: 'boolean',
      description: 'Indicates whether the building is older than 10 years',
    },
    installationStatus: {
      $ref: '#/components/schemas/InstallationStatusDto',
    },
    installationDate: {
      type: 'string',
      description: 'The date when the gas appliance was installed',
      format: 'date',
      nullable: true,
    },
    boilerServiceDate: {
      type: 'string',
      description: 'The most recent date when the boiler was serviced or maintained',
      format: 'date',
      nullable: true,
    },
    maintenanceStartDate: {
      type: 'string',
      description: 'The start date for ongoing maintenance coverage',
      format: 'date',
      nullable: true,
    },
    maintenanceStartAsap: {
      type: 'boolean',
      description: 'Maintenance starts ASAP',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains maintenance and service information for gas appliances and installations',
} as const;

export const $OrderInfoRequest = {
  type: 'object',
  properties: {
    campaign: {
      type: 'string',
      description: 'The campaign property',
      nullable: true,
    },
    cancelUrl: {
      type: 'string',
      description: 'The cancelUrl property',
      nullable: true,
    },
    couponCode: {
      type: 'string',
      description: 'The couponCode property',
      nullable: true,
    },
    currencyCode: {
      type: 'string',
      description: 'The currencyCode property',
      nullable: true,
    },
    customer: {
      $ref: '#/components/schemas/OrderCustomer',
    },
    locale: {
      type: 'string',
      description: 'The locale property',
      nullable: true,
    },
    orderReference: {
      type: 'string',
      description: 'The orderReference property',
      nullable: true,
    },
    products: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoOrderProduct',
      },
      description: 'The products property',
      nullable: true,
    },
    redirectUrl: {
      type: 'string',
      description: 'The redirectUrl property',
      nullable: true,
    },
    shippingAddress: {
      $ref: '#/components/schemas/Address',
    },
  },
  additionalProperties: false,
  description: 'Order info request',
} as const;

export const $OrderInitiatedResponse = {
  required: ['orderId'],
  type: 'object',
  properties: {
    orderId: {
      type: 'string',
      description: 'The unique identifier for the initiated order.',
      format: 'uuid',
    },
  },
  additionalProperties: false,
  description: 'Represents the response for initiating an order, containing the ID of the initiated order.',
} as const;

export const $OrderMeterReadingDto = {
  required: ['meterTimeFrameType', 'value'],
  type: 'object',
  properties: {
    meterTimeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    value: {
      type: 'number',
      description: 'The numerical reading from the meter as a string',
      format: 'decimal',
    },
  },
  additionalProperties: false,
  description: 'Represents a single meter reading for a specific meter register type',
} as const;

export const $OrderPaymentDto = {
  required: ['acceptedMandate', 'iban', 'paymentMethod'],
  type: 'object',
  properties: {
    paymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
    iban: {
      type: 'string',
      description: 'International Bank Account Number for payment processing',
    },
    acceptedMandate: {
      type: 'boolean',
      description: 'Indicates whether the customer has accepted the SEPA mandate',
    },
  },
  additionalProperties: false,
  description: 'Represents payment details for an order',
} as const;

export const $OrderPersonalDetailsDto = {
  required: ['dateOfBirth', 'email', 'firstName', 'language', 'lastName', 'phoneNumber', 'representation'],
  type: 'object',
  properties: {
    representation: {
      $ref: '#/components/schemas/Representation',
    },
    firstName: {
      type: 'string',
      description: "The customer's first name",
    },
    lastName: {
      type: 'string',
      description: "The customer's last name",
    },
    dateOfBirth: {
      type: 'string',
      description: "The customer's date of birth",
      format: 'date',
    },
    phoneNumber: {
      type: 'string',
      description: "The customer's contact phone number",
    },
    email: {
      type: 'string',
      description: "The customer's email address",
    },
    language: {
      $ref: '#/components/schemas/CustomerLanguageDto',
    },
    receiveInvoicesThroughMail: {
      type: 'boolean',
      description: 'Whether the customer opts to receive invoices through mail. Null means no preference specified',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Request model for personal details of a customer during order creation',
} as const;

export const $OrderProductTypeDto = {
  enum: ['Commodity', 'NonCommodity'],
  type: 'string',
  description: 'Represents the type of product associated with an order.',
} as const;

export const $OrderPromoDto = {
  required: ['energyProduct', 'promoCode'],
  type: 'object',
  properties: {
    promoCode: {
      type: 'string',
      description: 'PromoId',
    },
    energyProduct: {
      $ref: '#/components/schemas/PriceSimulationEnergyTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Promo of Order',
} as const;

export const $OrderSolarPanelsDto = {
  required: ['hasSolarPanels'],
  type: 'object',
  properties: {
    hasSolarPanels: {
      type: 'boolean',
      description: 'Indicates whether solar panels are installed at the property',
    },
    installationDate: {
      $ref: '#/components/schemas/SolarPanelInstallationDateDto',
    },
    totalPower: {
      type: 'number',
      description: 'The total power output capacity in watts or kilowatts',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents solar panel installation details for energy production tracking',
} as const;

export const $OrderStatusCardDetailsResponse = {
  required: ['address'],
  type: 'object',
  properties: {
    address: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    gasEan: {
      type: 'string',
      description: 'Gas EAN',
      nullable: true,
    },
    electricityEan: {
      type: 'string',
      description: 'Electricity EAN',
      nullable: true,
    },
    startDate: {
      type: 'string',
      description: 'Start date for the order',
      format: 'date',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Details of an order status',
} as const;

export const $OrderStatusCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/OrderStatusCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response model for order status card in next best action flow',
} as const;

export const $OrderStepDto = {
  enum: [
    'ServiceProposalStep',
    'PersonalDetailsStep',
    'DeliveryAddressStep',
    'ElectricityDetailsStep',
    'GasDetailsStep',
    'SelectPaymentMethodStep',
    'OverviewStep',
    'OrderConfirmationStep',
  ],
  type: 'string',
  description: 'Enumeration representing the steps involved in the order management process.',
} as const;

export const $OrderSwitchReasonDto = {
  enum: ['MoveToEneco', 'NewMeterConnection', 'TakeOverMeterConnectionOldInhabitant'],
  type: 'string',
  description: 'Switch reason',
} as const;

export const $OwnerAccountLinkingRequest = {
  required: ['isOwnerReassignmentFlow', 'lastName'],
  type: 'object',
  properties: {
    lastName: {
      type: 'string',
      description: 'Last name of the account',
    },
    alias: {
      type: 'string',
      description: 'Alias for the crm account',
      nullable: true,
    },
    isOwnerReassignmentFlow: {
      type: 'boolean',
    },
  },
  additionalProperties: false,
  description: 'Body containing details to link an owner account',
} as const;

export const $OwnerReassignmentLinkingRequest = {
  required: ['alias', 'sessionToken'],
  type: 'object',
  properties: {
    sessionToken: {
      type: 'string',
      description: 'Session token',
    },
    alias: {
      type: 'string',
      description: 'Alias the user selected',
    },
  },
  additionalProperties: false,
  description: 'Body containing details for a owner reassignment',
} as const;

export const $PayInvoiceCardDetailsResponse = {
  required: ['summary'],
  type: 'object',
  properties: {
    summary: {
      $ref: '#/components/schemas/GetInvoicesOpenAmountSummaryResponse',
    },
  },
  additionalProperties: false,
  description: `Represents the details of a "Pay Invoice" card in the Next Best Actions system.
The card provides information about the total open invoice amount and the number of open invoices.`,
} as const;

export const $PayInvoiceCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/PayInvoiceCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for pay invoice card',
} as const;

export const $PaymentMethodByBillingAccountResponse = {
  required: [
    'billingAccountNumber',
    'currentPaymentMethod',
    'failedDirectDebitCounter',
    'hasDirectDebitRequirement',
    'hasEbillingRequirement',
    'meters',
  ],
  type: 'object',
  properties: {
    billingAccountNumber: {
      type: 'string',
      description: 'Billing account number',
    },
    hasEbillingRequirement: {
      type: 'boolean',
      description:
        'Whether the user currently has an E-billing promo running and has the possibility of losing the promo when changing payment method',
    },
    hasDirectDebitRequirement: {
      type: 'boolean',
      description:
        'Whether the user currently has an Direct Debit promo running and has the possibility of losing the promo when changing payment method',
    },
    currentPaymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
    failedDirectDebitCounter: {
      type: 'integer',
      description: 'Amount of failed transaction attempts to offer the amount through direct debit to the bank',
      format: 'int32',
    },
    iban: {
      type: 'string',
      description: 'IBAN details',
      nullable: true,
    },
    signatureLocation: {
      type: 'string',
      description: 'Location on which signature was made',
      nullable: true,
    },
    signatureDate: {
      type: 'string',
      description: 'Date on which signature was made',
      format: 'date',
      nullable: true,
    },
    mandateId: {
      type: 'string',
      description: 'Mandate identifier',
      nullable: true,
    },
    meters: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/BillingAccountRelatedMeterResponse',
      },
      description: 'Billing account related meters',
    },
  },
  additionalProperties: false,
  description: 'Contains payment method information per Billing account',
} as const;

export const $PaymentMethodChangedDueToFailedDirectDebitCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for payment method changed due to failed direct debit card',
} as const;

export const $PaymentMethodDto = {
  enum: ['DirectDebit', 'BankTransfer', 'DirectDebitExcludingYearlyBill'],
  type: 'string',
  description: 'The way the invoice gets paid',
} as const;

export const $PaymentMethodInfo = {
  type: 'object',
  properties: {
    lastFourDigits: {
      type: 'string',
      description: 'The lastFourDigits property',
      nullable: true,
    },
    methodType: {
      $ref: '#/components/schemas/PaymentMethodType',
    },
    status: {
      $ref: '#/components/schemas/PaymentStatus',
    },
  },
  additionalProperties: false,
  description: 'Payment method information',
} as const;

export const $PaymentMethodResponse = {
  required: ['items'],
  type: 'object',
  properties: {
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PaymentMethodByBillingAccountResponse',
      },
      description: 'Payment methods per billing account',
    },
  },
  additionalProperties: false,
  description: 'Contains payment method information',
} as const;

export const $PaymentMethodType = {
  enum: ['Creditcard', 'Bancontact', 'Other'],
  type: 'string',
  description: 'Payment method type',
} as const;

export const $PaymentPlanDto = {
  required: [
    'amountOfSlices',
    'billingAccountNumber',
    'end',
    'invoices',
    'openAmount',
    'paymentMethod',
    'slices',
    'start',
    'status',
  ],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Id of the payment plan',
      nullable: true,
    },
    start: {
      type: 'string',
      description: 'Start of the payment plan',
      format: 'date',
    },
    end: {
      type: 'string',
      description: 'End of the payment plan',
      format: 'date',
    },
    openAmount: {
      type: 'number',
      description: 'Open amount of the payment plan',
      format: 'decimal',
    },
    amountOfSlices: {
      type: 'integer',
      description: 'Amount of slices in the payment plan',
      format: 'int32',
    },
    slices: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PaymentPlanSliceDto',
      },
      description: 'Slices in the payment plan',
    },
    invoices: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/GetInvoiceDto',
      },
      description: 'Invoices to be paid through the payment plan',
    },
    status: {
      $ref: '#/components/schemas/PaymentPlanStatusDto',
    },
    maxAmountOfSlices: {
      type: 'integer',
      description: 'Max amount of slices of the payment plan',
      format: 'int32',
      nullable: true,
    },
    billingAccountNumber: {
      type: 'string',
      description: 'Billing account for which the payment plan has been created',
    },
    paymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
  },
  additionalProperties: false,
  description: 'A payment plan',
} as const;

export const $PaymentPlanEligibilityConditions = {
  required: [
    'hasDeactivatedPaymentPlanInLastThreeMonths',
    'hasDunning',
    'hasExistingPaymentPlan',
    'hasNoClosingOrYearlyBill',
    'moreThanMaximumAmount',
    'moreThanMinimumAmount',
  ],
  type: 'object',
  properties: {
    hasDeactivatedPaymentPlanInLastThreeMonths: {
      type: 'boolean',
      description: 'Whether there is a deactivated payment plan in the last three months',
    },
    moreThanMinimumAmount: {
      type: 'boolean',
      description: 'Whether the amount is more than the minimum amount',
    },
    moreThanMaximumAmount: {
      type: 'boolean',
      description: 'Whether the amount is more than the maximum amount',
    },
    hasExistingPaymentPlan: {
      type: 'boolean',
      description: 'Whether there is an existing payment plan',
    },
    hasDunning: {
      type: 'boolean',
      description: 'Whether the is a dunning level of 4',
    },
    hasNoClosingOrYearlyBill: {
      type: 'boolean',
      description: 'Whether there is no closing or yearly bill',
    },
  },
  additionalProperties: false,
  description: 'Conditions on which the payment plan eligibility gets determined',
} as const;

export const $PaymentPlanEligibilityResponse = {
  required: ['billingAccounts'],
  type: 'object',
  properties: {
    billingAccounts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/BillingAccountPaymentPlanEligibilityDto',
      },
      description: 'List of billing accounts with eligibility and conditions',
    },
  },
  additionalProperties: false,
  description: 'Body containing per-billing-account information on whether a user can request a payment plan or not',
} as const;

export const $PaymentPlanInstallmentCardDetailsResponse = {
  type: 'object',
  properties: {
    paymentPlan: {
      $ref: '#/components/schemas/PaymentPlanDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the details of the payment plan installment card.',
} as const;

export const $PaymentPlanInstallmentCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/PaymentPlanInstallmentCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for payment plan installment card',
} as const;

export const $PaymentPlanSliceDto = {
  required: ['amount', 'end', 'start'],
  type: 'object',
  properties: {
    start: {
      type: 'string',
      description: 'Start of the slice',
      format: 'date',
    },
    end: {
      type: 'string',
      description: 'End of the slice',
      format: 'date',
    },
    amount: {
      type: 'number',
      description: 'Amount to be paid for the slice',
      format: 'decimal',
    },
    paid: {
      type: 'boolean',
      description: 'Whether the slice has been paid or not',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Slice of a payment plan',
} as const;

export const $PaymentPlanStatusDto = {
  enum: ['Activated', 'Revoked', 'Completed', 'Simulation', 'Pending'],
  type: 'string',
  description: 'Current status of the payment plan',
} as const;

export const $PaymentPlansResponse = {
  required: ['paymentPlans'],
  type: 'object',
  properties: {
    paymentPlans: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PaymentPlanDto',
      },
      description: 'Payment plans',
    },
  },
  additionalProperties: false,
  description: 'Response containing one or more payment plans',
} as const;

export const $PaymentStatus = {
  enum: ['Valid', 'Expiring', 'Expired', 'Invalid', 'PendingVerification'],
  type: 'string',
  description: 'Payment status',
} as const;

export const $PeakAverageResponse = {
  required: ['average'],
  type: 'object',
  properties: {
    average: {
      type: 'number',
      description: 'Average value',
      format: 'decimal',
    },
  },
  additionalProperties: false,
  description: 'Response containing the average value of peak data.',
} as const;

export const $PeakPeriodDto = {
  required: ['date', 'periodEnd', 'periodStart', 'value'],
  type: 'object',
  properties: {
    periodStart: {
      type: 'string',
      description: 'Start of the period',
      format: 'date-time',
    },
    periodEnd: {
      type: 'string',
      description: 'End of the period',
      format: 'date-time',
    },
    date: {
      type: 'string',
      description: 'Time of the actual peak value',
      format: 'date-time',
    },
    value: {
      type: 'number',
      description: 'Value measured',
      format: 'decimal',
    },
  },
  additionalProperties: false,
  description: 'Period of peak values',
} as const;

export const $PeakResponse = {
  required: ['consumptionType', 'endDate', 'periods', 'startDate', 'timeFrame', 'unitOfMeasure'],
  type: 'object',
  properties: {
    consumptionType: {
      $ref: '#/components/schemas/ConsumptionTypeDto',
    },
    timeFrame: {
      $ref: '#/components/schemas/TimeFrameDto',
    },
    startDate: {
      type: 'string',
      description: 'The start date of the current view period',
      format: 'date',
    },
    endDate: {
      type: 'string',
      description: 'The end date of the current view period',
      format: 'date',
    },
    unitOfMeasure: {
      $ref: '#/components/schemas/UnitOfMeasureDto',
    },
    periods: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PeakPeriodDto',
      },
      description: 'Periods in which peak values are available',
    },
  },
  additionalProperties: false,
  description: 'Response containing peak values',
} as const;

export const $PlanPriceModel = {
  enum: ['FixedAmount', 'PerUnit', 'Tiered', 'PerUnitMetered', 'TieredMetered', 'FixedPercentage'],
  type: 'string',
  description: 'Plan price model',
} as const;

export const $PreDeliveryFAQCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Pre-Delivery FAQ card',
} as const;

export const $PreswitchBasicAddressDto = {
  required: ['buildingNumber', 'city', 'country', 'language', 'postcode', 'street'],
  type: 'object',
  properties: {
    city: {
      type: 'string',
      description: 'City name of the address',
    },
    country: {
      type: 'string',
      description: 'Country of the address',
    },
    postcode: {
      type: 'string',
      description: 'Postal code of the address',
    },
    street: {
      type: 'string',
      description: 'Street name of the address',
    },
    buildingNumber: {
      type: 'string',
      description: 'Building number of the address',
    },
    language: {
      $ref: '#/components/schemas/PreswitchLanguageCodeDto',
    },
  },
  additionalProperties: false,
  description: 'Represents an address associated with a preswitch basic record',
} as const;

export const $PreswitchBasicRecordDto = {
  required: ['addresses', 'gridAccessProviderId', 'headpoint', 'id', 'utilityType'],
  type: 'object',
  properties: {
    id: {
      type: 'string',
      description: 'Unique identifier of the preswitch basic record',
      format: 'uuid',
    },
    headpoint: {
      type: 'string',
      description: 'The headpoint (EAN) identifier for the energy connection',
    },
    utilityType: {
      $ref: '#/components/schemas/UtilityTypeDto',
    },
    serviceComponent: {
      $ref: '#/components/schemas/MeterService',
    },
    gridAccessProviderId: {
      type: 'string',
      description: 'Identifier of the grid access provider managing the connection',
    },
    validFrom: {
      type: 'string',
      description: 'The date from which this record is valid',
      format: 'date',
      nullable: true,
    },
    addresses: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PreswitchBasicAddressDto',
      },
      description: 'List of addresses associated with this energy connection point',
    },
  },
  additionalProperties: false,
  description:
    'Represents a preswitch basic record containing EAN information retrieved from an external service lookup based on the provided address',
} as const;

export const $PreswitchLanguageCodeDto = {
  enum: ['NL', 'FR', 'EN'],
  type: 'string',
  description: 'Represents language codes for communication preferences',
} as const;

export const $PriceAggregationDto = {
  enum: ['Hourly', 'Daily', 'Monthly'],
  type: 'string',
  description: 'Type of price aggregation',
} as const;

export const $PriceModel = {
  enum: ['FixedAmount', 'PerUnit', 'Tiered', 'PerUnitMetered', 'TieredMetered', 'FixedPercentage'],
  type: 'string',
  description: 'Price model',
} as const;

export const $PriceSimulationCompensationTypeDto = {
  enum: ['Offtake', 'Compensation', 'Valorisation', 'Injection'],
  type: 'string',
  description: 'Represents the compensationtype (service component)',
} as const;

export const $PriceSimulationDetailsDto = {
  required: ['customerType', 'energyType', 'features', 'isProspect', 'postalCode', 'priceSimulationId'],
  type: 'object',
  properties: {
    priceSimulationId: {
      type: 'string',
      format: 'uuid',
    },
    accountNumber: {
      type: 'string',
      nullable: true,
    },
    isProspect: {
      type: 'boolean',
    },
    customerType: {
      $ref: '#/components/schemas/CustomerTypeDto',
    },
    postalCode: {
      type: 'string',
    },
    energyType: {
      $ref: '#/components/schemas/PriceSimulationEnergyTypeDto',
    },
    usage: {
      $ref: '#/components/schemas/PriceSimulationUsageDto',
    },
    features: {
      $ref: '#/components/schemas/PriceSimulationFeaturesDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the details of a price simulation.',
} as const;

export const $PriceSimulationElectricityMultipleUsageDto = {
  required: ['offPeakUsage', 'peakUsage'],
  type: 'object',
  properties: {
    peakUsage: {
      type: 'integer',
      description: 'The electricity usage during peak hours.',
      format: 'int32',
    },
    offPeakUsage: {
      type: 'integer',
      description: 'The electricity usage during off-peak hours.',
      format: 'int32',
    },
  },
  additionalProperties: false,
  description: 'Represents the electricity usage details for a multiple meter configuration in price simulation.',
} as const;

export const $PriceSimulationElectricitySingularUsageDto = {
  required: ['totalUsage'],
  type: 'object',
  properties: {
    totalUsage: {
      type: 'integer',
      description: 'The total electricity usage.',
      format: 'int32',
    },
    exclusiveNightUsage: {
      type: 'integer',
      description: 'The electricity usage exclusively during night hours, nullable if not specified.',
      format: 'int32',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents the electricity usage details for a singular meter configuration in price simulation.',
} as const;

export const $PriceSimulationElectricityUsageDto = {
  required: ['takeAveragePeak'],
  type: 'object',
  properties: {
    singularMeterUsage: {
      $ref: '#/components/schemas/PriceSimulationElectricitySingularUsageDto',
    },
    multipleMeterUsage: {
      $ref: '#/components/schemas/PriceSimulationElectricityMultipleUsageDto',
    },
    peakPower: {
      type: 'number',
      description: 'The peak power usage, nullable if not specified.',
      format: 'decimal',
      nullable: true,
    },
    takeAveragePeak: {
      type: 'boolean',
      description: 'Indicates whether to use average peak power in the simulation.',
    },
    solarPanelsProduction: {
      $ref: '#/components/schemas/PriceSimulationSolarPanelsProductionDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the electricity usage details for price simulation.',
} as const;

export const $PriceSimulationEmailRequest = {
  required: ['email', 'language', 'promotionalContentOptIn'],
  type: 'object',
  properties: {
    email: {
      type: 'string',
      description: 'The email address to send the price simulation to',
    },
    promotionalContentOptIn: {
      type: 'boolean',
      description: 'Whether the user opted in for promotional content',
    },
    language: {
      $ref: '#/components/schemas/CustomerLanguageDto',
    },
    variableProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPair',
      },
      description: 'Optional list of variable energy product pairs for price simulation',
      nullable: true,
    },
    fixedProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPair',
      },
      description: 'Optional list of fixed energy product pairs for price simulation',
      nullable: true,
    },
    dynamicProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPair',
      },
      description: 'Optional list of dynamic energy product pairs for price simulation',
      nullable: true,
    },
    variableProductsData: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPairMail',
      },
      description: 'Optional list of variable energy product pairs for price simulation with name mapping',
      nullable: true,
    },
    fixedProductsData: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPairMail',
      },
      description: 'Optional list of fixed energy product pairs for price simulation with name mapping',
      nullable: true,
    },
    dynamicProductsData: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPairMail',
      },
      description: 'Optional list of dynamic energy product pairs for price simulation with name mapping',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents a request for initiating a price simulation email operation.',
} as const;

export const $PriceSimulationEnergyTypeDto = {
  enum: ['Electricity', 'Gas', 'Both'],
  type: 'string',
  description: 'Represents different energy types for price simulation.',
} as const;

export const $PriceSimulationFeaturesDto = {
  required: ['installations', 'meterType'],
  type: 'object',
  properties: {
    installations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PriceSimulationInstallationDto',
      },
      description: 'A list of installations present at the location, such as solar panels or home battery.',
    },
    heatingType: {
      $ref: '#/components/schemas/PriceSimulationHeatingTypeDto',
    },
    housingType: {
      $ref: '#/components/schemas/PriceSimulationHousingTypeDto',
    },
    houseHoldSize: {
      $ref: '#/components/schemas/PriceSimulationHouseHoldSizeDto',
    },
    solarPanelInstallationDate: {
      $ref: '#/components/schemas/SolarPanelInstallationDateDto',
    },
    compensationType: {
      $ref: '#/components/schemas/PriceSimulationCompensationTypeDto',
    },
    meterType: {
      $ref: '#/components/schemas/PriceSimulationMeterTypeDto',
    },
    meterSubType: {
      $ref: '#/components/schemas/PriceSimulationMeterSubTypeDto',
    },
    hasExclusiveNightMeter: {
      type: 'boolean',
      description: 'Indicates if an exclusive night meter is present at the location.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents various features related to energy usage, installations, and housing for price simulation.',
} as const;

export const $PriceSimulationGasUsageDto = {
  required: ['totalUsage'],
  type: 'object',
  properties: {
    totalUsage: {
      type: 'integer',
      description: 'The total gas usage measured in the simulation.',
      format: 'int32',
    },
  },
  additionalProperties: false,
  description: 'Represents the gas usage details for price simulation.',
} as const;

export const $PriceSimulationHeatingTypeDto = {
  enum: ['ElectricHeating', 'GasHeating', 'HeatPump', 'Other'],
  type: 'string',
  description: 'Represents different types of heating for price simulation.',
} as const;

export const $PriceSimulationHistoryDto = {
  type: 'object',
  properties: {
    variableProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PriceSimulationHistoryProductCombinationDto',
      },
      description: 'For which variable products the price simulation was executed',
      nullable: true,
    },
    fixedProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PriceSimulationHistoryProductCombinationDto',
      },
      description: 'For which fixed products the price simulation was executed',
      nullable: true,
    },
    dynamicProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PriceSimulationHistoryProductCombinationDto',
      },
      description: 'For which dynamic products the price simulation was executed',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'History of simulation input',
} as const;

export const $PriceSimulationHistoryProductCombinationDto = {
  type: 'object',
  properties: {
    electric: {
      type: 'string',
      description: 'The identifier for the electric product used in the price simulation.',
      nullable: true,
    },
    gas: {
      type: 'string',
      description: 'The identifier for the gas product used in the price simulation.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents a combination of electric and gas products involved in a price simulation history.',
} as const;

export const $PriceSimulationHouseHoldSizeDto = {
  enum: ['One', 'Two', 'Three', 'Four', 'FiveOrMore'],
  type: 'string',
  description: 'Represents different household sizes used in price simulation.',
} as const;

export const $PriceSimulationHousingTypeDto = {
  enum: ['Apartment', 'FullyEnclosedBuilding', 'HalfOpenBuilding', 'OpenBuilding', 'Other'],
  type: 'string',
  description: 'Represents different types of housing used in price simulation.',
} as const;

export const $PriceSimulationInitiatedResponse = {
  required: ['priceSimulationId'],
  type: 'object',
  properties: {
    priceSimulationId: {
      type: 'string',
      description: 'The unique identifier for the initiated price simulation.',
      format: 'uuid',
    },
  },
  additionalProperties: false,
  description:
    'Represents the response for initiating a price simulation, containing the ID of the initiated price simulation.',
} as const;

export const $PriceSimulationInstallationDto = {
  enum: ['SolarPanels', 'HomeBattery', 'ChargingStation', 'HeatPump', 'None'],
  type: 'string',
  description: 'Represents different types of installations for price simulation.',
} as const;

export const $PriceSimulationMeterSubTypeDto = {
  enum: ['Single', 'Multiple'],
  type: 'string',
  description: 'Represents sub-types of meter configurations for price simulation.',
} as const;

export const $PriceSimulationMeterTypeDto = {
  enum: ['Analogue', 'Digital', 'BiDirectional'],
  type: 'string',
  description: 'Represents different types of meters used in price simulation.',
} as const;

export const $PriceSimulationProductCombinationOptionDto = {
  required: [
    'isWelcomePromo',
    'promoDisclaimers',
    'promoTexts',
    'sortOrder',
    'totalConditionalPromo',
    'totalYearlyPrice',
  ],
  type: 'object',
  properties: {
    promoTexts: {
      type: 'array',
      items: {
        type: 'string',
      },
      description: 'The collection of promotional text messages associated with this product combination.',
    },
    totalYearlyPrice: {
      type: 'number',
      description: 'The total yearly price amount.',
      format: 'decimal',
    },
    totalYearlyPriceWithNonCondtitionalPromo: {
      type: 'number',
      description: 'The total yearly price amount with the promo.',
      format: 'decimal',
      nullable: true,
    },
    totalConditionalPromo: {
      type: 'number',
      description: 'The discount amount.',
      format: 'decimal',
    },
    promoDisclaimers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PromoDisclaimerDto',
      },
      description: 'The collection of promotional disclaimers with their associated promo IDs and disclaimer texts.',
    },
    electricityProduct: {
      $ref: '#/components/schemas/PriceSimulationProductOptionDto',
    },
    gasProduct: {
      $ref: '#/components/schemas/PriceSimulationProductOptionDto',
    },
    isWelcomePromo: {
      type: 'boolean',
      description: 'Is the attached promo a welcome promo',
    },
    sortOrder: {
      type: 'integer',
      description: 'An order to sort the products on in the client, no value should be passed on from the backend.',
      format: 'int32',
    },
  },
  additionalProperties: false,
  description: 'Represents a product combination option containing optional electricity and gas products.',
} as const;

export const $PriceSimulationProductOptionDto = {
  required: ['costs', 'energyType', 'productName', 'tarriffChartUrl'],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/PriceSimulationEnergyTypeDto',
    },
    tarriffChartUrl: {
      type: 'string',
      description: 'URL of the tarriff chart',
    },
    productName: {
      type: 'string',
      description: 'The product name of the product.',
    },
    costs: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/CostDto',
      },
      description: 'The list of costs associated with this product.',
    },
  },
  additionalProperties: false,
  description: 'Represents an energy product option with its type, name and associated costs.',
} as const;

export const $PriceSimulationProductSimulationRequest = {
  required: ['dynamicProducts', 'fixedProducts', 'variableProducts'],
  type: 'object',
  properties: {
    variableProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPair',
      },
    },
    fixedProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPair',
      },
    },
    dynamicProducts: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnergyProductPair',
      },
    },
  },
  additionalProperties: false,
  description: 'Represents the request DTO containing grouped product names by type and energy category',
} as const;

export const $PriceSimulationRequest = {
  required: [
    'city',
    'customerType',
    'energyType',
    'features',
    'isProspect',
    'isUsageKnown',
    'isUsingDomiciliation',
    'language',
    'postalCode',
  ],
  type: 'object',
  properties: {
    accountNumber: {
      type: 'string',
      description: 'The account number of the customer. Can be null for prospects.',
      nullable: true,
    },
    isProspect: {
      type: 'boolean',
      description: 'Indicates whether the request is from a prospective customer.',
    },
    customerType: {
      $ref: '#/components/schemas/CustomerTypeDto',
    },
    language: {
      $ref: '#/components/schemas/CustomerLanguageDto',
    },
    postalCode: {
      type: 'string',
      description: "The postal code of the customer's location.",
    },
    city: {
      type: 'string',
      description: "The city of the customer's location.",
    },
    isUsageKnown: {
      type: 'boolean',
      description: 'Is the usage known.',
    },
    isUsingDomiciliation: {
      type: 'boolean',
      description: "Is the price simulation for the user's domicile?",
    },
    energyType: {
      $ref: '#/components/schemas/PriceSimulationEnergyTypeDto',
    },
    usage: {
      $ref: '#/components/schemas/PriceSimulationUsageDto',
    },
    features: {
      $ref: '#/components/schemas/PriceSimulationFeaturesDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the request for a price simulation.',
} as const;

export const $PriceSimulationSolarPanelsProductionDto = {
  type: 'object',
  properties: {
    peakHoursInjection: {
      type: 'integer',
      description: 'The amount of energy injected during peak hours.',
      format: 'int32',
      nullable: true,
    },
    offPeakHoursInjection: {
      type: 'integer',
      description: 'The amount of energy injected during off-peak hours.',
      format: 'int32',
      nullable: true,
    },
    totalInjection: {
      type: 'integer',
      description: 'The total amount of energy injected by the solar panels.',
      format: 'int32',
      nullable: true,
    },
    installationTotalKva: {
      type: 'number',
      description: 'The total capacity of the solar panel installation in kVA.',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents the production details of solar panels used for price simulation.',
} as const;

export const $PriceSimulationUsageDto = {
  type: 'object',
  properties: {
    electricity: {
      $ref: '#/components/schemas/PriceSimulationElectricityUsageDto',
    },
    gas: {
      $ref: '#/components/schemas/PriceSimulationGasUsageDto',
    },
  },
  additionalProperties: false,
  description: 'Represents energy usage details for both electricity and gas during a price simulation.',
} as const;

export const $ProblemDetails = {
  type: 'object',
  properties: {
    type: {
      type: 'string',
      nullable: true,
    },
    title: {
      type: 'string',
      nullable: true,
    },
    status: {
      type: 'integer',
      format: 'int32',
      nullable: true,
    },
    detail: {
      type: 'string',
      nullable: true,
    },
    instance: {
      type: 'string',
      nullable: true,
    },
  },
  additionalProperties: {},
} as const;

export const $ProductConfirmationCardDetailsResponse = {
  required: ['products'],
  type: 'object',
  properties: {
    products: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ProductConfirmationCardProductResponse',
      },
      description: 'Details of confirmed products',
    },
  },
  additionalProperties: false,
  description: 'Represents the details for a product confirmation card response.',
} as const;

export const $ProductConfirmationCardProductResponse = {
  required: ['date', 'energyType'],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    date: {
      type: 'string',
      description: 'Indicates the date associated with the product confirmation.',
      format: 'date',
    },
  },
  additionalProperties: false,
  description: 'Represents the product information provided within a product confirmation card.',
} as const;

export const $ProductConfirmationCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/ProductConfirmationCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for product confirmation card',
} as const;

export const $ProductSwitchAccountByOrderIdResponse = {
  type: 'object',
  properties: {
    accountNumber: {
      type: 'string',
      description: 'The account number associated with the order',
      nullable: true,
    },
    ean: {
      type: 'string',
      description: 'The EAN associated with the order',
      nullable: true,
    },
    deliveryAddressId: {
      type: 'string',
      description: 'The delivery address associated with the order',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents the response containing account details for a product switch order.',
} as const;

export const $ProductSwitchCurrentProductResponse = {
  required: [
    'ean',
    'energyType',
    'hasSocialTarriff',
    'isActive',
    'productSwitchStatus',
    'promoLoss',
    'tariffChartUrlFr',
    'tariffChartUrlNl',
    'technicalProductName',
  ],
  type: 'object',
  properties: {
    technicalProductName: {
      type: 'string',
      description: 'The technical name of the product',
    },
    promoLoss: {
      type: 'boolean',
      description: 'Indicates whether there is a loss of promotional benefits when switching the product',
    },
    hasSocialTarriff: {
      type: 'boolean',
      description: 'Indicates whether the product has a social tariff applied',
    },
    isActive: {
      type: 'boolean',
      description: 'Indicates whether the product is currently active',
    },
    productSwitchStatus: {
      $ref: '#/components/schemas/ProductSwitchStatusResponse',
    },
    ean: {
      type: 'string',
      description: 'EAN of the meter',
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
    tariffChartUrlNl: {
      type: 'string',
      description: 'URL of the tariff chart in Dutch',
    },
    tariffChartUrlFr: {
      type: 'string',
      description: 'URL of the tariff chart in French',
    },
  },
  additionalProperties: false,
  description: 'Current product information available for switching',
} as const;

export const $ProductSwitchProductResponse = {
  required: [
    'customerType',
    'preferred',
    'productType',
    'tariffChartUrlFr',
    'tariffChartUrlNl',
    'technicalProductName',
  ],
  type: 'object',
  properties: {
    technicalProductName: {
      type: 'string',
      description: 'The technical name of the product',
    },
    productType: {
      $ref: '#/components/schemas/ProductType',
    },
    customerType: {
      $ref: '#/components/schemas/CustomerTypeDto',
    },
    preferred: {
      type: 'boolean',
      description: 'Indicates whether the product is preferred',
    },
    tariffChartUrlNl: {
      type: 'string',
      description: 'URL of the tariff chart in Dutch',
    },
    tariffChartUrlFr: {
      type: 'string',
      description: 'URL of the tariff chart in French',
    },
  },
  additionalProperties: false,
  description: 'Product available to switch to',
} as const;

export const $ProductSwitchRecordDto = {
  required: ['current', 'switchOptions'],
  type: 'object',
  properties: {
    current: {
      $ref: '#/components/schemas/ProductSwitchCurrentProductResponse',
    },
    switchOptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ProductSwitchProductResponse',
      },
      description: 'A list of products available to switch to',
    },
  },
  additionalProperties: false,
  description: 'Represents the options to switch to from a specific product',
} as const;

export const $ProductSwitchRequest = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ProductSwitchRequestDto',
      },
      description: 'Multiple product switch request records',
    },
    orderId: {
      type: 'string',
      description: 'OrderId if initiated from Siebel order',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents the request body containing the product switch ID.',
} as const;

export const $ProductSwitchRequestDto = {
  required: ['ean', 'toProductTechnicalName'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description:
        'The International Article Number (EAN) associated with the product. This is a unique identifier used for tracking and identification in retail and logistics.',
    },
    toProductTechnicalName: {
      type: 'string',
      description: 'The name of new product, the ean (associated with the product) will be switched to.',
    },
  },
  additionalProperties: false,
  description: 'Represents the data transfer object for a product switch request.',
} as const;

export const $ProductSwitchResponse = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ProductSwitchRecordDto',
      },
      description: 'List of product switch records',
    },
  },
  additionalProperties: false,
  description: 'Represents the response for product switch options.',
} as const;

export const $ProductSwitchStatusResponse = {
  enum: ['PendingProductSwitch', 'TransitioningToProductSwitch', 'PendingProductSwitchCancellation', 'NoProductSwitch'],
  type: 'string',
  description: 'Represents the status of a product switch operation',
} as const;

export const $ProductType = {
  enum: ['Fixed', 'Variable', 'Dynamic'],
  type: 'string',
  description:
    'Type of product. Indicates whether there is a fixed or a variable price across a given timespan or the timespan of the product.',
} as const;

export const $ProgressTimelineCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Progress Timeline card',
} as const;

export const $PromoDisclaimerDto = {
  required: ['disclaimerText', 'energyProduct', 'hasDirectDebit', 'promoId'],
  type: 'object',
  properties: {
    promoId: {
      type: 'string',
      description: 'The id of the promo',
    },
    disclaimerText: {
      type: 'string',
      description: 'The text used in the disclaimer',
    },
    hasDirectDebit: {
      type: 'boolean',
      description: 'Has direct debit flag',
    },
    energyProduct: {
      $ref: '#/components/schemas/PriceSimulationEnergyTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the disclaimer of a promo',
} as const;

export const $PromoDto = {
  required: [
    'b2cflag',
    'directDebitFlag',
    'dualFuelFlag',
    'durationCheckRequiredFlag',
    'eBillingFlag',
    'energyProduct',
    'sohoflag',
  ],
  type: 'object',
  properties: {
    offerNumber: {
      type: 'string',
      description: 'The unique offer number identifying this promotion',
      nullable: true,
    },
    validStartDate: {
      type: 'string',
      description: 'The date when the promotion becomes valid and can be used',
      format: 'date',
      nullable: true,
    },
    validEndDate: {
      type: 'string',
      description: 'The date when the promotion expires and can no longer be used',
      format: 'date',
      nullable: true,
    },
    description: {
      type: 'string',
      description: 'A textual description of the promotion details',
      nullable: true,
    },
    b2cflag: {
      type: 'boolean',
      description: 'Flag indicating if the promotion is available for B2C (business-to-consumer) customers',
    },
    sohoflag: {
      type: 'boolean',
      description: 'Flag indicating if the promotion is available for SOHO (small office/home office) customers',
    },
    dualFuelFlag: {
      type: 'boolean',
      description: 'Flag indicating if the promotion requires both electricity and gas services',
    },
    directDebitFlag: {
      type: 'boolean',
      description: 'Flag indicating if the promotion requires direct debit payment method',
    },
    eBillingFlag: {
      type: 'boolean',
      description: 'Flag indicating if the promotion requires electronic billing',
    },
    durationCheckRequiredFlag: {
      type: 'boolean',
      description: 'Flag indicating if duration validation is required for this promotion',
    },
    discountTypeElec: {
      type: 'string',
      description: 'The type of discount applied to electricity services',
      nullable: true,
    },
    offerElecDiscount: {
      type: 'string',
      description: 'The electricity discount offer details',
      nullable: true,
    },
    offerElecDiscountAmount: {
      type: 'number',
      description: 'The monetary amount of the electricity discount',
      format: 'decimal',
      nullable: true,
    },
    offerGasDiscount: {
      type: 'string',
      description: 'The gas discount offer details',
      nullable: true,
    },
    offerGasDiscountAmount: {
      type: 'number',
      description: 'The monetary amount of the gas discount',
      format: 'decimal',
      nullable: true,
    },
    contractTextNl: {
      type: 'string',
      description: 'The contract text in Dutch for this promotion',
      nullable: true,
    },
    offerTextNl: {
      type: 'string',
      description: 'The offer text in Dutch for this promotion',
      nullable: true,
    },
    offerDisclaimerNl: {
      type: 'string',
      description: 'The offer disclaimer text in Dutch',
      nullable: true,
    },
    offerConfirmTextNl: {
      type: 'string',
      description: 'The offer confirmation text in Dutch',
      nullable: true,
    },
    offerConfirmDisclaimerNl: {
      type: 'string',
      description: 'The offer confirmation disclaimer text in Dutch',
      nullable: true,
    },
    contractTextFr: {
      type: 'string',
      description: 'The contract text in French for this promotion',
      nullable: true,
    },
    offerTextFr: {
      type: 'string',
      description: 'The offer text in French for this promotion',
      nullable: true,
    },
    offerDisclaimerFr: {
      type: 'string',
      description: 'The offer disclaimer text in French',
      nullable: true,
    },
    offerConfirmTextFr: {
      type: 'string',
      description: 'The offer confirmation text in French',
      nullable: true,
    },
    offerConfirmDisclaimerFr: {
      type: 'string',
      description: 'The offer confirmation disclaimer text in French',
      nullable: true,
    },
    energyProduct: {
      $ref: '#/components/schemas/PriceSimulationEnergyTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the promo details of an order',
} as const;

export const $Promotion = {
  required: ['disclaimer', 'eBillingRequired', 'text'],
  type: 'object',
  properties: {
    text: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
      description: "Name of the promotion by language. E.g. 'Loyalty promo Elektriciteit'",
    },
    disclaimer: {
      type: 'object',
      additionalProperties: {
        type: 'string',
      },
      description: 'Disclaimer of the promotion by language',
    },
    eBillingRequired: {
      type: 'boolean',
      description: 'Whether E-Billing is required for this promotion to be valid',
    },
  },
  additionalProperties: false,
  description: 'Promotion active on a Product',
} as const;

export const $PurchaseStatus = {
  enum: ['Unknown', 'NotPurchased', 'Purchased'],
  type: 'string',
  description: 'Purchase status',
} as const;

export const $PushDirectDebitCardDetailsResponse = {
  required: ['paymentMethods'],
  type: 'object',
  properties: {
    paymentMethods: {
      $ref: '#/components/schemas/PaymentMethodResponse',
    },
  },
  additionalProperties: false,
  description: 'Response containing details of a direct debit card push card, including associated payment methods',
} as const;

export const $PushDirectDebitCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/PushDirectDebitCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for push direct debit card',
} as const;

export const $PutAccountDetailsRequest = {
  required: ['alias'],
  type: 'object',
  properties: {
    alias: {
      type: 'string',
      description: 'the CRM account alias',
    },
  },
  additionalProperties: false,
  description: 'Details to update on a CRM account from the viewpoint of the logged in user',
} as const;

export const $PutContractDetailsForProductMeterRequest = {
  required: ['meterRegime', 'meterTariff'],
  type: 'object',
  properties: {
    meterRegime: {
      $ref: '#/components/schemas/MeterRegime',
    },
    meterTariff: {
      $ref: '#/components/schemas/MeterTariffDto',
    },
  },
  additionalProperties: false,
  description: 'Request to update the meter details',
} as const;

export const $RagRequest = {
  type: 'object',
  properties: {
    date: {
      type: 'string',
      description: 'The date.',
      nullable: true,
    },
    language: {
      type: 'string',
      description: 'The language.',
      nullable: true,
    },
    question: {
      type: 'string',
      description: 'The question.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The RAG answer request.',
} as const;

export const $RagResponse = {
  type: 'object',
  properties: {
    answer: {
      type: 'string',
      description: 'The RAG answer.',
      nullable: true,
    },
    sources: {
      type: 'string',
      description: 'The sources used for the answer.',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The RAG answer response.',
} as const;

export const $Reason = {
  enum: ['ADJ', 'TEMP', 'RECT', 'APPR', 'MISS', 'EST', 'OEST', 'DEF', 'VAL'],
  type: 'string',
  description: 'Quality of the reading',
} as const;

export const $ReasonDto = {
  enum: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  type: 'integer',
  description: 'Quality of the reading',
  format: 'int32',
} as const;

export const $RecommendedAmountResponseError = {
  enum: [
    'ActiveLock',
    'AdvanceAmountExceedsMax',
    'FailedToRetrieveBillingSubPeriods',
    'InvoiceOrEndnoteNeedsToBeCreatedFirst',
    'LastAdvanceDatetimeEqualToBillingDate',
    'NewAdvanceAmountDeviatesTooLess',
    'NewAdvanceAmountOverUpperLimit',
    'NoAssetChannelIndexValuesFound',
    'NoContractorFoundForConnection',
    'OtherError',
    'PeriodOfEstimatedConsumptionOutsideConnectionPeriod',
    'RecalculationInFirstThreeMonthsNotAllowed',
    'RecalculationTooSoon',
    'ThrottleTooManyRequests',
    'NoActiveBillingFrequencyFound',
    'WorkdayNotReached',
  ],
  type: 'string',
  description: 'What kind of error was returned on the RAA request',
} as const;

export const $RectificationContestedMeter = {
  required: ['correctedDate', 'ean', 'originalDate', 'rectificationContestedMeterReadingRecords', 'utilityType'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'EAN number identifying the meter',
    },
    originalDate: {
      type: 'string',
      description: 'Original date of the reading',
      format: 'date-time',
    },
    correctedDate: {
      type: 'string',
      description: 'Date the user entered',
      format: 'date-time',
    },
    utilityType: {
      $ref: '#/components/schemas/UtilityType',
    },
    rectificationContestedMeterReadingRecords: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RectificationContestedMeterReadingRecord',
      },
      description: 'List of contested meter reading records',
    },
  },
  additionalProperties: false,
  description: 'The information of a contested meter related to rectification.',
} as const;

export const $RectificationContestedMeterReadingRecord = {
  required: ['correctedValue', 'directionTypeCode', 'originalValue', 'timeFrameType'],
  type: 'object',
  properties: {
    originalValue: {
      type: 'integer',
      description: 'The original provided meter reading value',
      format: 'int32',
    },
    correctedValue: {
      type: 'integer',
      description: 'The meter reading value corrected by the user',
      format: 'int32',
    },
    timeFrameType: {
      $ref: '#/components/schemas/TimeframeTypeCodeDto',
    },
    directionTypeCode: {
      $ref: '#/components/schemas/DirectionTypeCodeDto',
    },
  },
  additionalProperties: false,
  description: 'The rectification meter information',
} as const;

export const $RectificationDeltaDto = {
  enum: ['HasDeviation', 'NoDeviation'],
  type: 'string',
  description: 'The rectification delta response',
} as const;

export const $RectificationDeltaResultResponse = {
  required: ['calculatedDelta', 'contestedValue', 'delta'],
  type: 'object',
  properties: {
    delta: {
      $ref: '#/components/schemas/RectificationDeltaDto',
    },
    calculatedDelta: {
      type: 'number',
      description: 'Calculated delta',
      format: 'double',
    },
    contestedValue: {
      $ref: '#/components/schemas/ContestedValue',
    },
  },
  additionalProperties: false,
  description: 'Record containing the deviation result',
} as const;

export const $RectificationDocuments = {
  required: ['fileExtension', 'fileName', 'fileUploadOperationId'],
  type: 'object',
  properties: {
    fileUploadOperationId: {
      type: 'string',
      description: 'Unique identifier for the archived document',
    },
    fileName: {
      type: 'string',
      description: 'Name of the attached file',
    },
    fileExtension: {
      type: 'string',
      description: 'File extension of the attached document',
    },
  },
  additionalProperties: false,
  description: 'The rectification attachment info',
} as const;

export const $RectificationEligibilityDto = {
  enum: ['Eligible', 'HasOngoingRectification', 'HasDigitalMeter', 'InvalidInvoice'],
  type: 'string',
  description: 'Response type for eligibility check',
} as const;

export const $RectificationEligibilityRecordResponse = {
  required: ['ean', 'eligibility'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'EAN for which eligibility is checked',
    },
    eligibility: {
      $ref: '#/components/schemas/RectificationEligibilityDto',
    },
  },
  additionalProperties: false,
  description: 'Represents the eligibility per EAN',
} as const;

export const $RectificationEligibilityResponse = {
  required: ['records'],
  type: 'object',
  properties: {
    records: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RectificationEligibilityRecordResponse',
      },
      description: 'Eligibility value per EAN',
    },
  },
  additionalProperties: false,
  description: 'Represents the response for a rectification eligibility check',
} as const;

export const $RectificationMeterReadingResponse = {
  required: ['date', 'ean', 'indexValues', 'meterReadingType', 'meterType', 'registeredDate', 'utilityType'],
  type: 'object',
  properties: {
    ean: {
      maxLength: 50,
      type: 'string',
      description: 'Gets or sets the value of the ean',
    },
    indexValues: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/MeterReadingIndexValue',
      },
      description: 'Gets or sets the list of index values associated with the meter reading.',
    },
    date: {
      type: 'string',
      description: 'Gets or sets the value of the date',
      format: 'date',
    },
    meterReadingType: {
      $ref: '#/components/schemas/MeterReadingType',
    },
    registeredDate: {
      type: 'string',
      description: 'Gets or sets the value of the registered date',
      format: 'date',
    },
    utilityType: {
      $ref: '#/components/schemas/UtilityType',
    },
    meterType: {
      $ref: '#/components/schemas/MeterType',
    },
  },
  additionalProperties: false,
  description: 'The meter reading response class',
} as const;

export const $ReferToAccountNumberIfRefundCardDetailsResponse = {
  required: ['summary'],
  type: 'object',
  properties: {
    summary: {
      $ref: '#/components/schemas/GetInvoicesOpenAmountSummaryResponse',
    },
  },
  additionalProperties: false,
  description: `Represents the details of a "Refer To Account Number If Refund" card in the Next Best Actions system.
The card provides information about the total open invoice amount and the number of open invoices.`,
} as const;

export const $ReferToAccountNumberIfRefundCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/ReferToAccountNumberIfRefundCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for refer to account number if refund card',
} as const;

export const $RegisterHolder = {
  required: ['registerType'],
  type: 'object',
  properties: {
    registerType: {
      $ref: '#/components/schemas/RegisterType',
    },
  },
  additionalProperties: false,
  description: 'Holder that has a meter register',
} as const;

export const $RegisterType = {
  enum: ['Single', 'Day', 'Night', 'ExclusiveNight'],
  type: 'string',
  description: 'Type of register',
} as const;

export const $Representation = {
  enum: ['Mr', 'Mrs', 'Ms'],
  type: 'string',
  description: 'Product renewal type',
} as const;

export const $SelectedCorrespondenceAddressDto = {
  enum: ['Old', 'New', 'Custom'],
  type: 'string',
  description: 'Customer selected correspondence address',
} as const;

export const $SessionTokenValidityResponse = {
  required: ['createdAt', 'inviteReference', 'status'],
  type: 'object',
  properties: {
    inviteReference: {
      type: 'string',
      description: 'Internal reference of the invite',
      format: 'uuid',
    },
    status: {
      $ref: '#/components/schemas/SessionTokenValidityStatusDto',
    },
    displayNameOwner: {
      type: 'string',
      description:
        'The ME voornaam of the owner of the account, given that the session token is in context of a crm account',
      nullable: true,
    },
    emailOwner: {
      type: 'string',
      description: 'The email of the owner of the account',
      nullable: true,
    },
    crmAccountNumber: {
      type: 'string',
      description: 'The Crm Account number of the account, given that the session token is in context of a crm account',
      nullable: true,
    },
    crmAccountAliasCurrentUser: {
      type: 'string',
      description:
        'The crm account alias of the current user for the account, given that the session token is in context of a crm account',
      nullable: true,
    },
    createdAt: {
      type: 'string',
      description: 'Invite creation date',
      format: 'date-time',
    },
    expiresAt: {
      type: 'string',
      description: 'Expiration date of the session token',
      format: 'date-time',
      nullable: true,
    },
    mailSentAt: {
      type: 'string',
      description: 'Date on which the mail was sent, if already sent',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The response of validating the session token validity',
} as const;

export const $SessionTokenValidityStatusDto = {
  enum: ['Redeemable', 'Redeemed', 'Expired', 'Revoked'],
  type: 'string',
  description: 'The validity status',
} as const;

export const $ShippingStatus = {
  enum: ['Unknown', 'NotShipped', 'Shipped'],
  type: 'string',
  description: 'Shipping status',
} as const;

export const $ShowPersonalInfoCardDetailsResponse = {
  required: ['accountNumber', 'firstName', 'lastName'],
  type: 'object',
  properties: {
    accountNumber: {
      type: 'string',
      description: 'The account number associated with the user.',
    },
    firstName: {
      type: 'string',
      description: 'The first name of the user.',
    },
    lastName: {
      type: 'string',
      description: 'The last name of the user.',
    },
  },
  additionalProperties: false,
  description: 'Represents the details of a personal information card response.',
} as const;

export const $ShowPersonalInfoCardResponse = {
  required: ['details'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    details: {
      $ref: '#/components/schemas/ShowPersonalInfoCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for show personal info card',
} as const;

export const $ShowUsageCardConsumptionsPerEanResponse = {
  required: ['consumptionType', 'ean', 'endDate', 'startDate', 'value'],
  type: 'object',
  properties: {
    ean: {
      type: 'string',
      description: 'The unique EAN identifier for which the consumption data is represented.',
    },
    consumptionType: {
      $ref: '#/components/schemas/ConsumptionTypeDto',
    },
    startDate: {
      type: 'string',
      description: 'The StartDate for which the consumption data is represented.',
      format: 'date-time',
    },
    endDate: {
      type: 'string',
      description: 'The EndDate for which the consumption data is represented.',
      format: 'date-time',
    },
    value: {
      type: 'number',
      description: 'The usage/injection for that meter and that consumptionType in a specific period of time.',
      format: 'decimal',
    },
  },
  additionalProperties: false,
  description: 'Represents the response containing consumption details for a specific EAN (European Article Number).',
} as const;

export const $ShowUsageCardDetailsResponse = {
  required: ['consumptions'],
  type: 'object',
  properties: {
    consumptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/ShowUsageCardConsumptionsPerEanResponse',
      },
      description: 'A collection of consumption details for each EAN  associated with the card',
    },
  },
  additionalProperties: false,
  description:
    'Represents the detailed response for the show usage card, including consumption data for multiple EANs.',
} as const;

export const $ShowUsageCardResponse = {
  required: ['hasAnalogMeter'],
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  properties: {
    hasAnalogMeter: {
      type: 'boolean',
      description: 'If true, customer has an analog meter. Otherwise false',
    },
    details: {
      $ref: '#/components/schemas/ShowUsageCardDetailsResponse',
    },
  },
  additionalProperties: false,
  description: 'Response for show usage card',
} as const;

export const $SignAgreementsRequest = {
  required: ['privacyPolicy', 'termsOfService'],
  type: 'object',
  properties: {
    termsOfService: {
      type: 'boolean',
      description: 'Terms of service',
    },
    privacyPolicy: {
      type: 'boolean',
      description: 'Privacy policy',
    },
  },
  additionalProperties: false,
  description: 'Defines which agreements have been signed by the user',
} as const;

export const $SignedAgreementsDto = {
  type: 'object',
  properties: {
    signedTermsOfService: {
      type: 'string',
      description: 'Date of signing the terms of service',
      format: 'date-time',
      nullable: true,
    },
    signedPrivacyPolicy: {
      type: 'string',
      description: 'Date of signing the privacy policy',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains the agreement dates',
} as const;

export const $SimpleOrderBasketDto = {
  required: ['items'],
  type: 'object',
  properties: {
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SimpleOrderBasketLineItemDto',
      },
      description: 'List of line items included in the order basket.',
    },
  },
  additionalProperties: false,
  description: 'Data transfer object representing a simple order basket.',
} as const;

export const $SimpleOrderBasketLineItemDto = {
  required: ['orderProductType', 'technicalProductName'],
  type: 'object',
  properties: {
    technicalProductName: {
      type: 'string',
      description: 'The technical name of the product associated with the line item.',
    },
    orderProductType: {
      $ref: '#/components/schemas/OrderProductTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Represents a line item in a simple order basket with details about the product and its type.',
} as const;

export const $SimulateGlobalAmountUpdateRequest = {
  required: ['amount'],
  type: 'object',
  properties: {
    amount: {
      type: 'integer',
      description: 'The proposed amount/>',
      format: 'int32',
    },
  },
  additionalProperties: false,
  description: 'Simulate global amount for an advance',
} as const;

export const $SimulatePriceSimulationResponse = {
  required: ['productCombinationOptions', 'simulationDetails'],
  type: 'object',
  properties: {
    simulationDetails: {
      $ref: '#/components/schemas/PriceSimulationDetailsDto',
    },
    productCombinationOptions: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/PriceSimulationProductCombinationOptionDto',
      },
      description: 'The list of available product combination options.',
    },
  },
  additionalProperties: false,
  description: 'Represents the response containing price simulation details and available product combination options.',
} as const;

export const $SmartEnergyDevice = {
  enum: ['EvCharger', 'HeatPump', 'ElectricalHeating', 'SwimmingPool'],
  type: 'string',
  description: 'Smart energy device',
} as const;

export const $SmartEnergyDeviceCombinationResponse = {
  required: ['devices'],
  type: 'object',
  properties: {
    devices: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SmartEnergyDevice',
      },
      description: 'Device combinations list',
    },
  },
  additionalProperties: false,
  description: 'Smart energy device combination response',
} as const;

export const $SmartEnergyDeviceCombinationResponseList = {
  required: ['deviceCombinations'],
  type: 'object',
  properties: {
    deviceCombinations: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SmartEnergyDeviceCombinationResponse',
      },
      description: 'Valid device combination',
    },
  },
  additionalProperties: false,
  description: 'Smart energy device combination response list',
} as const;

export const $SmartEnergyOfferRequest = {
  required: ['deviceCombination', 'injectionVolume', 'inverterType', 'usageVolume'],
  type: 'object',
  properties: {
    injectionVolume: {
      type: 'integer',
      description: 'Number of kwh injected',
      format: 'int32',
    },
    usageVolume: {
      type: 'integer',
      description: 'Number of kwh used',
      format: 'int32',
    },
    inverterType: {
      type: 'string',
      description: 'Inverter type',
    },
    deviceCombination: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SmartEnergyDevice',
      },
      description: 'Valid list of devices that can be combined into a valid combination',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Smart energy offer',
} as const;

export const $SmartEnergyOfferResponse = {
  required: ['offers'],
  type: 'object',
  properties: {
    offers: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SmartEnergyOfferResponseRow',
      },
      description: 'Offers',
    },
  },
  additionalProperties: false,
  description: 'Smart energy offer response',
} as const;

export const $SmartEnergyOfferResponseRow = {
  required: ['investmentDiscount'],
  type: 'object',
  properties: {
    injectedVolume: {
      type: 'integer',
      description: 'Energy generated (kWh).',
      format: 'int32',
      nullable: true,
    },
    usageVolume: {
      type: 'integer',
      description: 'Energy consumption from the grid (kWh).',
      format: 'int32',
      nullable: true,
    },
    savedVolume: {
      type: 'integer',
      description: 'Storage capacity (kWh).',
      format: 'int32',
      nullable: true,
    },
    numberOfModules: {
      type: 'integer',
      description: 'Number of modules (#).',
      format: 'int32',
      nullable: true,
    },
    hasBatteryFive: {
      type: 'integer',
      description: 'Battery 5kWh (#).',
      format: 'int32',
      nullable: true,
    },
    hasBatteryEight: {
      type: 'integer',
      description: 'Battery 8kWh (#).',
      format: 'int32',
      nullable: true,
    },
    inventorType: {
      type: 'string',
      description: 'Inverter (kW).',
      nullable: true,
    },
    investment: {
      type: 'integer',
      description: 'Investment at 0% (€).',
      format: 'int32',
      nullable: true,
    },
    investmentDiscount: {
      type: 'number',
      description: 'Discount with VAT (€).',
      format: 'decimal',
    },
    investmentSixPercent: {
      type: 'integer',
      description: 'Investment at 6% (€).',
      format: 'int32',
      nullable: true,
    },
    investmentTwentyOnePercent: {
      type: 'integer',
      description: 'Investment at 21% (€).',
      format: 'int32',
      nullable: true,
    },
    height: {
      type: 'integer',
      description: 'Height (cm).',
      format: 'int32',
      nullable: true,
    },
    width: {
      type: 'integer',
      description: 'Width (cm).',
      format: 'int32',
      nullable: true,
    },
    depth: {
      type: 'integer',
      description: 'Depth (cm).',
      format: 'int32',
      nullable: true,
    },
    yearlySaving: {
      type: 'integer',
      description: 'Annual savings (€).',
      format: 'int32',
      nullable: true,
    },
    extraSelfUsage: {
      type: 'number',
      description: 'Additional self-consumption (€).',
      format: 'decimal',
      nullable: true,
    },
    selfUsageOptimalisation: {
      type: 'number',
      description: 'Self-consumption optimization (€).',
      format: 'decimal',
      nullable: true,
    },
    capacityTarifReduction: {
      type: 'number',
      description: 'Capacity tariff reduction (€).',
      format: 'decimal',
      nullable: true,
    },
    enecoSmartSavings: {
      type: 'integer',
      description: 'Savings with Eneco Smart Steering (€).',
      format: 'int32',
      nullable: true,
    },
    payBackPeriodSixPercent: {
      type: 'integer',
      description: 'Payback period at 6% (€).',
      format: 'int32',
      nullable: true,
    },
    payBackPeriodTwentyOnePercent: {
      type: 'integer',
      description: 'Payback period at 21% (€).',
      format: 'int32',
      nullable: true,
    },
    roiSixPercent: {
      type: 'number',
      description: 'Return on Investment (ROI) for 20 years at 6%.',
      format: 'decimal',
      nullable: true,
    },
    roiTwentyOnePercent: {
      type: 'number',
      description: 'Return on Investment (ROI) for 20 years at 21%.',
      format: 'decimal',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Represents a response row for a smart energy offer.',
} as const;

export const $SolarPanelInstallationDateDto = {
  enum: ['BeforeJanuary2024', 'AfterJanuary2024'],
  type: 'string',
  description: `Represents the date of solar panel installation for price simulation purposes.
The date is significant only for locations in Wallonia.`,
} as const;

export const $StatusHintDto = {
  required: ['hint', 'state'],
  type: 'object',
  properties: {
    hint: {
      $ref: '#/components/schemas/StatusHintOptionDto',
    },
    state: {
      $ref: '#/components/schemas/StatusHintStateDto',
    },
  },
  additionalProperties: false,
  description: 'Record containing the state of a Dc.XAPI.Site.Web.Contracts.Move.StatusHintOptionDto',
} as const;

export const $StatusHintOptionDto = {
  enum: [
    'EmailConfirmation',
    'MoveFileCreated',
    'MoveInformationUpdated',
    'MeterValuesOldAddressFilledIn',
    'MeterValuesNewAddressFilledIn',
    'EndNote',
    'Completed',
  ],
  type: 'string',
  description: 'All status hint options',
} as const;

export const $StatusHintStateDto = {
  enum: ['Todo', 'Completed'],
  type: 'string',
  description: 'The state in which a status hint resides for a move',
} as const;

export const $SubmitRectificationRequest = {
  required: ['contestedMeterReadings', 'rectificationDocuments'],
  type: 'object',
  properties: {
    contestedMeterReadings: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RectificationContestedMeter',
      },
      description: 'List of contested meter readings for the rectification',
    },
    rectificationDocuments: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/RectificationDocuments',
      },
      description: 'List of documents attached to the rectification request',
    },
    comment: {
      type: 'string',
      description: 'Comment attached by the user',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'The rectification info',
} as const;

export const $SubscriptionDetailInfo = {
  type: 'object',
  properties: {
    detailsUrl: {
      type: 'string',
      description: 'The detailsUrl property',
      nullable: true,
    },
    detailType: {
      $ref: '#/components/schemas/SubscriptionType',
    },
    discountStatus: {
      $ref: '#/components/schemas/DiscountStatus',
    },
    endDate: {
      type: 'string',
      description: 'The endDate property',
      format: 'date-time',
      nullable: true,
    },
    name: {
      type: 'string',
      description: 'The name property',
      nullable: true,
    },
    percentage: {
      type: 'number',
      description: 'The percentage property',
      format: 'double',
      nullable: true,
    },
    price: {
      type: 'number',
      description: 'The price property',
      format: 'double',
      nullable: true,
    },
    priceModel: {
      $ref: '#/components/schemas/PriceModel',
    },
    startDate: {
      type: 'string',
      description: 'The startDate property',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Subscription detail information',
} as const;

export const $SubscriptionInfo = {
  type: 'object',
  properties: {
    campaign: {
      type: 'string',
      description: 'The campaign property',
      nullable: true,
    },
    details: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/SubscriptionDetailInfo',
      },
      description: 'The details property',
      nullable: true,
    },
    endDate: {
      type: 'string',
      description: 'The endDate property',
      format: 'date-time',
      nullable: true,
    },
    planDetailsUrl: {
      type: 'string',
      description: 'The planDetailsUrl property',
      nullable: true,
    },
    planId: {
      type: 'string',
      description: 'The planId property',
      nullable: true,
    },
    planName: {
      type: 'string',
      description: 'The planName property',
      nullable: true,
    },
    planPrice: {
      type: 'number',
      description: 'The planPrice property',
      format: 'double',
      nullable: true,
    },
    planPriceModel: {
      $ref: '#/components/schemas/PlanPriceModel',
    },
    quantity: {
      type: 'integer',
      description: 'The quantity property',
      format: 'int32',
      nullable: true,
    },
    serviceType: {
      type: 'string',
      description: 'The serviceType property',
      nullable: true,
    },
    startDate: {
      type: 'string',
      description: 'The startDate property',
      format: 'date-time',
      nullable: true,
    },
    status: {
      $ref: '#/components/schemas/SubscriptionStatus',
    },
    subscriptionId: {
      type: 'string',
      description: 'The subscriptionId property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Subscription info',
} as const;

export const $SubscriptionStatus = {
  enum: ['Active', 'Future', 'NonRenewing', 'InTrial', 'Cancelled'],
  type: 'string',
  description: 'Subscription status',
} as const;

export const $SubscriptionStatusDto = {
  enum: ['Created', 'LinkCompleted', 'Active', 'Expired'],
  type: 'string',
  description: 'Subscription status',
} as const;

export const $SubscriptionTierDto = {
  enum: ['Free', 'Premium'],
  type: 'string',
  description: 'Subscription tier',
} as const;

export const $SubscriptionType = {
  enum: ['RecurringAddon', 'OneTimeCharge', 'Discount'],
  type: 'string',
  description: 'Subscription type',
} as const;

export const $SubscriptionTypeDto = {
  enum: ['SmartCharging', 'SmartInsights'],
  type: 'string',
  description: 'Subscription type',
} as const;

export const $SuggestedEanResponse = {
  required: ['ean', 'energyType'],
  type: 'object',
  properties: {
    energyType: {
      $ref: '#/components/schemas/MoveEnergyTypeDto',
    },
    ean: {
      type: 'string',
      description: 'EAN of the meter',
    },
  },
  additionalProperties: false,
  description: 'Contains EAN information returned by ThinkNext',
} as const;

export const $TariffCardByLanguage = {
  required: ['language', 'tariffCard', 'type'],
  type: 'object',
  properties: {
    language: {
      type: 'string',
      description: 'Language of the tariff card',
    },
    tariffCard: {
      type: 'string',
      description: 'Tariff card content',
    },
    type: {
      $ref: '#/components/schemas/TariffChartType',
    },
  },
  additionalProperties: false,
  description: 'Tariff card information by language',
} as const;

export const $TariffChartType = {
  enum: ['Normal', 'Addendum', 'Renewal', 'Social'],
  type: 'string',
  description: 'Indicates the type of a tariff chart',
} as const;

export const $TariffDetails = {
  required: ['startDate', 'tariffCardByLanguage'],
  type: 'object',
  properties: {
    tariffCardByLanguage: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/TariffCardByLanguage',
      },
      description:
        'Links to the tariff card by available languages. Languages are described as ISO 639-1 Alpha-2 codes.',
    },
    startDate: {
      type: 'string',
      description: 'Date on which this tariff becomes active.',
      format: 'date-time',
    },
    fixedDurationEndDate: {
      type: 'string',
      description: 'End date if product has fixed end date',
      format: 'date-time',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Describes details in regards to a tariff for a given timeframe. (Usually monthly)',
} as const;

export const $ThankYouCardResponse = {
  type: 'object',
  allOf: [
    {
      $ref: '#/components/schemas/NextBestActionCardResponse',
    },
  ],
  additionalProperties: false,
  description: 'Response for Thank You card',
} as const;

export const $TimeFrameDto = {
  enum: ['Monthly', 'Yearly', 'FifteenMin', 'Hourly', 'Daily'],
  type: 'string',
  description: 'Represents the time frame for data aggregation.',
} as const;

export const $TimeframeTypeCodeDto = {
  enum: ['TH', 'HI', 'LO', 'EX'],
  type: 'string',
  description: 'Type frame type code',
} as const;

export const $UnitOfMeasureDto = {
  enum: [0, 1],
  type: 'integer',
  description: 'Unit of measure of the value',
  format: 'int32',
} as const;

export const $UpdateAccountCompanyDetailsRequest = {
  required: ['companyNumber', 'formatType', 'name', 'vatType'],
  type: 'object',
  properties: {
    name: {
      type: 'string',
      description: 'Name of the company',
    },
    formatType: {
      $ref: '#/components/schemas/CompanyFormatTypeDto',
    },
    vatType: {
      $ref: '#/components/schemas/CompanyVatTypeDto',
    },
    companyNumber: {
      type: 'string',
      description: 'Company number',
    },
  },
  additionalProperties: false,
  description: 'Company data for a crm account',
} as const;

export const $UpdateAccountContactDetailsRequest = {
  required: ['contactAddress', 'email', 'firstName', 'gender', 'language', 'lastName'],
  type: 'object',
  properties: {
    firstName: {
      type: 'string',
      description: 'First name of the account',
    },
    lastName: {
      type: 'string',
      description: 'Last name of the account',
    },
    email: {
      type: 'string',
      description: 'Email of the account',
    },
    dateOfBirth: {
      type: 'string',
      description: 'Birth date of the account',
      format: 'date',
      nullable: true,
    },
    telephoneNumber: {
      type: 'string',
      description: 'Telephone number of the account',
      nullable: true,
    },
    mobileNumber: {
      type: 'string',
      description: 'Mobile number of the account',
      nullable: true,
    },
    gezinsBondNumber: {
      type: 'string',
      description: 'Gezinsbond number of the account',
      nullable: true,
    },
    gender: {
      $ref: '#/components/schemas/GenderDto',
    },
    language: {
      $ref: '#/components/schemas/CustomerLanguageDto',
    },
    contactAddress: {
      $ref: '#/components/schemas/ContactAddressDto',
    },
  },
  additionalProperties: false,
  description: 'Update the accounts contact details',
} as const;

export const $UpdateAccountContactPreferencesRequest = {
  required: ['advancePayments', 'enecoNews', 'invoicePreferences', 'promotions'],
  type: 'object',
  properties: {
    invoicePreferences: {
      $ref: '#/components/schemas/InvoiceContactPreference',
    },
    advancePayments: {
      type: 'boolean',
      description: 'Does the user want Advance invoices',
    },
    enecoNews: {
      type: 'boolean',
      description: 'Does the user want more information about Eneco',
    },
    promotions: {
      type: 'boolean',
      description: 'Doest the user want more info about Promotions or third party partners',
    },
    energyMonitorFrequency: {
      $ref: '#/components/schemas/EnergyMonitorFrequency',
    },
  },
  additionalProperties: false,
  description: 'Representation a CRM accounts contact preferences',
} as const;

export const $UpdateAdvancePaymentRequest = {
  required: ['amount', 'type'],
  type: 'object',
  properties: {
    type: {
      $ref: '#/components/schemas/UpdateAdvancePaymentRequestType',
    },
    amount: {
      type: 'number',
      description:
        'The global amount if Dc.XAPI.Site.Web.Contracts.AdvanceAmount.UpdateAdvancePaymentRequestType.Global or amount for EAN if Dc.XAPI.Site.Web.Contracts.AdvanceAmount.UpdateAdvancePaymentRequestType.Granular',
      format: 'decimal',
    },
    ean: {
      type: 'string',
      description: 'EAN if Dc.XAPI.Site.Web.Contracts.AdvanceAmount.UpdateAdvancePaymentRequestType.Granular',
      nullable: true,
    },
    energyType: {
      $ref: '#/components/schemas/EnergyTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Proposal for new advance request amount',
} as const;

export const $UpdateAdvancePaymentRequestType = {
  enum: ['Global', 'Granular'],
  type: 'string',
  description: 'Determines how the advance payment changes get handled',
} as const;

export const $UpdateBasketRequest = {
  required: ['basket'],
  type: 'object',
  properties: {
    priceSimulationId: {
      type: 'string',
      description: 'The price simulation id',
      format: 'uuid',
      nullable: true,
    },
    basket: {
      $ref: '#/components/schemas/SimpleOrderBasketDto',
    },
  },
  additionalProperties: false,
  description: 'Request to update the basket',
} as const;

export const $UpdateDeliveryAndCorrespondenceAddressRequest = {
  required: ['deliveryAddress'],
  type: 'object',
  properties: {
    deliveryAddress: {
      $ref: '#/components/schemas/AddressDetailsDto',
    },
    correspondenceAddress: {
      $ref: '#/components/schemas/CorrespondenceAddressDto',
    },
  },
  additionalProperties: false,
  description: 'Request to update the delivery address and correspondence address for an order',
} as const;

export const $UpdateElectricityOrderRequest = {
  required: [
    'deliveryStartDateAsap',
    'hasExclusiveNightMeter',
    'meterType',
    'readings',
    'serviceComponent',
    'solarPanels',
    'switchReason',
  ],
  type: 'object',
  properties: {
    switchReason: {
      $ref: '#/components/schemas/OrderSwitchReasonDto',
    },
    ean: {
      type: 'string',
      description: 'The EAN number for the meter',
      nullable: true,
    },
    meterNumber: {
      type: 'string',
      description: 'The meter number of the meter',
      nullable: true,
    },
    hasExclusiveNightMeter: {
      type: 'boolean',
      description: 'Customer has an exclusive night meter',
    },
    exclusiveNightEan: {
      type: 'string',
      description: 'The exclusive night meter EAN if one exists',
      nullable: true,
    },
    exclusiveNightMeterNumber: {
      type: 'string',
      description: 'The exclusive night meter meterNumber if one exists',
      nullable: true,
    },
    deliveryStartDate: {
      type: 'string',
      description: 'The delivery start date',
      format: 'date',
      nullable: true,
    },
    deliveryStartDateAsap: {
      type: 'boolean',
      description: 'Customer wants the delivery to be ASAP',
    },
    readings: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/OrderMeterReadingDto',
      },
      description: 'The list of meter readings',
    },
    solarPanels: {
      $ref: '#/components/schemas/OrderElectricitySolarPanelsDto',
    },
    meterType: {
      $ref: '#/components/schemas/PriceSimulationMeterTypeDto',
    },
    serviceComponent: {
      $ref: '#/components/schemas/ElectricityServiceComponentDto',
    },
  },
  additionalProperties: false,
  description: 'Request to update electricity usage details',
} as const;

export const $UpdateEmailRequest = {
  required: ['sessionToken'],
  type: 'object',
  properties: {
    sessionToken: {
      type: 'string',
      description: 'The session token',
    },
  },
  additionalProperties: false,
  description: 'Request which allows a user to change his password',
} as const;

export const $UpdateGasOrderRequest = {
  type: 'object',
  properties: {
    meterNumber: {
      type: 'string',
      description: 'MeterNumber',
      nullable: true,
    },
    ean: {
      type: 'string',
      description: 'EAN',
      nullable: true,
    },
    meterReading: {
      $ref: '#/components/schemas/OrderMeterReadingDto',
    },
    switchReason: {
      $ref: '#/components/schemas/OrderSwitchReasonDto',
    },
    deliveryStartDate: {
      type: 'string',
      description: 'When to start delivery the gas product',
      format: 'date',
      nullable: true,
    },
    deliveryStartDateAsap: {
      type: 'boolean',
      description: 'Delivery should start asap',
      nullable: true,
    },
    maintenance: {
      $ref: '#/components/schemas/OrderGasMaintenanceDto',
    },
  },
  additionalProperties: false,
  description: 'Request to update gas details',
} as const;

export const $UpdateInvoiceFrequenciesDto = {
  required: ['serviceDeliveryPoints'],
  type: 'object',
  properties: {
    serviceDeliveryPoints: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/UpdateInvoiceFrequencyDto',
      },
      description: 'Service delivery points to configure the invoice frequency for',
    },
  },
  additionalProperties: false,
  description: 'Body containing service delivery points to configure the invoice frequency for',
} as const;

export const $UpdateInvoiceFrequencyDto = {
  required: ['contractNumber', 'invoiceFrequency'],
  type: 'object',
  properties: {
    contractNumber: {
      type: 'string',
      description: 'The contract number to configure the invoice frequency for',
    },
    invoiceFrequency: {
      $ref: '#/components/schemas/InvoiceFrequencyDto',
    },
  },
  additionalProperties: false,
  description: 'A meter with monthly invoice period',
} as const;

export const $UpdateKeyTransferRequest = {
  required: ['keyTransferDateUnknown', 'reportedVacancy'],
  type: 'object',
  properties: {
    keyTransferDate: {
      type: 'string',
      description: 'Date on which the key gets transferred',
      format: 'date',
      nullable: true,
    },
    keyTransferDateUnknown: {
      type: 'boolean',
      description: 'Key transfer date is unknown right now',
    },
    vacancyDate: {
      type: 'string',
      description: 'Date of vacancy',
      format: 'date',
      nullable: true,
    },
    reportedVacancy: {
      type: 'boolean',
      description: 'Whether there is going to be vacancy',
    },
  },
  additionalProperties: false,
  description: 'Body containing details about the key transfer on an address',
} as const;

export const $UpdateLinkFromAccountRequest = {
  required: ['alias', 'linkingType'],
  type: 'object',
  properties: {
    alias: {
      type: 'string',
      description: 'Alias for the linked account',
    },
    linkingType: {
      $ref: '#/components/schemas/AccountLinkingTypeDto',
    },
  },
  additionalProperties: false,
  description: 'Details to update on a linked account',
} as const;

export const $UpdateLocalLogin = {
  required: ['displayName', 'email', 'password'],
  type: 'object',
  properties: {
    displayName: {
      type: 'string',
      description: 'Display name (ME Voornaam) to configure for the user',
    },
    email: {
      type: 'string',
      description: 'Email that the user can login with locally',
    },
    password: {
      type: 'string',
      description:
        'Password that the user can login with locally. If the password is empty ("") or not present, the password will not be updated.',
    },
  },
  additionalProperties: false,
  description: 'Updates the local login details for a user',
} as const;

export const $UpdateMonthlyInvoicePeriodDtoMeter = {
  required: ['billingAccountNumber', 'period'],
  type: 'object',
  properties: {
    billingAccountNumber: {
      type: 'string',
      description: 'Number that signifies the billing account',
    },
    period: {
      $ref: '#/components/schemas/MonthlyInvoicePeriodDto',
    },
  },
  additionalProperties: false,
  description: 'A meter with monthly invoice period',
} as const;

export const $UpdateMonthlyInvoicePreferenceDto = {
  required: ['meters'],
  type: 'object',
  properties: {
    meters: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/UpdateMonthlyInvoicePeriodDtoMeter',
      },
      description: 'Meters to configure the preferences for',
    },
  },
  additionalProperties: false,
  description: 'Body containing Meters to configure the preferences for',
} as const;

export const $UpdateMoveReasonRequest = {
  required: ['reasonDto'],
  type: 'object',
  properties: {
    reasonDto: {
      $ref: '#/components/schemas/MoveReasonDto',
    },
  },
  additionalProperties: false,
  description: 'Body containing details on how the user wants to move',
} as const;

export const $UpdateMultipleAdvancePaymentRequests = {
  required: ['isBbpUpdated', 'requests'],
  type: 'object',
  properties: {
    isBbpUpdated: {
      type: 'boolean',
      description: 'Is the bbp amount changed',
    },
    requests: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/UpdateAdvancePaymentRequest',
      },
      description: 'Requests of the advances that will be updated',
    },
  },
  additionalProperties: false,
  description: 'Update multiple advance amounts',
} as const;

export const $UpdateNewAddressRequest = {
  required: ['address'],
  type: 'object',
  properties: {
    address: {
      $ref: '#/components/schemas/MoveAddressDto',
    },
  },
  additionalProperties: false,
  description: 'Body containing new address details for a move',
} as const;

export const $UpdatePaymentMethodByBillingAccountResponse = {
  required: ['billingAccountNumber', 'newPaymentMethod'],
  type: 'object',
  properties: {
    billingAccountNumber: {
      type: 'string',
      description: 'Billing account number',
    },
    newPaymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
    iban: {
      type: 'string',
      description: 'IBAN details',
      nullable: true,
    },
    directDebitConsentGiven: {
      type: 'boolean',
      description: 'Consent for direct debit given',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Contains updated payment method information per billing account',
} as const;

export const $UpdatePaymentMethodRequest = {
  required: ['items'],
  type: 'object',
  properties: {
    items: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/UpdatePaymentMethodByBillingAccountResponse',
      },
      description: 'Payment methods per billing account',
    },
  },
  additionalProperties: false,
  description: 'Contains updated payment method information',
} as const;

export const $UpdatePaymentOrderRequest = {
  required: ['acceptedMandate', 'iban', 'paymentMethod'],
  type: 'object',
  properties: {
    paymentMethod: {
      $ref: '#/components/schemas/PaymentMethodDto',
    },
    iban: {
      type: 'string',
      description: 'The International Bank Account Number (IBAN)',
    },
    acceptedMandate: {
      type: 'boolean',
      description: 'Whether user accepted the mandate',
    },
  },
  additionalProperties: false,
  description: 'Request object for updating payment details of an order',
} as const;

export const $UpdatePersonalAndCompanyDetailsRequest = {
  required: ['isSoho', 'personalDetails'],
  type: 'object',
  properties: {
    isSoho: {
      type: 'boolean',
      description: 'If person is a business customer or not (true if is a business customer)',
    },
    personalDetails: {
      $ref: '#/components/schemas/OrderPersonalDetailsDto',
    },
    companyDetails: {
      $ref: '#/components/schemas/OrderCompanyDetailsDto',
    },
  },
  additionalProperties: false,
  description: 'Request model for updating PersonalDetails or CompanyDetails',
} as const;

export const $UpdateProfileResponse = {
  required: ['result'],
  type: 'object',
  properties: {
    result: {
      $ref: '#/components/schemas/UpdateProfileResultDto',
    },
  },
  additionalProperties: false,
  description: 'Result of updating a local profile.',
} as const;

export const $UpdateProfileResultDto = {
  enum: ['Updated', 'ConfirmationEmailSent'],
  type: 'string',
  description: `Indicates which update flow was applied when updating a local profile, so the frontend can decide
whether it needs to show a confirmation notification to the user.`,
} as const;

export const $UpdateSubscriptionStatusRequest = {
  required: ['status'],
  type: 'object',
  properties: {
    status: {
      $ref: '#/components/schemas/SubscriptionStatusDto',
    },
  },
  additionalProperties: false,
  description: 'Update subscription status request',
} as const;

export const $UpdateVacancyRequest = {
  required: ['vacancyUntil'],
  type: 'object',
  properties: {
    vacancyUntil: {
      type: 'string',
      description: 'Date until vacancy has been requested. Should be the last day of one of the four next months',
      format: 'date',
    },
  },
  additionalProperties: false,
  description: 'Update the vacancy of multiple EANs',
} as const;

export const $UtilityType = {
  enum: ['Electricity', 'Gas'],
  type: 'string',
  description: 'The utility type enum',
} as const;

export const $UtilityTypeDto = {
  enum: [0, 1],
  type: 'integer',
  format: 'int32',
} as const;

export const $ValidateOrderResponse = {
  type: 'object',
  properties: {
    checkoutExpiresAt: {
      type: 'string',
      description: 'The checkoutExpiresAt property',
      format: 'date-time',
      nullable: true,
    },
    checkoutUrl: {
      type: 'string',
      description: 'The checkoutUrl property',
      nullable: true,
    },
    currencyCode: {
      type: 'string',
      description: "The 3-character currency code to be used for the order. Currently Eneco only support value 'EUR'",
      nullable: true,
    },
    customer: {
      $ref: '#/components/schemas/OrderCustomer',
    },
    errorDetails: {
      $ref: '#/components/schemas/EnecoErrorDetails',
    },
    initialInvoiceAmount: {
      type: 'number',
      description: 'The initialInvoiceAmount property',
      format: 'double',
      nullable: true,
    },
    isOneTime: {
      type: 'boolean',
      description: 'The isOneTime property',
      nullable: true,
    },
    orderReference: {
      type: 'string',
      description: 'The orderReference property',
      nullable: true,
    },
    products: {
      type: 'array',
      items: {
        $ref: '#/components/schemas/EnecoProduct',
      },
      description: 'The products property',
      nullable: true,
    },
    shippingAddress: {
      $ref: '#/components/schemas/Address',
    },
    success: {
      type: 'boolean',
      description: 'The success property',
      nullable: true,
    },
  },
  additionalProperties: false,
  description: 'Validate order response',
} as const;

export const $ValidatePromoRequest = {
  required: ['offerNumber'],
  type: 'object',
  properties: {
    offerNumber: {
      type: 'string',
      description: 'Offer number from the promo',
    },
  },
  additionalProperties: false,
  description: 'Request containing the order finalization data',
} as const;

export const $ValidatePromoResponse = {
  required: ['promo'],
  type: 'object',
  properties: {
    promo: {
      $ref: '#/components/schemas/PromoDto',
    },
  },
  additionalProperties: false,
  description: 'Returns the promo',
} as const;

export const $ValidationProblemDetails = {
  required: ['errors'],
  type: 'object',
  properties: {
    type: {
      type: 'string',
      nullable: true,
    },
    title: {
      type: 'string',
      nullable: true,
    },
    status: {
      type: 'integer',
      format: 'int32',
      nullable: true,
    },
    detail: {
      type: 'string',
      nullable: true,
    },
    instance: {
      type: 'string',
      nullable: true,
    },
    errors: {
      type: 'object',
      additionalProperties: {
        type: 'array',
        items: {
          type: 'string',
        },
      },
    },
  },
  additionalProperties: {},
} as const;

export const $VehicleAssetResourceDto = {
  required: ['alias', 'brand', 'chargingLocation', 'model'],
  type: 'object',
  properties: {
    brand: {
      minLength: 1,
      type: 'string',
      description: 'Brand of the vehicle',
    },
    model: {
      type: 'string',
      description: 'Model of the vehicle',
      nullable: true,
    },
    year: {
      type: 'integer',
      description: 'Year of the vehicle',
      format: 'int32',
      nullable: true,
    },
    alias: {
      type: 'string',
      description: 'Vehicle alias',
      nullable: true,
    },
    chargingLocation: {
      $ref: '#/components/schemas/LocationDto',
    },
  },
  additionalProperties: false,
  description: 'Vehicle asset',
} as const;
